/* eslint-disable prettier/prettier */
module.exports = {
  app: "App",
  news: "新闻",
  component: "组件",
  download: "下载",
  downloading: "下载中",
  unableToDownload: "无法下载",
  features: "功能",
  applications: "应用程序",
  dashboard: "仪表板",
  customers: "客户",
  warehouses: "仓库",
  management: "管理",
  carriers: "承运商",
  operations: "运营",
  warehousing: "仓储",
  quote: "报价",
  business: "业务",
  invoices: "发票",
  prepayments: "预付款",
  billsToPay: "应付账单",
  modules: "模块",
  agency: "代理",
  pages: "页面",
  gallery: "图库",
  pricing: "定价",
  privacyPolicy: "隐私政策",
  feedback: "反馈",
  report: "报告",
  faqS: "常见问题",
  advanceComponent: "高级组件",
  blank: "空白",
  session: "会话",
  login: "登录",
  reset: "重置",
  register: "注册",
  lockScreen: "锁定屏幕",
  forgotPassword: "忘记密码",
  forgotYourPassword: "忘记密码了？",
  letsGetYouBackIn: "让我们帮您重新登录",
  recoverPassword: "恢复密码",
  dontWorryJustEnterYourEmailAddressBelowAndWellAssistYou:
    "别担心！只需在下方输入您的电子邮件地址，我们会为您提供帮助。",
  withInstructionsToResetYourPassword: "并附带重置密码的说明",
  checkYourEmail: "请检查您的电子邮件",
  emailNotReceived: "未收到电子邮件？",
  resend: "重新发送",
  uiComponents: "UI 组件",
  alerts: "警告",
  appBar: "应用栏",
  avatars: "头像",
  buttons: "按钮",
  bottomNavigations: "底部导航",
  badges: "徽章",
  cards: "卡片",
  cardsMasonry: "瀑布流卡片",
  chip: "标签",
  dialog: "对话框",
  dividers: "分割线",
  drawers: "抽屉",
  draft: "草稿",
  totalQuotes: "报价总数",
  inspect: "检查",
  expansionPanel: "展开面板",
  gridList: "网格列表",
  list: "列表",
  menu: "菜单",
  popOverTooltip: "弹出框和工具提示",
  progress: "进度",
  snackbar: "消息条",
  selectionControls: "选择控件",
  dateTimePicker: "日期和时间选择器",
  tabs: "标签页",
  stepper: "步骤条",
  notification: "通知",
  notifications: "通知",
  sweetAlert: "Sweet Alert",
  autoComplete: "自动完成",
  aboutUs: "关于我们",
  widgets: "小部件",
  forms: "表单",
  formElements: "表单元素",
  textField: "文本字段",
  selectList: "选择列表",
  charts: "图表",
  reCharts: "Re Charts",
  reactChartjs2: "React Chartjs 2",
  icons: "图标",
  themifyIcons: "Themify Icons",
  simpleLineIcons: "Simple Line Icons",
  materialIcons: "Material Icons",
  tables: "表格",
  basic: "基础",
  dataTable: "数据表格",
  responsive: "响应式",
  maps: "地图",
  googleMaps: "Google Maps",
  leafletMaps: "Leaflet Maps",
  inbox: "收件箱",
  users: "用户",
  userProfile1: "用户资料 1",
  userProfile2: "用户资料 2",
  userManagement: "用户管理",
  userList: "用户列表",
  calendar: "日历",
  cultures: "文化",
  selectable: "可选择",
  customRendering: "自定义渲染",
  chat: "聊天",
  todo: "待办事项",
  editor: "编辑器",
  wysiwygEditor: "WYSIWYG 编辑器",
  quillEditor: "Quill 编辑器",
  dragAndDrop: "拖放",
  reactDragula: "React Dragula",
  reactDnd: "React Dnd",
  ecommerce: "电子商务",
  shopList: "商店列表",
  shopGrid: "商店网格",
  invoice: "发票",
  crm: "CRM",
  ratings: "评分",
  number: "数字",
  welcomeBack: "欢迎回来！",
  pleaseCreateANewPasswordForYourAccount: "请为您的账户创建新密码",
  emailOrUsername: "电子邮件或用户名",
  rememberMe: "记住我",
  notRegisteredYet: "还没有注册？",
  clickToResend: "点击重新发送",
  clickHere: "点击这里。",
  youWillBeRedirectedToTheSignInPageIfYouAreNotRedirectedAutomatically:
    "您将被重定向到登录页面。如果没有自动重定向，",
  createAnAccount: "创建账户",
  web: "Web",
  done: "完成",
  inProgress: "进行中",
  waiting: "等待中",
  subscribed: "已订阅",
  searchItem: "搜索物品",
  startDate: "开始日期",
  endDate: "结束日期",
  password: "密码",
  newPassword: "新密码",
  createNewPassword: "创建新密码",
  filters: "筛选",
  private: "私有",
  corporate: "企业",
  name: "姓名",
  volume: "体积",
  sidebarOverlay: "侧边栏覆盖",
  appSettings: "应用设置",
  sidebarImage: "侧边栏图片",
  miniSidebar: "迷你侧边栏",
  boxLayout: "盒式布局",
  rtlLayout: "从右到左布局",
  darkMode: "深色模式",
  light: "浅色",
  dark: "深色",
  refresh: "刷新",
  refreshing: "刷新中",
  record: "记录",
  play: "播放",
  start: "开始",
  cancel: "取消",
  copy: "复制",
  send: "发送",
  add: "添加",
  update: "更新",
  confirm: "确认",
  delete: "删除",
  yes: "是",
  no: "否",
  addNewContact: "添加新联系人",
  editAContact: "编辑联系人",
  addNewLocation: "添加新位置",
  editALocation: "编辑位置",
  summary: "摘要",
  week: "周",
  weekday: "工作日",
  month: "月",
  firstName: "名",
  lastName: "姓",
  address: "地址",
  description: "描述",
  total: "总计",
  selectRoom: "选择房间",
  selectDescription: "选择描述",
  addNew: "新增",
  revoke: "撤销",
  assign: "分配",
  save: "保存",
  saveComment: "保存评论",
  create: "创建",
  savePublishTask: "保存并发布任务",
  accept: "接受",
  accepted: "已接受",
  complete: "完成",
  back: "返回",
  ok: "确定",
  next: "下一步",
  saveChanges: "保存更改",
  cancelChanges: "取消更改",
  more: "更多",
  remove: "移除",
  changePhoto: "更换照片",
  booking: "预订",
  enterBooking: "输入预订",
  user: "用户",
  promo: "促销",
  themeColor: "主题颜色",
  selectProject: "选择项目",
  shop: "商店",
  cart: "购物车",
  checkout: "结账",
  product: "产品",
  removeProduct: "移除产品",
  noItemFound: "未找到物品",
  saas: "SAAS",
  multilevel: "多级",
  level1: "级别 1",
  level2: "级别 2",
  imageCropper: "图片裁剪",
  videoPlayer: "视频播放器",
  dropzone: "拖放区域",
  cropImage: "裁剪图片",
  preview: "预览",
  projects: "项目",
  projectDetail: "项目详情",
  clients: "客户",
  shipments: "运输件",
  editShipment: "编辑货运",
  viewShipment: "查看货运",
  newShipment: "新建货运",
  loadBy: "装载方式",
  createShipment: "创建货运",
  products: "产品",
  latestScan: "最新扫描",
  dateOfLoading: "装载日期",
  editProduct: "编辑产品",
  newProduct: "新建产品",
  noProductsToShow: "暂无产品可显示",
  theProductWasRemovedSuccesfully: "产品已成功移除",
  containers: "集装箱",
  settings: "设置",
  cartonQuantity: "纸箱数量",
  palletQuantity: "托盘数量",
  despatches: "发货",
  edit: "编辑",
  details: "详情",
  detail: "详情",
  locations: "位置",
  comments: "评论",
  estimatedDates: "预计日期",
  destinationWh: "目的仓库",
  vessel: "船舶",
  vesselName: "船舶名称",
  travel: "运输",
  container: "集装箱",
  containerType: "集装箱类型",
  selectContainerType: "选择集装箱类型",
  shipmentType: "货运类型",
  containerNumbers: "集装箱编号",
  grossWeight: "毛重",
  inputWeight: "输入重量",
  project: "项目",
  totalQuantity: "总数量",
  totalPallets: "托盘总数",
  eta: "ETA",
  etaFinalPort: "ETA 最终港口",
  etaWarehouse: "ETA 仓库",
  pickUpDate: "提货日期",
  scanDate: "扫描日期",
  departureDate: "出发日期",
  arrivalAtDestination: "交付日期",
  hawb: "HAWB",
  flightNumber: "航班号",
  airline: "航空公司",
  etaUnpackData: "ETA 拆箱数据",
  actualDates: "实际日期",
  agent: "代理人",
  agentId: "代理人 ID",
  agentParentCode: "代理人上级 ID",
  email: "电子邮件",
  businessAddress: "公司地址",
  businessContacts: "商务联系人",
  businessName: "公司名称",
  businessNumber: "公司编号",
  businessRegistration: "工商注册",
  businessRegistrationNumber: "工商注册号",
  mainEmailAddress: "主要电子邮件地址",
  website: "网站",
  bodyType: "车身类型",
  fuelType: "燃料类型",
  condition: "状况",
  engine: "发动机",
  ownership: "所有权",
  branch: "分支机构",
  fleetStatus: "车队状态",
  dryStandard: "标准干货箱",
  dryHigh: "高干货箱",
  tank: "罐式箱",
  open: "打开",
  openTop: "开顶箱",
  openTopHigh: "高开顶箱",
  flat: "平板箱",
  flatStandard: "标准平板箱",
  flatHigh: "高平板箱",
  reeferStandard: "标准冷藏箱",
  reeferHigh: "高冷藏箱",
  po: "采购订单号",
  sku: "SKU",
  itemRemovedSuccessfully: "物品已成功移除！",
  import: "导入",
  export: "导出",
  importCsvFile: "导入 CSV 文件",
  printDeliveryDocket: "打印送货单",
  despatch: "发货",
  qtyOfCartonsDespatched: "已发货纸箱数量",
  qtyOfPalletsDespatched: "已发货托盘数量",
  ofDespatches: "发货次数",
  ofOrdersDespatched: "已发货订单数",
  stockOnHand: "库存现有量",
  stockOnHandDetailed: "库存现有量 - 详细",
  crossDockStatus: "越库状态",
  packing: "包装",
  addMaterial: "添加材料",
  fillAllFieldsToSave: "请填写所有字段以保存",
  addItem: "添加物品",
  instructionStatus: "指令状态",
  selectWhen: "选择时间",
  addInstruction: "添加指令",
  availableInstructions: "可用指令",
  remark: "备注",
  inputYourRemarkAndPressEnter: "输入备注并按回车",
  uplift: "提升",
  coordinator: "协调员",
  selectedInstructions: "已选指令",
  selectAStatus: "选择状态",
  applyChooseLocations: "应用并选择位置",
  filterConditions: "筛选条件",
  filterLocations: "筛选位置",
  conditions: "条件",
  typeOfPacking: "包装类型",
  itemStatus: "物品状态",
  itemNumber: "物品编号",
  width: "宽度",
  length: "长度",
  leader: "负责人",
  searchLeader: "搜索负责人",
  staffs: "员工",
  searchForStaff: "搜索员工",
  fleets: "车队",
  searchForFleet: "搜索车队",
  height: "高度",
  cartonPerPallet: "每托盘纸箱数",
  palletHeight: "托盘高度",
  heightWithPallet: "含托盘高度",
  heightIncPallet: "含托盘高度",
  ti: "Ti",
  hi: "您好",
  selectProductsBelowToAddThem: "选择下方产品以添加",
  productSkuSearch: "产品 (SKU) 搜索",
  productName: "产品名称",
  shippingItem: "运输物品",
  truckTransport: "卡车/运输",
  customerName: "客户名称",
  addNewProject: "添加新项目",
  projectName: "项目名称",
  projectCustomer: "项目客户",
  importFiles: "导入文件",
  fileHistory: "文件历史",
  projectCreatedWithSuccess: "项目创建成功！",
  uploadNewFile: "上传新文件",
  imapHost: "IMAP主机",
  imapPort: "IMAP端口",
  emailUser: "邮箱用户",
  emailPassword: "邮箱密码",
  useTls: "使用 TLS",
  addNewComment: "添加新评论",
  typeYourCommentHere: "在此输入评论",
  order: "订单",
  origin: "始发地",
  destination: "目的地",
  type: "类型",
  dateCreated: "创建日期",
  dateUpdated: "更新日期",
  buyerName: "买方名称",
  shipVia: "运输方式",
  shipTo: "收货地址",
  incoterm: "Incoterm",
  createNewSupplier: "创建新供应商",
  fulfilled: "已履行",
  quantityOrdered: "订购数量",
  quantityRequested: "请求数量",
  quantityFullfilled: "已履行数量",
  variation: "差异",
  switchToActualInventory: "切换到实际库存",
  switchToQuotedInventory: "切换到报价库存",
  switchToEstimatedInventory: "切换到估算库存",
  searchByNameOrEmail: "按名称或电子邮件搜索",
  supplierDetails: "供应商详情",
  supplier: "供应商",
  supplierName: "供应商名称",
  supplierCode: "供应商代码",
  address1: "地址 1",
  address2: "地址 2",
  suburbTown: "区/镇",
  streetNumber: "街道号码",
  postalCode: "邮政编码",
  state: "州/省",
  country: "国家",
  contactName: "联系人姓名",
  locationStatus: "位置状态",
  filterByShipment: "按货运编号筛选",
  noInformationToBeShown: "暂无可显示的信息。",
  loadingShipments: "加载货运中",
  loadingDispatches: "加载发货中",
  loadingSuppliers: "加载供应商中...",
  loadingNotifications: "加载通知中",
  task: "任务",
  usedBy: "使用者",
  fleetNumber: "车队编号",
  make: "品牌",
  model: "型号",
  body: "车身",
  position: "职位",
  username: "用户名",
  location: "位置",
  mainContact: "主要联系人",
  role: "角色",
  rooms: "房间",
  fullName: "全名",
  symbol: "符号",
  decimalPoints: "小数位",
  lastUpdate: "最后更新",
  lastModified: "最后修改",
  flatFee: "固定费用",
  hourlyFee: "小时费用",
  halfHourFee: "半小时费用",
  triggers: "触发器",
  tasksType: "任务类型",
  jobsType: "作业类型",
  branches: "分支机构",
  updated: "已更新",
  color: "颜色",
  icon: "图标",
  packaging: "包装",
  configuration: "配置",
  currency: "货币",
  currencies: "货币",
  measurements: "度量",
  addCustomCurrency: "添加自定义货币",
  displayUnit: "显示单位",
  languages: "语言",
  prefix: "前缀",
  language: "语言",
  room: "房间",
  types: "类型",
  descriptiveSymbol: "描述符号",
  descriptiveSymbols: "描述符号",
  exceptionSymbol: "异常符号",
  exceptionSymbols: "异常符号",
  locationSymbol: "位置符号",
  locationSymbols: "位置符号",
  photoIsMandatory: "照片为必填项",
  selectTheRoom: "选择房间",
  editRoom: "编辑房间",
  addNewType: "添加新类型",
  editType: "编辑类型",
  addNewDescriptiveSymbol: "添加新描述符号",
  selectSymbol: "选择符号",
  editDescriptiveSymbol: "编辑描述符号",
  addNewExceptionSymbol: "添加新异常符号",
  editExceptionSymbol: "编辑异常符号",
  addNewLocationSymbol: "添加新位置符号",
  editLocationSymbol: "编辑位置符号",
  addNewOne: "添加新项",
  createFleet: "创建车队",
  editFleet: "编辑车队",
  viewFleet: "查看车队",
  editThisFleet: "编辑此车队",
  addANewFleet: "添加新车队",
  viewThisFleet: "查看此车队",
  vinNumber: "车架号",
  year: "年份",
  engineType: "发动机类型",
  plateNumber: "车牌号",
  addCondition: "添加条件",
  typeMode: "类型模式",
  warehouse: "仓库",
  searchForWarehouse: "搜索仓库",
  searchForBranch: "搜索分支机构",
  capacity: "容量",
  capacityOfEachLiftvan: "每个搬运箱的容量",
  volumeCapacityM3: "体积容量 (m³)",
  weightCapacityKG: "承重容量 (Kg)",
  outOfService: "停止服务",
  serialNumber: "序列号",
  inputSerialNumber: "输入序列号",
  mechanicalElectricalChecklist: "机电检查清单",
  hasTheMEChecklistBeenDoneOnThisItem: "此物品是否已完成机电检查清单？",
  isItWorking: "是否正常工作？",
  userDetails: "用户详情",
  permissions: "权限",
  placeName: "地点名称",
  local: "本地",
  companyId: "公司 ID",
  suppliers: "供应商",
  newSupplier: "新建供应商",
  viewSupplier: "查看供应商",
  editSupplier: "编辑供应商",
  printSupplier: "打印供应商",
  editPlace: "编辑地点",
  newPlace: "新建地点",
  newUser: "新建用户",
  createdAt: "创建于",
  voyage: "航次",
  voyageNumber: "航次编号",
  voyageStatus: "航次状态",
  voyageInformation: "航次信息",
  containerNumber: "集装箱编号",
  inputContainer: "输入集装箱",
  inputShipment: "输入货运",
  internalReference: "内部参考号",
  exportShipment: "导出货运",
  eventProductUpdate: "产品更新事件",
  importProductsEvents: "导入产品事件",
  view: "查看",
  close: "关闭",
  closed: "已关闭",
  closedForInvoicing: "已关闭待开票",
  closedForReceiving: "已关闭待收货",
  createNetwork: "创建网络",
  createCustomer: "创建客户",
  createAgent: "创建代理人",
  createSupplier: "创建供应商",
  linkAccounts: "关联账户",
  understood: "已了解",
  productEvents: "产品事件",
  birthDate: "出生日期",
  emergencyName: "紧急联系人姓名",
  emergencyPhone: "紧急联系电话",
  emergencyRelationship: "紧急联系人关系",
  gender: "性别",
  skills: "技能",
  residencyStatus: "居住状态",
  certificates: "证书",
  addressLine1: "地址行 1",
  addressLine2: "地址行 2",
  suburb: "区/镇",
  staffStatus: "员工状态",
  staffMnt: "员工 - MNT",
  editStaff: "编辑员工",
  newStaff: "新建员工",
  saveAsUser: "保存为用户",
  yourPasswordMustBeAtLeast12CharactersLong: "密码长度必须至少为 12 个字符",
  yourPasswordMustContainAtLeastOneSpecialCharacter:
    "密码必须包含至少一个特殊字符",
  pleaseEnterYourPassword: "请输入您的密码",
  yourPasswordMustBeAtMaximumOf30CharactersLong:
    "密码长度不能超过 30 个字符",
  pleaseEnterAValidPhoneNumber: "请输入有效的电话号码",
  phoneNumber: "电话号码",
  pleaseEnterALastName: "请输入姓氏",
  yourLastNameMustBeAtLeast4CharactersLong: "姓氏长度必须至少为 4 个字符",
  pleaseEnterAFirstName: "请输入名字",
  yourFirstNameMustBeAtLeast4CharactersLong: "名字长度必须至少为 4 个字符",
  pleaseEnterAName: "请输入名称",
  yourNameMustBeAtLeast4CharactersLong: "名称长度必须至少为 4 个字符",
  yourRegistrationNumberMustBeAtLeast4CharactersLong:
    "注册号长度必须至少为 4 个字符",
  pleaseEnterAPhoneNumber: "请输入电话号码",
  yourPhoneMustBeAtLeast6CharactersLong: "电话号码长度必须至少为 6 个字符",
  yourWebMustBeAtLeast4CharactersLong: "网址长度必须至少为 4 个字符",
  pleaseEnterAAddressLine: "请输入地址行",
  yourAddressLineMustBeAtLeast4CharactersLong:
    "地址行长度必须至少为 4 个字符",
  pleaseEnterASuburb: "请输入区/镇",
  yourSuburbMustBeAtLeast4CharactersLong: "区/镇长度必须至少为 4 个字符",
  pleaseEnterAStateNumber: "请输入州/省编号",
  yourStateMustBeAtLeast3CharactersLong: "州/省长度必须至少为 3 个字符",
  pleaseEnterAPostalCodeNumber: "请输入邮政编码",
  yourPostalCodeMustBeAtLeast4CharactersLong: "邮政编码长度必须至少为 4 个字符",
  pleaseEnterACountry: "请输入国家",
  yourCountryMustBeAtLeast4CharactersLong: "国家长度必须至少为 4 个字符",
  newItemSType: "新物品类型",
  editItemSType: "编辑物品类型",
  newItemSDescription: "新物品描述",
  editItemSDescription: "编辑物品描述",
  network: "网络",
  anErrorOccurredTryAgain: "发生错误，请重试",
  operationPerformedSuccessfully: "操作成功",
  resendWelcomeEmail: "重新发送欢迎邮件",
  resendWelcomeEmailConfirmation: "向 [name] 发送欢迎邮件？",
  welcomeEmailSentSuccessfully: "欢迎邮件发送成功",
  labelCreated: "标签已创建",
  sunday: "星期日",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",
  january: "一月",
  february: "二月",
  march: "三月",
  april: "四月",
  may: "五月",
  june: "六月",
  july: "七月",
  august: "八月",
  september: "九月",
  october: "十月",
  november: "十一月",
  december: "十二月",
  customerSTimeZone: "客户时区",
  startTime: "开始时间",
  endTime: "结束时间",
  whatsapp: "Whatsapp",
  sms: "SMS",
  originAddress: "始发地地址",
  destinationAddress: "目的地地址",
  active: "活跃",
  Active: "活跃",
  disabled: "已禁用",
  sendToAmos: "发送至 AMOS",
  printReports: "打印报告",
  cancelOrder: "取消订单",
  cancelQuote: "取消报价",
  inactive: "非活跃",
  Inactive: "非活跃",
  invertStatuses: "反转状态",
  filterByStatus: "按状态筛选",
  activeInactive: "活跃 / 非活跃",
  selectType: "选择类型",
  selectStatus: "选择状态",
  userCode: "用户代码",
  enterUserCode: "输入用户代码",
  emailAddress: "电子邮件地址",
  mobileNumber: "手机号码",
  contactType: "联系人类型",
  enterHere: "在此输入",
  dateOfBirth: "出生日期",
  typeOfUser: "用户类型",
  thisUserIsALeader: "此用户是负责人",
  checkThisBoxIfTheUserAboveIsAlsoALeader: "如果上述用户也是负责人，请勾选此框",
  useEmailAddress: "使用电子邮件地址",
  citySuburb: "城市 / 区",
  postcode: "邮编",
  countryOrRegion: "国家或地区",
  timezone: "时区",
  enterFirstName: "输入名字",
  enterLastName: "输入姓氏",
  dateNumberFormat: "日期 / 数字格式",
  defaultCurrency: "默认货币",
  userInactive: "用户非活跃",
  roles: "角色",
  communications: "通讯",
  communicationSubscriptions: "通讯订阅",
  searchByEnter: "按回车搜索",
  approve: "批准",
  decline: "拒绝",
  activeNetwork: "活跃网络",
  invites: "邀请",
  reject: "拒绝",
  approved: "已批准",
  waitingForApproval: "等待审批",
  sendToReview: "发送审核",
  automaticallyInvitationSentBy: "自动邀请发送人",
  importerExporter: "进口商和出口商",
  newRole: "新建角色",
  editRole: "编辑角色",
  continue: "继续",
  saveWithoutAssigning: "保存但不分配",
  saveAndAssign: "保存并分配",
  createRole: "创建角色",
  createRoom: "创建房间",
  updateRole: "更新角色",
  assignUser: "分配用户",
  productSIsRequired: "产品为必填项！",
  roleName: "角色名称",
  roleDescriptionOptional: "角色描述（可选）",
  quoteAssignedTo: "报价分配给",
  manager: "经理",
  searchForManager: "搜索经理",
  youMustEnterAnEntityName: "*您必须输入实体名称",
  youMustEnterAnAddress: "*您必须输入地址",
  youMustEnterASuburbTown: "*您必须输入区/镇",
  youMustEnterAState: "*您必须输入州/省",
  youMustEnterACountry: "*您必须输入国家",
  youMustEnterAPostalcode: "*您必须输入邮政编码",
  youMustEnterARegistrationNumber: "*您必须输入注册号",
  youMustEnterABillingEmail: "*您必须输入账单电子邮件",
  youMustEnterAMobile: "*您必须输入手机号码",
  youMustEnterATimezone: "*您必须输入时区",
  youMustEnterAConsultant: "*您必须输入顾问",
  youMustEnterAContactPerson: "*您必须输入联系人",
  youMustEnterAFirstName: "*您必须输入名字",
  youMustEnterALastName: "*您必须输入姓氏",
  youMustEnterAnEmail: "*您必须输入电子邮件",
  youMustEnterAName: "*您必须输入名称",
  youMustEnterAPhoneNumber: "*您必须输入电话号码",
  youMustEnterAParentCode: "*您必须输入上级 ID 编号",
  youMustEnterALocationName: "*您必须输入位置名称",
  youMustEnterAStatus: "*您必须输入状态",
  youMustEnterAnEstablishedYear: "*您必须输入成立年份",
  youMustEnterASince: "*您必须输入起始时间",
  youMustEnterAnEntityLegalName: "*您必须输入实体法定名称",
  youMustEnterAWebsite: "*您必须输入网站",
  youMustEnterAContactName: "*您必须输入联系人姓名",
  youMustEnterAContactType: "*您必须输入联系人类型",
  startTypingToSearchDots: "输入以搜索...",
  established: "成立",
  establishedYear: "成立年份",
  since: "起始时间",
  entity: "实体",
  entityLegalName: "实体法定名称",
  mobile: "手机",
  customerDetails: "客户详情",
  editCustomer: "编辑客户",
  useTheSameAddressForPostalAddress: "邮寄地址使用相同地址？",
  registrationNumber: "注册号",
  addAnotherContact: "添加另一个联系人",
  includeInEmail: "包含在电子邮件中",
  consultant: "顾问",
  searchConsultant: "搜索顾问",
  searchWarehouse: "搜索仓库",
  searchTimezone: "搜索时区",
  billingEmail: "账单电子邮件",
  postalAddress: "邮寄地址",
  contact: "联系人",
  contactPerson: "联系人",
  invalidLink: "无效链接",
  closeWindow: "关闭窗口",
  youHaventAcceptedTheInvitation: "您尚未接受邀请",
  thisLinkIsNotValidPleaseCheckIfYouHaveAccessedTheCorrectLink:
    "此链接无效。请检查您是否访问了正确的链接。",
  youCanSafelyCloseThisWindowNowIfYouNeedAnyFurtherAssistanceFeelFreeToReachOutHaveAGreatDay:
    "您现在可以安全关闭此窗口。如需进一步帮助，请随时联系我们。祝您愉快！",
  enterLocationName: "输入位置名称",
  enterWebsite: "输入网站",
  enterRegistrationNumber: "输入注册号",
  primaryContact: "主要联系人",
  createLocation: "创建位置",
  viewLocation: "查看位置",
  editLocation: "编辑位置",
  jobType: "作业类型",
  warehouseOrigin: "始发仓库",
  warehouseDestination: "目的仓库",
  tag: "标签",
  billingAs: "账单方式：",
  leadSourceFrom: "潜在客户来源",
  moveCoordinator: "搬运协调员",
  inventoryQuoted: "报价库存",
  inventoryLeader: "库存负责人",
  inventoryActual: "实际库存",
  myDetails: "我的详情",
  orderDetails: "订单详情",
  actualAsQuoted: "实际与报价一致",
  movingFrom: "搬出地",
  movingTo: "搬入地",
  itemQuantity: "物品数量",
  inventories: "库存",
  originContact: "始发地联系人",
  destinationContact: "目的地联系人",
  seeAccessChecklist: "查看准入检查清单",
  pickupAccessDetails: "提货准入详情",
  deliveryAccessDetails: "送货准入详情",
  noContactsAdded: "未添加联系人",
  complement: "补充信息",
  street: "街道",
  typeOfBuilding: "建筑类型",
  loadingDockHeight: "装卸码头高度",
  liftAvailable: "有电梯可用",
  accessInstructions: "准入说明",
  navigationNotes: "导航备注",
  createYourShipeeziAccount: "创建您的 Shipeezi 账户",
  createAccount: "创建您的账户",
  haveAnAccountSignIn: "已有账户？登录",
  mode: "模式",
  service: "服务",
  editOrder: "编辑订单",
  newOrder: "新建订单",
  weight: "重量",
  truckType: "卡车类型",
  carrier: "承运商",
  truckBookingNumber: "卡车预订编号",
  trackingNumber: "追踪号",
  palletsPerTruck: "每车托盘数",
  deliveryDate: "交付日期",
  proposedDeliveryDate: "建议交付日期",
  bookingDetails: "预订详情",
  deliveryAddress: "送货地址",
  deliveryAddressLine: "送货地址行",
  deliveryAddressSuburb: "送货地址区/镇",
  receiver: "收货人",
  senderAddress: "发货人地址",
  senderAddressLine: "发货人地址行",
  senderAddressSuburb: "发货人地址区/镇",
  palletsQty: "托盘数量",
  cartonQty: "纸箱数量",
  despatchDate: "发货日期",
  pleaseEnterAYourFirstName: "*请输入您的名字。",
  pleaseEnterAYourLastName: "*请输入您的姓氏。",
  pleaseEnterAYourEmailAddress: "*请输入您的电子邮件地址。",
  pleaseEnterAPassword: "*请输入密码。",
  pleaseConfirmAPassword: "*请确认密码。",
  pleaseEnterAUsername: "*请输入用户名。",
  pleaseEnterAMobilePhone: "*请输入手机号码。",
  atLeastOnePhotoIsRequired: "*至少需要一张照片",
  atLeastOneProductIsRequired: "至少需要一个产品",
  thisEmailIsInvalid: "*此电子邮件无效",
  thisFieldIsRequired: "此字段为必填项",
  selectAnAccessRule: "选择访问规则",
  youNeedToSelectAtLeastOneBranch: "*您需要至少选择一个分支机构",
  youNeedToSelectAtLeastOneSection: "*您需要至少选择一个部门",
  youNeedToSelectAtLeastOneContact: "*您需要至少选择一个联系人",
  youMustEnterACustomer: "*您必须输入客户",
  youMustEnterAEmail: "*您必须输入电子邮件",
  youMustEnterAnMobile: "*您必须输入手机号码",
  youMustHaveAtLeastOneLocation: "*您必须至少拥有一个位置",
  youMustHaveAtLeastOnePrimaryLocation: "*您必须至少拥有一个主要位置",
  pleaseEnterAValidEmail: "*请输入有效的电子邮件",
  quoted: "已报价",
  actual: "实际",
  totalItems: "物品总数",
  registered: "已登记",
  loaded: "已装载",
  taken: "已取走",
  delivered: "已交付",
  void: "作废",
  disposal: "处置",
  missing: "缺失",
  missingShipment: "缺失货运",
  shipped: "已发运",
  packed: "已包装",
  uplifted: "已提升",
  bol: "BoL",
  selectNewStatusForItem: "为物品选择新状态",
  item: "物品",
  items: "物品",
  packer: "包装工",
  selectPacker: "选择包装工",
  selectNewStatusForItems: "为物品选择新状态",
  newStatus: "新状态",
  changeItemsStatus: "更改物品状态",
  addNewItem: "添加新物品",
  createNewItem: "创建新物品",
  addNewRoom: "添加新房间",
  editItem: "编辑物品",
  viewItem: "查看物品",
  createNewOne: "创建 + 新建",
  comment: "评论",
  createNewComment: "创建新评论",
  newComment: "新评论",
  commentBy: "评论人",
  hideCommentHistory: "隐藏评论历史",
  seeCommentHistory: "查看评论历史",
  copyInfoFromPickup: "从提货处复制信息",
  copyInfoFromDelivery: "从送货处复制信息",
  pickup: "提货",
  pickUp: "提货",
  delivery: "送货",
  switchToManual: "切换到手动地址输入",
  switchToGoogle: "切换到 Google Maps 输入",
  addAnotherAddress: "添加其他地址",
  selectATask: "选择任务",
  enterADateInField: "在字段中输入日期",
  theSurveyDateMustBeGreaterThanTheCurrentDate:
    "调查日期必须晚于当前日期",
  time: "时间",
  date: "日期",
  addATask: "添加任务",
  enterOnTheVideoSurvey: "进入视频调查",
  startVideoSurvey: "开始视频调查",
  scheduleAVideoSurvey: "安排视频调查",
  thisDateIsInvalid: "此日期无效",
  notAvailable: "不可用",
  addATaskHomeSurveyOrVideoSurveyToCreateAQuote:
    "添加家庭调查或视频调查任务以创建报价",
  pickupAccess: "提货准入",
  deliveryAccess: "送货准入",
  switchToPickupAccess: "切换到提货准入",
  switchToDeliveryAccess: "切换到送货准入",
  duplicate: "复制",
  willTheEntryOfTheHouseBeObstructed: "房屋入口是否会被阻挡？",
  driveway: "车道",
  steep: "陡峭",
  long: "较长",
  whatIsTheLengthM: "长度是多少(m)？",
  residence: "住宅",
  residenceType: "住宅类型",
  house: "房屋",
  apartment: "公寓",
  level: "楼层",
  howManyLevels: "有几层？",
  groundFloor: "底层",
  split: "错层",
  multiStorey: "多层",
  steps: "台阶",
  notAuthorizedByCustomer: "未经客户授权",
  photos: "照片",
  addPhoto: "添加照片",
  hasLift: "有电梯吗？",
  lift: "电梯",
  internal: "内部",
  external: "外部",
  streetAccess: "街道通道",
  wide: "宽",
  narrow: "窄",
  step: "台阶",
  normal: "正常",
  permitRequired: "需要许可证",
  oneWay: "单行道",
  culDeSac: "死胡同",
  roundabout: "环形交叉路口",
  speedHumps: "减速带",
  noThroughRoad: "禁止通行",
  road: "公路",
  sea: "海运",
  air: "空运",
  ferry: "渡轮",
  storage: "仓储",
  other: "其他",
  parking: "停车",
  parkingType: "停车类型",
  carry: "搬运",
  carryM: "搬运距离(m)",
  treesPowerline: "树木/电力线",
  overhanging: "悬垂",
  low: "低",
  action: "操作",
  vehicleSize: "车辆大小",
  small: "小型",
  rigid: "刚性车",
  semi: "半挂车",
  isFerryRequired: "需要渡轮吗？",
  saveAComment: "保存评论",
  createComment: "创建评论",
  saveABookmark: "保存书签",
  takeAScreenshot: "截屏",
  accessDetailsDescribedAboveAreAccurateToTheBestOfMyKnowledge:
    "以上准入详情据我所知准确无误。",
  specialInstructions: "特殊说明",
  itemInstructionStatus: "物品指令状态",
  deleteAddress: "删除地址",
  thereAreItemsOrMaterialsRegisteredWithThisAddressIfYouDeleteThisAddressNowAllItemsWillBeRegisteredWithTheMainDeliveryAddressWouldYouLikeToDoThat:
    "有物品或材料登记在此地址下。如果您现在删除此地址，所有物品将登记到主送货地址下。您确定要这样做吗？",
  inventory: "库存",
  itemDetails: "物品详情",
  materialDetails: "材料 - 详情",
  addAnother: "再添加一个",
  fileIsTooBigMax2Mb: "文件过大（最大 2MB）",
  thisFileExtensionIsNotAllowed: "不允许使用此文件扩展名",
  fileIsTooBigMax8Mb: "文件过大（最大 8MB）",
  fileAlreadyExistsInThisFolder: "该文件夹中已存在此文件",
  anotherFolderWithThisNameAlreadyExists: "已存在同名文件夹",
  newFolder: "新建文件夹",
  upload: "上传",
  uploading: "上传中",
  uploadingYourContent: "正在上传您的内容",
  share: "共享",
  shared: "已共享",
  unshare: "取消共享",
  notBeingShared: "未共享",
  stopSharing: "停止共享",
  cancelRequest: "取消请求",
  requestDocument: "请求文档",
  empty: "空",
  file: "文件",
  files: "文件",
  folder: "文件夹",
  rename: "重命名",
  currentStock: "当前库存",
  theFolderNameIsRequired: "文件夹名称为必填项",
  theFileNameIsRequired: "文件名称为必填项",
  accessChecklistSummary: "准入检查清单摘要",
  selectAnOption: "选择一个选项",
  searchTask: "搜索任务",
  anErrorOccuredTryAgain: "发生错误，请重试。",
  secondContact: "第二联系人",
  pleaseSelectAQuoteType: "请选择报价类型",
  pleaseFillAReference: "请填写参考号",
  pleaseSelectAStatus: "请选择状态",
  pleaseSelectAConsultant: "请选择顾问",
  pleaseSelectAManager: "请选择经理",
  pleaseSelectAMode: "请选择模式",
  pleaseFillPickUpCustomerFields: "请填写提货客户字段",
  pleaseFillPickUpAddressFields: "请填写提货地址字段",
  pleaseFillDeliveryCustomerFields: "请填写送货客户字段",
  pleaseFillDeliveryAddressFields: "请填写送货地址字段",
  pleaseCheckTheAccessDetailsDescribedOnPickupAccess:
    "请检查提货准入中的准入详情",
  customRange: "自定义范围",
  summaryFromSales: "销售摘要",
  toAddAnOrderClickOnTheButtonBelow: "要添加订单，请点击下方按钮。",
  addOrderToAShipment: "将订单添加到货运",
  addOrder: "添加订单",
  addOrders: "添加订单",
  changeOrderToAShipment: "更改订单到货运",
  selectShipmentsBelowToAddThem: "选择下方货运以添加。",
  matchOrigin: "匹配始发地",
  matchDestination: "匹配目的地",
  notSent: "未发送",
  shipmentOrigin: "货运始发地",
  shipmentDestination: "货运目的地",
  portName: "港口名称",
  airportName: "机场名称",
  recordDeleted: "记录已删除",
  noVideoRecorded: "无录制视频",
  noCommentsRegistered: "无登记评论",
  noScreenshotsRegistered: "无登记截图",
  noBookmarksRegistered: "无登记书签",
  videoSurvey: "视频调查",
  videos: "视频",
  communication: "通讯",
  document: "文档",
  documents: "文档",
  documentSharing: "文档共享",
  documentsForThisBooking: "此预订的文档",
  map: "地图",
  costing: "成本核算",
  addProduct: "添加产品",
  addProducts: "添加产品",
  addProductToCarton: "将产品添加到纸箱",
  sendEmail: "发送电子邮件",
  sendSMS: "发送 SMS",
  attachmentFailedPleaseTryAgainLater: "附件失败。请稍后重试！",
  clickToViewJson: "点击查看 JSON",
  closeJsonFile: "关闭 JSON 文件",
  invalidEmailFormat: "电子邮件格式无效",
  emailSuccessfullySent: "电子邮件发送成功！",
  somethingWentWrongPleaseTryAgain: "出了点问题。请重试！",
  typeTheEmailAddressEnter: "输入电子邮件地址 + 回车",
  addGroupCosting: "添加分组成本",
  deleteConfirmation: "删除确认",
  areYouSureYouWantToRemoveThisItem: "您确定要移除此物品吗？",
  selectAtLeastOneItemToChangeStatus: "请至少选择一个物品以更改状态",
  anItemWasAddToTheSelectedRoom: "已将物品添加到所选房间",
  aRoomHasBeenAddedToTheInventory: "已将房间添加到库存",
  anItemWasUpdatedAtTheSelectedRoom: "已更新所选房间中的物品",
  anItemWasRemovedFromTheSelectedRoom: "已从所选房间移除物品",
  couldNotFindItemToDuplicate: "无法找到要复制的物品",
  emailSentSuccesfuly: "电子邮件发送成功！",
  smsSentSuccesfuly: "SMS 发送成功！",
  couldNotSendEmail: "无法发送电子邮件",
  ifAMatchingAccountWasFoundAnEmailWasSentTo:
    "如果找到匹配的账户，已向以下地址发送电子邮件",
  toAllowYouToResetYourPassword: "以便您重置密码。",
  isAnUser: "是用户",
  isNotAnUser: "不是用户",
  allContacts: "所有联系人",
  seeAllOfYourBusinessContacts: "查看所有商务联系人",
  editContact: "编辑联系人",
  addContact: "添加联系人",
  addLocation: "添加位置",
  addContactUser: "添加联系人用户",
  editContactUser: "编辑联系人用户",
  viewAllContacts: "查看所有联系人",
  registerAsAnUser: "注册为用户",
  editThisBusinessContact: "编辑此商务联系人",
  contactDetails: "联系人详情",
  pleaseEnterARegistrationNumber: "请输入注册号",
  otherDetails: "其他详情",
  shipeeziNetwork: "Shipeezi 网络",
  agentIsConnectedToTheShipeezisNetwork: "代理人已连接到 Shipeezi 网络",
  inviteToNetwork: "邀请加入网络",
  actions: "操作",
  sortBy: "排序方式",
  inactiveCompany: "非活跃公司",
  billing: "账单",
  primary: "主要",
  secondary: "次要",
  general: "通用",
  generalPhoto: "通用照片",
  overview: "概览",
  manageUsers: "管理用户",
  monthlyPayment: "月付款",
  addSeats: "添加席位",
  currentPlan: "当前方案",
  changePlan: "更改方案",
  lastPaidInvoice: "上次已付发票",
  billingDetails: "账单详情",
  editPaymentDetails: "编辑付款详情",
  cardHolder: "持卡人",
  creditCardNumber: "信用卡号",
  cvv: "CVV",
  expDate: "有效期",
  billingAddress: "账单地址",
  people: "人员",
  resources: "资源",
  configurations: "配置",
  preferences: "偏好设置",
  orderType: "订单类型",
  leadSource: "潜在客户来源",
  statuses: "状态",
  integrations: "集成",
  apiAllied: "API Allied",
  history: "历史记录",
  checklistForms: "检查清单和表单",
  fleet: "车队",
  equimpent: "设备",
  staff: "员工",
  itemList: "物品列表",
  packagingType: "包装类型",
  modeType: "模式类型",
  exceptionCodes: "异常代码",
  exceptionLocationCode: "异常位置代码",
  materials: "材料",
  instructions: "指令",
  itemDestination: "物品目的地",
  automation: "自动化",
  access: "访问",
  iso174511: "ISO17451-1:2016 - 证书",
  createNewUser: "创建新用户",
  createNewRole: "创建新角色",
  createNewCustomer: "创建新客户",
  deleteCustomer: "删除客户",
  deleteAgent: "删除代理人",
  deleteSelected: "删除所选",
  typePressEnter: "输入 + 按回车",
  createUser: "创建用户",
  viewUser: "查看用户",
  viewUsers: "查看用户",
  editUser: "编辑用户",
  useCompanyAddress: "使用公司地址",
  timezoneIsUpdatedAutomaticallyToMatchYourComputerTimezone:
    "时区会自动更新以匹配您的计算机时区",
  inactiveUser: "非活跃用户",
  activeUser: "活跃用户",
  logUserOut: "注销用户",
  searchAndSelectTheRoleTo: "搜索并选择角色以",
  assignUsers: "分配用户",
  searchAndSelectUsersTo: "搜索并选择用户以",
  viewRole: "查看角色",
  editThisRole: "编辑此角色",
  viewThisRole: "查看此角色",
  setPermissions: "设置权限",
  addANewItem: "添加新物品",
  viewAnItem: "查看物品",
  editAnItem: "编辑物品",
  editLocationForCustomer: "编辑客户位置",
  createNewLocationForCustomer: "为客户创建新位置",
  viewLocationForCustomer: "查看客户位置",
  editOrderType: "编辑订单类型",
  createNewOrderType: "创建新订单类型",
  editLeadSource: "编辑潜在客户来源",
  createNewLeadSource: "创建新潜在客户来源",
  leadSourceStatus: "潜在客户来源状态",
  editStatus: "编辑状态",
  createNewStatus: "创建新状态",
  itemName: "物品名称",
  itemCode: "物品代码",
  itemVolume: "物品体积",
  itemWeight: "物品重量",
  photosAreMandatory: "照片为必填项",
  brandIsMandatory: "品牌为必填项",
  commentIsMandatory: "评论为必填项",
  mEChecklistIsMandatory: "机电检查清单为必填项",
  inactiveItem: "非活跃物品",
  roomName: "房间名称",
  roomCode: "房间代码",
  inactiveLocation: "非活跃位置",
  editPackagingType: "编辑包装类型",
  createPackagingType: "创建包装类型",
  packagingTypeName: "包装类型名称",
  packagingTypeCode: "包装类型代码",
  yourComment: "您的评论",
  packagingTypeStatus: "包装类型状态",
  reason: "原因",
  code: "代码",
  enterTypeOfContact: "输入联系人类型",
  dimensions: "尺寸",
  couldnTSubscribeShipment: "无法订阅货运",
  couldnTRetrieveShipmentStatus: "无法获取货运状态",
  voyageStatusUpdated: "航次状态已更新",
  pod: "Pod",
  pressEnterToAdd: "按回车添加",
  inputYourComments: "输入您的评论",
  portOfDestination: "卸货港 (PoD)",
  placeOfDestination: "目的地",
  containerGateInAtPol: "集装箱在装货港进闸",
  containerGateInPort: "集装箱进港",
  nextPort: "下一港口",
  containerLoadedAtFirstPolPortOfLoad: "集装箱在首个装货港 (POL) 装载",
  containerGateOutAtPodPortOfDischarge: "集装箱在卸货港 (POD) 出闸",
  originPort: "始发港",
  finalDestinationPort: "最终目的港",
  estimatedArrival: "预计到达",
  actualArrival: "实际到达",
  carrierEstimatedArrival: "承运商预计到达",
  carrierActualArrival: "承运商实际到达",
  arrivalAtPort: "到达港口",
  departureAtPort: "从港口出发",
  predictiveArrivalAt: "预计到达",
  arrivalAt: "到达",
  editCurrency: "编辑货币",
  createCurrency: "创建货币",
  editItemInstruction: "编辑物品指令",
  createItemInstruction: "创建物品指令",
  addANewCurrency: "添加新货币",
  australianDollar: "澳元",
  a: "A$",
  currencyView: "货币查看",
  currencyStatus: "货币状态",
  editLanguage: "编辑语言",
  actualStatus: "实际状态",
  createNewLanguage: "创建新语言",
  baseLanguage: "基础语言",
  en: "EN",
  measurementStatus: "度量状态",
  flag: "标记",
  where: "位置",
  usage: "用途",
  filteringBy: "筛选条件 ",
  editModeType: "编辑模式类型",
  createModeType: "创建模式类型",
  editThisModeType: "编辑此模式类型",
  addNewModeType: "添加新模式类型",
  modeTypeStatus: "模式类型状态",
  needAddAHomeOrVideoSurvey: "需要添加家庭调查或视频调查",
  quotedInventory: "报价库存",
  chooseADestination: "选择目的地",
  aMaterialWasAddToTheSelectedRoom: "已将一个材料添加到所选房间",
  pressEnterToSaveOrEscToCancel: "按回车键保存或按 ESC 取消",
  youHaveToChooseAQuoteModeToAddAnItem: "您需要选择报价模式才能添加项目",
  youHaveToChooseAQuoteModeToAddAMaterial: "您需要选择报价模式才能添加材料",
  youHaveToSelectARoomBeforeAddAMaterial: "您需要先选择房间才能添加材料",
  aRoomWithThisNameAlreadyExists: "同名房间已存在",
  youHaveToSelectARoomBeforeAddAnItem: "您需要先选择房间才能添加物品",
  generateToken: "生成令牌",
  copyToken: "复制令牌",
  copiedSuccessfully: "复制成功",
  unitQty: "单位数量",
  productQty: "产品数量",
  qtyStock: "数量（库存）",
  qtyShipping: "数量（运输）",
  latitude: "纬度",
  longitude: "经度",
  vesselType: "船舶类型",
  vesselPosition: "船舶位置",
  speedKnots: "速度（节）",
  editMeasurement: "编辑测量",
  createMeasurement: "创建测量",
  createNewStaff: "创建新员工",
  viewStaff: "查看员工",
  male: "男",
  female: "女",
  createService: "创建服务",
  editService: "编辑服务",
  viewService: "查看服务",
  serviceStatus: "服务状态",
  sellDescription: "销售描述",
  serviceDescription: "服务描述",
  sellType: "销售类型",
  m3Fee: "立方米费用",
  defaultPrice: "默认价格",
  serviceGroup: "服务组",
  inputMessage: "输入消息",
  viewChecklist: "查看检查清单",
  editChecklist: "编辑检查清单",
  createChecklist: "创建检查清单",
  emptyList: "空列表",
  addAll: "全部添加",
  addType: "添加类型",
  addBranch: "添加分支机构",
  jobTypeAlreadyExistInTheList: "该作业类型已存在于列表中",
  branchAlreadyExistInTheList: "该分支机构已存在于列表中",
  riskAssessment: "风险评估",
  vehicleTrailer: "车辆/拖车",
  required: "必填",
  title: "标题",
  needAction: "需要操作",
  answerAction: "回复操作",
  addNewQuestion: "添加新问题",
  trigger: "触发器",
  addNewTrigger: "添加新触发器",
  notes: "备注",
  taskTypeAlreadyExistInTheList: "该任务类型已存在于列表中",
  taskType: "任务类型",
  questions: "问题",
  appTriggers: "应用触发器",
  beforeStartTask: "开始任务前",
  beforeContinueTask: "继续任务前",
  beforeFinishTask: "完成任务前",
  beforeAcceptTask: "接受任务前",
  text: "文本",
  checkbox: "复选框",
  decimal: "小数",
  integer: "整数",
  signature: "签名",
  photo: "照片",
  checkboxText: "复选框和文本",
  radioButton: "单选按钮",
  textarea: "文本域",
  radioButtonText: "单选按钮和文本",
  johnny: "Johnny",
  bravo: "Bravo",
  john: "John",
  sampleEmailCom: "sample@email.com",
  emergency: "紧急",
  pendingCustomerUpload: "待客户上传",
  sharedWithCustomer: "已与客户共享",
  resendRequest: "重新发送请求",
  uploadedByCustomer: "客户已上传",
  noDocumentsRequestedYet: "暂无文档请求",
  donTWorryIfAnyDocumentsAreRequestedByUsYouWillBeNotifiedAndWillBeAbleToManageThem:
    "请放心，如果我们请求了任何文档，您将收到通知并可以管理它们。",
  oneOrMoreRequiredFieldsAreEmpty: "一个或多个必填字段为空",
  noChangeHasBeenDetected: "未检测到任何更改",
  noCommentsBeTheFirstToComment: "暂无评论！成为第一个评论的人...",
  mainAddress: "主地址",
  createANewBusinessContact: "创建新的商业联系人",
  editABusinessContact: "编辑商业联系人",
  includeInCommunications: "包含在通讯中",
  thisUserNeedsToHaveSomeProjectSelected: "该用户需要选择至少一个项目",
  thisUserNeedsToHaveSomeRoleSelected: "该用户需要选择至少一个角色",
  thePasswordDoesNotMatch: "密码不匹配",
  selectPerformancePrediction: "选择绩效预测",
  performancePrediction: "绩效预测",
  passwordAndConfirmPasswordMustBeTheSame: "密码和确认密码必须一致",
  newPasswordAndConfirmPasswordMustBeTheSame: "新密码和确认密码必须一致",
  hiThere: "您好！",
  pleaseFindTheJsonFileAttachedForShipmentS: "请查收随附的运输件 JSON 文件",
  best: "此致，",
  discard: "放弃",
  discardChanges: "放弃更改",
  areYouSureYouWantToDiscardAllChanges: "您确定要放弃所有更改吗？",
  thisActionIsPermanentAndCannotBeUndone: "此操作是永久性的，无法撤销！",
  shipeeziAustralia: "Shipeezi  Australia",
  supportShipeeziCom: "support@shipeezi.com",
  wwwShipeeziCom: "www.shipeezi.com",
  shipeeziKey: "Shipeezi 密钥",
  termsOfUsePrivacyPolicySecurityPolicy: "使用条款、隐私政策、安全政策",
  andSaasAgreement: " 和 SaaS 协议 ",
  agreed: "已同意",
  thisCurrencyIsAlreadyRelatedToACompanyThereforeYouCannotChangeHisStatus:
    "该货币已关联至一家公司，因此无法更改其状态。",
  select: "选择",
  hello: "您好，",
  dateRange: "日期范围",
  viewToday: "查看今天",
  activeQuotes: "活跃报价",
  quotedVolume: "报价量",
  videoSurveys: "视频勘测",
  activeOrders: "活跃订单",
  orderVolume: "订单量",
  branchOrigin: "始发分支机构",
  branchDestination: "目的分支机构",
  material: "材料",
  accessStatus: "访问状态",
  instruction: "指令",
  scheduleCreateSuccessfully: "排程创建成功",
  sendAutomaticalyASmsEmailInvite: "自动发送短信/电子邮件邀请",
  theEmailOrPhoneIsAlreadyInUseByAnotherCustomer:
    "该电子邮件或电话号码已被其他客户使用",
  wouldYouLikeToSendTheDetailsOfTheCallToYourCustomerBy:
    "您是否希望通过以下方式将通话详情发送给客户",
  assignRole: "分配角色",
  duplicateRole: "复制角色",
  accessRule: "访问规则",
  accessRules: "访问规则",
  membersInGroup: "该组中的成员",
  showAll: "显示全部",
  enterNameForThisGroup: "输入该组的名称",
  describeThisGroupInFewWords: "用几个词描述该组",
  groupCreatedSuccessfully: "群组 '{{groupName}}' 创建成功",
  groupUpdatedSuccessfully: "群组 '{{groupName}}' 更新成功",
  anErrorOccurredWhileUpdatingGroup:
    "更新群组 '{{groupName}}' 时发生错误。请联系 Shipeezi 支持团队获取帮助",
  thisIsADefaultSystemGroupThatCannotBeModifiedButYouCanAddOrRemoveMembersFromIt:
    "这是默认系统组，无法修改，但您可以添加或移除其中的成员",
  kindlyResolveTheFormErrorsBeforeProceeding:
    "请在继续之前解决表单中的错误...",
  theGroupNameAlreadyExistsPleaseChooseADifferentName:
    "群组名称 '{{groupName}}' 已存在，请选择其他名称。",
  changeStatus: "更改状态",
  purchase: "采购",
  purchaseOrder: "采购订单",
  salesOrder: "销售订单",
  asPlanned: "按计划",
  potentialDelay: "可能延误",
  delayed: "已延误",
  selectAVideoSurveyOfToday: "选择今天的视频勘测",
  openVideoSurvey: "打开视频勘测",
  searchOrAddAReference: "搜索或添加参考编号",
  searchOriginAddress: "搜索起运地地址",
  searchDestinationAddress: "搜索目的地地址",
  searchOrAddACustomer: "搜索或添加客户",
  jobAlreadyExists: "作业已存在",
  associateCustomer: "关联客户",
  thereIsAlreadyACustomerWithThisEmailOrPhoneNumberDoYouWantToAssociateTheTask:
    "已有客户使用此电子邮件或电话号码，是否要关联该任务？",
  associate: "关联",
  phone: "电话号码",
  translation: "翻译",
  viewActivity: "查看活动",
  seeActivity: "查看活动",
  activity: "活动",
  createItem: "创建物品",
  folders: "文件夹",
  shipment: "运输件",
  quotes: "报价",
  estimate: "估算",
  loadingQuotes: "正在加载报价",
  quotesWonVsLost: "报价成功与失败对比",
  quotesWon: "成功报价",
  quotesLost: "失败报价",
  won: "成功",
  lost: "失败",
  lastUpdatedOn: "最后更新于",
  instructionsNotFound: "未找到指令",
  quotesPerformed: "已执行报价",
  ordersByType: "按类型分类的订单",
  orders: "订单",
  loadingOrders: "正在加载订单",
  itFeelsABitEmpty: "这里看起来有点空",
  videoName: "视频名称",
  fetchingVideo: "正在获取视频",
  fetchDetails: "获取详情",
  videoUploadInProgress: "视频上传中",
  noVideoAvailable: "暂无可用视频",
  screenshots: "截图",
  imageOfAScreenshot: "截图图片",
  fetchingScreenshots: "正在获取截图",
  seeMore: "查看更多",
  noScreenshotAvailable: "暂无可用截图",
  fetchingComments: "正在获取评论",
  noCommentsAvailable: "暂无评论",
  screenSharing: "屏幕共享",
  bookmarks: "书签",
  fetchingBookmarks: "正在获取书签",
  noBookmarksAvailable: "暂无书签",
  bookmarkSavedSuccessfully: "书签保存成功。",
  couldNotSaveBookmark: "无法保存书签",
  searchByCustomerNamePhoneNumberOrEmailAddress:
    "按客户名称、电话号码或电子邮件地址搜索",
  searchManager: "搜索经理",
  totalQty: "总数量",
  totalVolume: "总体积",
  totalWeight: "总重量",
  contacts: "联系人",
  createANewWarehouse: "创建新仓库",
  editWarehouse: "编辑仓库",
  createANewBranch: "创建新分支机构",
  editBranch: "编辑分支机构",
  viewBranch: "查看分支机构",
  viewWarehouse: "查看仓库",
  closeAllPanels: "关闭所有面板",
  collapseAllPanels: "折叠所有面板",
  expandAllPanels: "展开所有面板",
  expandAll: "展开全部",
  collapseAll: "折叠全部",
  tba: "TBA",
  editMaterial: "编辑材料",
  createANewMaterial: "创建新材料",
  materialStatus: "材料状态",
  isAnItem: "是否为物品？",
  editInstruction: "编辑指令",
  createInstruction: "创建指令",
  when: "当",
  editTaskType: "编辑任务类型",
  createTaskType: "创建任务类型",
  taskTypeStatus: "任务类型状态",
  isBookable: "可预订？",
  isItBookable: "是否可预订？",
  viewDestination: "查看目的地",
  editDestination: "编辑目的地",
  createDestination: "创建目的地",
  destinationStatus: "目的地状态",
  colorValueMustStartWithAndCannotBeAWhiteColor:
    "颜色值必须以 # 开头且不能为白色",
  automaticSequencing: "自动编号",
  nextNumber: "下一个编号",
  changeStatuses: "更改状态",
  changeAllSelectedStatusesTo: "将所有选中的状态更改为",
  changeItemStatuses: "更改物品状态",
  changeAllSelectedItemsStatusesTo: "将所有选中物品的状态更改为",
  visibilityControlAndTransparencyOfYourShipments:
    "运输件的可见性、管控和透明度。",
  yourRequestHasExpiredMakeANewRecovery: "您的请求已过期。请重新发起恢复",
  pleaseEnterAEmail: "请输入电子邮件地址。",
  resetPassword: "重置密码",
  pleaseCheckYourEmail: "请检查您的电子邮件。",
  yourPasswordHasBeenUpdated: "您的密码已更新。",
  returnToLogin: "返回登录",
  backToLogin: "返回登录",
  didnTReceiveTheEmail: "没有收到邮件？",
  aPasswordResetMessageWasSentToYourEmailAddress:
    "密码重置邮件已发送至您的电子邮件地址。",
  enterTheEmailAddressAssociatedWithYourAccountAndWeLlSendYouALinkToResetYourPassword:
    "输入与您账户关联的电子邮件地址，我们将向您发送密码重置链接。",
  createAccessOption: "创建访问选项",
  editAccessOption: "编辑访问选项",
  drivewayLength: "车道长度",
  carryDistance: "搬运距离",
  switchTo: "切换至",
  questionFieldsAreRequired: "问题字段为必填项。",
  triggerFieldTypeIsRequired: "触发器字段类型为必填项。",
  valueOfEntryIsAlreadyInUsed: "该条目的值已被使用",
  aRoleOfTypeSystemIsSelectedAndCannotBeChanged:
    "已选择系统类型角色，无法更改",
  theDateIsWrong: "日期有误",
  theUserMustBeAtLeast18YearsOldAndUnder100YearsOld:
    "用户年龄必须在 18 岁至 100 岁之间",
  approveQuote: "批准报价",
  doYouReallyWantToApproveTheQuote: "您确定要批准该报价吗？",
  areYouSureYouWantToDeliverThisOrder: "您确定要交付该订单吗？",
  areYouSureYouWantToCancelTheOrder: "您确定要取消该订单吗",
  yesCancelOrder: "是，取消订单",
  areYouSureYouWantToCancelTheQuote: "您确定要取消该报价吗",
  yesCancelQuote: "是，取消报价",
  oops: "哎呀！",
  youShouldCancelTheseTasksInYourAppBeforeContinue:
    "请在继续之前在应用中取消这些任务。",
  itLooksLikeSomeTasksOfThisOrderAreInProgress:
    "该订单的部分任务正在进行中。",
  declineQuote: "拒绝报价",
  doYouReallyWantToDeclineTheQuote: "您确定要拒绝该报价吗？",
  viewInCalendarMode: "以日历模式查看",
  viewInGridMode: "以网格模式查看",
  removeAll: "全部移除",
  roleNotFound: "未找到角色",
  userNotFound: "未找到用户",
  searchForRole: "搜索角色...",
  searchForUser: "搜索用户...",
  inbound: "入库",
  atPort: "在港口",
  atDc: "在配送中心",
  ofTotalContainers: "占集装箱总数",
  containerDistributionByDestination: "按目的地分布的集装箱",
  shareLink: "分享链接",
  cameraOff: "关闭摄像头",
  video: "视频",
  microphone: "麦克风",
  joinNow: "立即加入",
  youDidnTAddAnyItemsYet: "您尚未添加任何物品",
  copied: "已复制",
  shareViaApp: "通过应用分享",
  shareViaLink: "通过链接分享",
  shareViaSms: "通过短信分享",
  shareViaWhatsapp: "通过 Whatsapp 分享",
  openWhatsappToShare: "打开 Whatsapp 分享",
  shareViaEMail: "通过电子邮件分享",
  shareTheVideoSurveyWithTheCustomer: "与客户分享视频勘测",
  shareTheInventoryWithTheCustomer: "与客户分享库存",
  shareTheEstimateWithTheCustomer: "与客户分享估算",
  shareInventory: "分享库存",
  shareEstimate: "分享估算",
  shareVideoSurvey: "分享视频勘测",
  inventoryUpdated: "库存已更新",
  youAreAboutToLeaveVideoSurveyAreYouSure: "您即将离开视频勘测。确定吗？",
  theCustomerWillBeForcedToLeaveToo: "客户也将被迫离开。",
  youHaveUnsavedChangesInTheInventory: "您在库存中有未保存的更改。",
  audioDeviceTest: "音频设备测试",
  recording: "录制中...",
  playing: "播放中...",
  leave: "离开",
  noIssuesDetected: "未检测到问题",
  inputDevice: "输入设备",
  inputLevel: "输入电平",
  speaker: "扬声器",
  outputDevice: "输出设备",
  outputLevel: "输出电平",
  connectivityAndBandwidthTest: "连接和带宽测试",
  taskTypeIsRequired: "任务类型为必填项。",
  orderTypeIsRequired: "订单类型为必填项。",
  orderTypeStatus: "订单类型状态",
  sequence: "序列",
  poNumber: "PO 编号",
  despatchedQuantity: "已发数量",
  destinationDcCmlDc: "目的地配送中心（CML DC）",
  estimateClearedForPickUp: "估算已清关待提取",
  estimateUnpackDate: "预计拆箱日期",
  actualArriveWh: "实际到达仓库",
  bookedFor: "预订日期",
  at: "于",
  contactEmailCom: "contact@email.com",
  expectedCallQuality: "预期通话质量：",
  deliverOrder: "交付订单",
  generateReport: "生成报告",
  generatePDFreports: "生成 PDF 报告",
  hideSection: "隐藏区域",
  showSection: "显示区域",
  online: "在线",
  offline: "离线",
  collapse: "折叠",
  allow: "允许",
  notAllow: "不允许",
  allowCustomer: "允许客户",
  screenshotSavedSuccessfully: "截图保存成功",
  couldNotSaveScreenshot: "无法保存截图",
  couldNotRetrieveScreenshots: "无法获取截图",
  loadingDespatches: "正在加载发货单",
  checklistStatus: "检查清单状态",
  warehouseStatus: "仓库状态",
  branchStatus: "分支机构状态",
  someRequiredInformationAreMissing: "部分必填信息缺失 ",
  addAnExistentContact: "添加已有联系人",
  selectAContact: "选择联系人",
  hideInput: "隐藏输入框",
  hideForm: "隐藏表单",
  createNewContact: "创建新联系人",
  loadingData: "正在加载数据...",
  qty: "数量",
  isThisMaterialAnItem: "该材料是否为物品？",
  automationAndControlForIncreasedSupplyChainVisibility:
    "自动化和管控，提升供应链可见性。",
  youHavenTAddedAnyItemsYet: "您尚未添加任何物品",
  youHavenTAddedAnyMaterialYet: "您尚未添加任何材料",
  prices: "价格",
  createNewPrice: "创建新价格",
  price: "价格",
  addNewGroup: "添加新组",
  DimensionFee: "{dimension} 费用",
  searchAgent: "搜索代理人",
  preferredUplift: "首选提取方式",
  accessRuleName: "访问规则名称",
  addAccessRule: "添加访问规则",
  groupName: "组名",
  newGroup: "新建组",
  subTotal: "小计",
  deleteThisLine: "删除此行",
  thereMustBeAtLeastOneServiceInAGroup: "每个组中至少需要一项服务",
  deleteThisGroup: "删除此组",
  thereMustBeAtLeastOneGroupInAPrice: "每个价格中至少需要一个组",
  editGroupName: "编辑组名",
  searchCurrency: "搜索货币",
  searchService: "搜索服务",
  priceCreatedSuccessfully: "价格创建成功",
  groupAddedSuccessfully: "组添加成功",
  serviceAddedSuccessfully: "服务添加成功",
  pressToConfirmGroupNameChange: "按下确认组名更改",
  pressToCancelGroupNameChange: "按下取消组名更改",
  fillNameAndPressSaveOrEnter: "填写名称并按保存或回车",
  addNewLine: "添加新行",
  originCosts: "起运地费用",
  destinationCosts: "目的地费用",
  extras: "附加项",
  deleteThisPrice: "删除此价格",
  agentSelected: "已选择代理人",
  pricingListUpdatedOn: "价格列表更新于",
  noneAgentSelected: "未选择代理人",
  totalCosts: "总费用",
  manageNeverBeenEasier: "管理从未如此简单",
  visibilityAtItsBest: "可见性达到最佳",
  shipeeziIsTheEssentialToolForCompaniesOfAllSizesToConsolidateAutomateAndUncomplicateInformationAndShipmentFlowAcrossTheGlobe:
    "Shipeezi 是各种规模企业整合、自动化和简化全球信息及货运流程的必备工具。",
  saveTimeAndMoney: "节省时间和金钱",
  withShipeeziVisibilityAndIncreasedControlIsDeliveredSavingMoreThan30InLogisticsCostsAnd60InTimeReporting:
    "通过 Shipeezi，实现可见性和更强的管控力，节省超过 30% 的物流成本和 60% 的报告时间。",
  createYourAccount: "创建您的账户",
  youAreJustMomentsAwayOfHavingFullVisibilityAndControlOverYourShipments:
    "您即将拥有对运输件的全面可见性和管控力！",
  confirmPassword: "确认密码",
  haveAnAccount: "已有账户？",
  signIn: "登录",
  shipeezi: "© Shipeezi",
  termsOfUse: "使用条款",
  passwordsDonTMatch: "*密码不匹配",
  companyName: "公司名称",
  companyType: "公司类型",
  selectCompanyType: "选择公司类型",
  spShipper: "SP - 发货人",
  fmFreightManager: "FM - 货运经理",
  mvMoving: "MV - 搬迁",
  getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime:
    "接收 Shipeezi 关于产品更新、行业新闻和活动的电子邮件。如果您改变主意，可以随时退订。",
  byContinuingYouReAgreeingToShipeeziS: "继续即表示您同意Shipeezi的",
  requestAccount: "申请账户",
  ourTeamWillGetInTouchWithYouAsSoonAsPossible:
    "我们的团队将尽快与您联系。",
  thankYouForSignUpYouCanCheckYourEmailToProceed:
    "感谢您的注册。请检查您的电子邮件以继续。",
  youWillReceiveAnEmailTo: "您将收到发送至",
  toConfirmYourSignUp: "的邮件以确认您的注册。",
  thereWasAnErrorCreatingTheAccount: "创建账户时发生错误",
  captcha: "验证码",
  captchaExpired: "验证码已过期",
  and: "和",
  leaveVideoSurvey: "离开视频勘测",
  wellDoneOnTheMeetingWith: "与以下人员的会议已完成",
  donTForgetWhatYouHaveAvailableFromThisMeeting:
    "别忘了您从此次会议中获得的内容。",
  didYouLeaveTheMeetingByMistake: "您是否误退了会议？",
  rejoinTheMeetingHere: "点击此处重新加入会议",
  packingMaterial: "包装材料",
  estimateQuote: "估算报价",
  agents: "代理",
  editEstimate: "编辑估算",
  charge: "费用",
  quantity: "数量",
  rate: "费率",
  margin: "利润",
  markUp: "加价",
  discount: "折扣",
  totalCost: "总费用",
  paymentMethod: "付款方式",
  creditCard: "信用卡",
  credit_card: "信用卡",
  account: "账户",
  cash: "现金",
  goBackToApp: "返回应用",
  closeTab: "关闭标签页",
  openCommunication: "开启通讯",
  enableMicrophone: "开启麦克风",
  disableMicrophone: "关闭麦克风",
  enableCamera: "开启摄像头",
  disableCamera: "关闭摄像头",
  shareScreen: "共享屏幕",
  stopSharingScreen: "停止共享屏幕",
  cannotShareScreenWhenAnotherUserIsSharing: "其他用户正在共享时无法共享屏幕",
  screenSharingIsNotSupportedWithThisBrowser: "此浏览器不支持屏幕共享",
  emailConfirmationTimeHasExpired: "电子邮件确认时间已过期",
  thereWasAnErrorConfirmingTheEmail: "确认电子邮件时发生错误",
  emailSuccessfullyConfirmed: "电子邮件确认成功",
  backToLoginPage: "返回登录页面",
  goToShipeeziBlog: "前往 Shipeezi 博客",
  isNowVerified: "已验证！",
  chooseAPassword: "选择密码",
  useLettersNumbersAndSymbolsForSafety: "请使用字母、数字和符号以确保安全",
  confirmYourPassword: "确认您的密码",
  theSameOneFromAbove: "与上方输入一致",
  youJustNeedToCreateAPasswordForYourAccount:
    "您只需为您的账户创建一个密码。",
  predictiveDeparture: "预计出发：",
  departure: "出发",
  arrival: "到达",
  nextPortArrival: "下一港口到达：",
  decimalSeparator: "小数点分隔符",
  thousandSeparator: "千位分隔符",
  usePoint: "使用点号（.）",
  useComma: "使用逗号（,）",
  newService: "新建服务",
  createANewServiceOrGroup: "创建新服务或组",
  createNewGroup: "创建新组",
  inventoryList: "库存清单",
  openLegacyVersion: "打开旧版本",
  closeThisScreen: "关闭此页面",
  changeGroupStatus: "更改组状态",
  noAssociatedService: "无关联服务。",
  viewGroups: "查看组",
  groups: "组",
  seemsLikeYouDidnTCreateAnyGroup: "您似乎还没有创建任何组 :(",
  searchGroups: "搜索组",
  groupCosting: "组成本",
  totalOfPrice: "价格合计 ",
  sent: "已发送",
  group: "组",
  changeStatusTo: "将状态更改为",
  totalOf: "合计",
  lastUpdated: "最后更新",
  thisServiceCannotBeActivatedBecauseIsUnavailable:
    "该服务不可用，无法激活",
  thisServiceCannotBeEditedBecauseIsUnavailable:
    "该服务不可用，无法编辑",
  loadingPrices: "正在加载价格",
  updatePrices: "更新价格",
  reviewPrices: "审核价格",
  editFile: "编辑文件",
  uploadCsv: "上传 CSV",
  uploadCsvFile: "上传 CSV 文件",
  downloadTemplate: "在此处下载我们的 CSV 模板",
  clickToDownloadThePriceTemplateAndFillPrices:
    "点击下载价格模板并填写价格",
  noFilesUploaded: "未上传文件",
  noneDataHasFilled: "未填写数据",
  fee: "费用",
  thisServiceDoesNotExist: "该服务不存在",
  thereIsNoRelationshipBetweenThisServiceAndTheGroup:
    "该服务与该组之间无关联关系",
  thisGroupDoesNotExist: "该组不存在",
  thereIsNoRelationshipBetweenThisGroupAndTheService:
    "该组与该服务之间无关联关系",
  theValueOfThisFieldIsInvalid: "该字段的值无效",
  thisCurrencyDoesNotExist: "该货币不存在",
  nonGrouped: "未分组",
  wasEditedSuccessfully: "编辑成功！",
  thisRecordCannotBeEditedBecauseThereIsAnErrorInTheServiceOrGroup:
    "由于服务或组存在错误，无法编辑此记录",
  theseServicesWillNotBeUpdatedIfYouWouldLikeToCorrectThemYouShouldEditFile:
    "这些服务将不会被更新。如果您想修正它们，请编辑文件。",
  thisCanBeCorrectedIfYouClickIn: "您可以点击以下位置修正 ",
  latestUpload: "最近上传",
  youCanOnlyContinueAfterAllWarningsHaveBeenResolved:
    "所有警告解决后方可继续",
  timeControl: "时间控制",
  arrivedAtTheResidence: "到达住所",
  breakFrom: "休息自",
  to: "至",
  leavingTheResidence: "离开住所",
  arrivedBackToTheWarehouse: "返回仓库",
  timeSummary: "时间摘要",
  transitTime: "运输时间",
  breakTime: "休息时间",
  workTime: "工作时间",
  totalTime: "总时间",
  extraStaff: "额外员工",
  deleteSubscriber: "删除订阅者",
  whenYouDeleteANotification:
    "删除通知后，关联联系人将不再收到提醒。",
  wouldYouLikeToProceed: "是否继续？",
  pricesUpdatedSuccessfully: "价格更新成功",
  weWillUpdateAllPricesDisregardingThoseMarkedWith:
    "我们将更新所有价格，忽略标记为以下内容的项",
  ifYouWantToUpdateThesePricesYouShouldEditFile:
    "如果您想更新这些价格，请编辑文件",
  newMessage: "新消息！",
  oopsIncorrectCredentials: "哎呀！凭据不正确。",
  leaveWithoutSave: "不保存离开",
  youHaveUnsavedChangesAreYouSureYouWantToLeave:
    "您有未保存的更改。确定要离开吗？",
  youShouldSaveYourWorkBeforeLeaving: "离开前请保存您的工作。",
  doYouReallyWantToDeleteThisAgent: "您确定要删除此代理人吗",
  agentDetails: "代理人详情",
  toAllowYourPasswordReset: "以完成密码重置。",
  sorryTheLinkHasExpired: "抱歉，链接已过期。",
  theResetPasswordLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "密码重置链接已过期。您可以点击下方按钮重新获取。",
  resetPasswordLink: "重置密码链接",
  emailSuccessfullyResent: "电子邮件重新发送成功",
  anUnknownErrorHasOccurred: "发生未知错误",
  emailOrUsernameIsRequired: "电子邮件或用户名为必填项",
  passwordIsRequired: "密码为必填项",
  userLoggedIn: "用户已登录",
  thereWasAnErrorCapturingYourEmailToResend: "获取您的电子邮件以重新发送时发生错误",
  theEmailConfirmationLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "电子邮件确认链接已过期。您可以点击下方按钮重新获取。",
  resendConfirmationLink: "重新发送确认链接",
  thankYouForRequestingAnAccountWithShipeezi: "感谢您申请 Shipeezi 账户。",
  ourTeamWillBeInContactWithYouPriorToActivatingYourAccount:
    "我们的团队将在激活您的账户前与您联系。",
  companyDetails: "公司详情",
  uploadCentre: "上传中心",
  goBackToHomePage: "返回首页",
  goBackToLogin: "返回登录",
  goBackToLoginPage: "返回登录页面",
  previous: "上一步",
  skip: "跳过",
  downloadOurCsvTemplateHere: "在此处下载我们的 CSV 模板",
  addAdditionalUsers: "添加其他用户",
  theContactDetailsUsedToRegisterHasBecomeAnAdminUserAlready:
    "用于注册的联系信息已成为管理员用户。",
  registeredUsers: "已注册用户",
  addUser: "添加用户",
  aud: "AUD",
  youCanSelectToUploadYourOwnFilesInformationNowOrLaterIfYouPreferYouCanUseOurDefaultInformationTheseInformationIsInRegardsToYourInventoryItemsServicesFleetStaffAndSoOn:
    "您可以选择现在或稍后上传您自己的文件（信息）。如果您愿意，可以使用我们的默认信息。这些信息涉及您的库存物品、服务、车队、员工等。",
  uploadOwnList: "上传自定义列表",
  useShipeeziSDefaultList: "使用 Shipeezi 默认列表",
  inventoryListIso174511: "库存清单 ISO17451-1:2016 认证",
  usingShipeeziSDefault: "使用 Shipeezi 默认",
  itemsRoomsPackagingTypeMethodOfPreparationModeTypeExceptionCodesExceptionLocationCodeItemInstructionsAndItemDestination:
    "物品、房间、包装类型、准备方法、模式类型、异常代码、异常位置代码、物品指令和物品目的地。",
  checklistForm: "检查清单和表单",
  riskAssessmentTemplate: "风险评估模板",
  usingShipeeziSSampleData: "使用 Shipeezi 示例数据",
  listOfMaterials: "材料清单",
  aFewCommonTypesOfPackingMaterialsWillBeLoaded:
    "将加载一些常见的包装材料类型",
  services: "服务",
  oneServiceTypeWillBeCreated: "将创建一个服务类型",
  oneStaffWillBeCreated: "将创建一名员工",
  oneVehicleWillBeCreated: "将创建一辆车辆",
  theseInstructionsCanBeUsedInTheSalesAndOperationsAppForUpliftDeliveryOrMoveCoordinator:
    "这些指令可在销售和运营应用中用于提取、交付或搬迁协调",
  usualAccessQuestionsWillBeCreatedHere: "常用访问问题将在此处创建",
  iso174511CertifiedItems:
    "ISO17451-1:2016 认证：物品、房间、包装类型、准备方法、模式类型、异常代码、异常位置代码、物品指令和物品目的地。",
  csvUploaded: "CSV 已上传",
  asPerYourSelectionWeAreGoingToUploadTheStandardContentForTheFollowingSections:
    "根据您的选择，我们将上传以下部分的标准内容：",
  youCanChooseFromTheListBelowWhichItemsYouWantToUploadAndWhichYouWantToUseShipeeziSDefault:
    "您可以从以下列表中选择要上传的项目以及要使用 Shipeezi 默认的项目：",
  weAreLoadingTheUploadedContentPleaseWait: "正在加载上传的内容，请稍候",
  thisMightTakeAWhile: "这可能需要一些时间",
  ifThisIsTakingTooMuchLonger: "如果等待时间过长，",
  tryAgainHere: "请在此处重试",
  thankYouForCompleteThisProcess: "感谢您完成快速设置流程。",
  readyToStartUsingShipeezi: "准备好使用 Shipeezi 了吗？",
  getStarted: "开始使用",
  confirmationEmailHasBeenSucessfullyResent: "确认邮件已成功重新发送！",
  confirmationEmailCouldNotBeenResent: "确认邮件无法重新发送！",
  resetUserPassword: "重置用户密码",
  businessLogo: "企业标志",
  businessIcon: "企业图标",
  addLogo: "添加标志",
  choosePicture: "选择图片",
  maxSize: "最大尺寸",
  formats: "格式",
  crop: "裁剪",
  version: "版本",
  profile: "个人资料",
  emailToResetPasswordSent: "密码重置邮件已发送",
  "2Mb": "2 MB",
  maxFileSize: "最大文件大小：",
  fileTypes: "文件类型：",
  accountDetails: "账户详情",
  csvTemplateIsInvalid: "CSV 模板无效",
  line: "行",
  isRequired: "为必填项",
  mustBeOneOfTheValidOptions: "必须为有效选项之一",
  mustBeFilledInWithXOrLeftEmpty: '必须填写 "x" 或留空',
  mustBeANumber: "必须为数字",
  mustBeADateWithTheFormatDdMmYyyy: "必须为日期格式 dd/mm/yyyy",
  errorsFound: "发现错误",
  errorsFoundInYourFile: "您的文件中发现错误",
  on: "在",
  csvWeHaveFoundSomeErrorsYouShouldAdjustThoseLinesToProceed:
    "CSV 中发现一些错误。请调整以下行后继续：",
  donTKnowWhatSWrong: "不知道哪里出错了？",
  downloadOurTemplateHere: "在此处下载我们的模板",
  downloadOurTemplate: "下载我们的模板",
  logout: "退出登录",
  logOut: "退出登录",
  userProfile: "用户资料",
  helpCenter: "帮助中心",
  dispatchFilters: "调度筛选",
  allTasks: "所有任务",
  allTeams: "所有团队",
  unpublishedTasks: "未发布的任务",
  publishedTasks: "已发布的任务",
  teamsWithUnpublishedTasks: "有未发布任务的团队",
  teamsWithPublishedTasks: "有已发布任务的团队",
  someChangesMayTakeSomeTimeToBeAppliedOnThisScreen:
    "部分更改可能需要一些时间才能在此页面生效",
  thisFleetIsUnavailableOnThisDate: "该车队在此日期不可用",
  thisMemberIsUnavailableOnThisDate: "该成员在此日期不可用",
  theFilteredDataAffectsWhatYouSeeOnDispatch:
    "筛选的数据会影响您在「调度」中看到的内容",
  termsAndConditions: "条款和条件",
  currentlyViewing: "当前查看",
  changeTo: "更改为",
  switchingAccounts: "正在切换账户。",
  unknown: "未知",
  messageHasBeenSentSuccessfully: "消息发送成功！",
  avatar: "头像",
  approvingCompany: "正在审批公司...",
  theCompanyHasBeenApproved: "公司已获批准！",
  nowIsReadyToRockAndRoll: "现在已准备就绪。",
  quoteType: "报价类型",
  allProjects: "所有项目",
  typeMobile: "手机类型",
  searchForTimezone: "搜索时区",
  inviteUser: "邀请用户",
  userEmail: "用户电子邮件",
  userAddedSuccessfully: "用户添加成功",
  unableToRegisterAdditionalUser: "无法注册其他用户",
  inviteSentSuccessfully: "邀请发送成功！",
  saveAndInvite: "保存并邀请",
  createAndInvite: "创建并邀请",
  anEmailWasSentToUsernameWithYourRequest: "已将您的请求通过电子邮件发送至 *username*",
  companyInvitation: "公司邀请",
  inviteDeclined: "邀请已拒绝",
  youHaveBeenInvitedToBePartOf: "您已被邀请加入 ",
  youHaveBeenInvitedToBePartOfCompany: "您已被邀请加入该公司",
  youCanAcceptOrDeclineTheInvitationAndWeWillNotifyTheCompanyAdministrator:
    "您可以接受或拒绝邀请，我们将通知公司管理员。",
  weWillNotifyTheAdministrator: "我们将通知管理员。",
  weWillNotifyTheAdministratorFor: "我们将通知管理员关于",
  youCanCloseThisWindow: "您可以关闭此窗口",
  ifYouRejectedThisInvitationByMistakePleaseRequestANewInvite:
    "如果您误拒了此邀请，请申请新的邀请",
  here: "此处",
  yourInvitationExpired: "您的邀请已过期",
  companyUpdatedSuccessfully: "公司更新成功",
  termsAcceptedSuccessfully: "条款接受成功",
  by: "由",
  entityName: "实体名称",
  sorryTheLinkIsBroken: "抱歉，链接已失效",
  theInviteLinkIsBroken: "邀请链接已失效。",
  theInviteLinkIsBrokenYouCanRequestANewOneByClickingOnTheButtonBelow:
    "邀请链接已失效。您可以点击下方按钮重新获取。",
  resendInviteLink: "重新发送邀请链接",
  goBack: "返回",
  theInviteLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "邀请链接已过期。您可以点击下方按钮重新获取。",
  thisFieldIsAnInvalidUrl: "该字段的 URL 无效",
  thisFieldShouldHaveDigitsOnly: "该字段只能包含数字",
  validFormats: "有效格式",
  typeOfInstruction: "指令类型",
  inputYourInstruction: "输入您的指令",
  asYouAddedAnItemThatDoesNotBelongToTheIso174511:
    "由于您添加的物品不属于 ISO17451-1:2016 标准，您的库存清单不合规。",
  requestingNewInvite: "正在请求新邀请",
  youHaveAlreadyAcceptedThisInvitation: "您已接受此邀请！",
  loadingInvitation: "正在加载邀请...",
  userHasNotBeenInvited: "用户尚未被邀请",
  navigation: "导航",
  someOfTheseEmailsProvidedIsInvalid: "提供的部分电子邮件无效",
  isThisAnItemDestination: "这是物品目的地吗？",
  ssccQty: "SSCC 数量",
  etdAtOrigin: "始发地 ETD",
  etaAtDestination: "目的地 ETA",
  subjects: "主题",
  favorites: "收藏",
  reports: "报告",
  company: "公司",
  itFeelsEmptyRightNow: "目前没有内容。",
  status: "状态",
  filter: "筛选",
  reference: "参考编号",
  referenceNumber: "参考编号",
  customer: "客户",
  pdf: "PDF",
  csv: "CSV",
  exportAs: "导出为",
  tags: "标签",
  nothingToShowHereYet: "暂无内容可显示。",
  thisWarehouseDoesNotAllowStorageOfLooseItemsSelectAStorageBoxInstead:
    "此仓库不允许存放散装物品。请选择一个存储箱。",
  iConfirmThatAllTheDetailsAboveAreTrue: "我确认以上所有信息属实",
  notInformed: "未告知",
  signHere: "在此签名",
  expandAllTasks: "展开所有任务",
  hideAllTasks: "隐藏所有任务",
  checkIfAnyOfTheTasksEligibleForReportGenerationUpliftDeliveryLocalHasBeenCompletedAndHasADate:
    "检查是否有符合报告生成条件的任务（提取、交付、本地）已完成并有日期",
  asn: "ASN",
  containerSize: "集装箱尺寸",
  selectOne: "选择一个",
  seal: "封条",
  consignee: "收货人",
  consigneeCode: "收货人代码",
  deliverToWarehouse: "送达仓库",
  serviceType: "服务类型",
  shipTerms: "运输条款",
  mbl: "MBL",
  hbl: "HBL",
  loadingPort: "装货港",
  destinationPort: "目的港",
  dischargePort: "卸货港",
  searchAddress: "搜索地址",
  shipperOriginAirport: "发货人始发机场",
  receiverDestinationAirport: "收货人目的机场",
  airports: "机场",
  ports: "港口",
  roads: "公路",
  scannedDate: "扫描日期",
  pickUpFromOrigin: "从始发地提取",
  ataAtOrigin: "始发地 ATA",
  ataAtDestination: "目的地 ATA",
  actualDeliveryDate: "实际交付日期",
  senderOriginRoad: "发货人始发公路",
  receiverDestinationRoad: "收货人目的公路",
  roadName: "公路名称",
  estimatedDeliveryDate: "预计交付日期",
  noReportsAddedToFavorites: "暂无添加到收藏的报告",
  go: "前往",
  itemInstructions: "物品指令",
  chooseAnItemInstruction: "选择物品指令",
  notHaveDatesYet: "尚无日期",
  videoSurveyRecordDeleted: "视频勘测记录已删除",
  theVideoRecordedForThisSurveyWasDeletedAsTheStatusHasChangedTo:
    "由于状态已更改为以下状态，该勘测的录制视频已被删除",
  youDoNotHaveAccessToThisRecordAnymore: "您不再有权访问此记录。",
  diary: "日志",
  day: "天",
  days: "天",
  see: "查看",
  moreTasks: "更多任务",
  sequenceMustBeAValidNumber: "*序列号必须为有效数字",
  sequenceMustBeAIntegerNumber: "*序列号必须为整数",
  sequenceMustBeGreaterThan0: "*序列号必须大于 0",
  sequenceMustBeSmallerThan1000: "*序列号必须小于 1000",
  noTasksRegisteredForTheDay: "当天无已登记的任务",
  startsAt: "开始时间：",
  search: "搜索",
  seeTaskOnOrder: "在订单中查看任务",
  taskDetails: "任务详情",
  storageBoxes: "存储箱",
  storageBoxTypes: "存储箱类型",
  prepayment: "预付款",
  noneInformationToShow: "暂无信息可显示",
  tasks: "任务",
  assignTask: "分配任务",
  printJob: "打印作业",
  cancelTask: "取消任务",
  yesCancelTask: "是，取消任务",
  areYouSureYouWantToCancelThisTask: "您确定要取消此任务吗？",
  searchByFleet: "按车队搜索",
  searchByStaff: "按员工搜索",
  searchByLeader: "按负责人搜索",
  searchByStorageBox: "按存储箱搜索",
  orderReference: "订单参考编号",
  taskStartsAt: "任务开始于",
  languageName: "语言名称",
  australianEnglishSystem: "澳大利亚英语（系统）",
  thisIsTheName: "这是名称",
  term: "术语",
  createdBy: "创建者",
  lengthM: "长度（m）",
  taskList: "任务列表",
  exception: "异常代码",
  cancelled: "已取消",
  labelTooltipRecording: "录制中",
  labelTooltipNotRecording: "未录制",
  youAreNotAllowedToEditThisQuote: "您无权编辑此报价",
  youAreNotAllowedToEditThisOrder: "您无权编辑此订单",
  fileDownloadComplete: "文件下载完成",
  scheduleNow: "立即安排",
  videoSurveyUnavailable: "视频勘测不可用",
  thisVideoSurveyHasBeenClosed: "该视频勘测已关闭",
  pleaseScheduleAnotherSurveyToContinue: "请安排另一次勘测以继续",
  youCanScheduleAnotherVideoSurveyNowOrLater: "您可以现在或稍后安排另一次视频勘测",
  theCustomerHasRemovedTheCallRecordingPermission:
    "客户已撤销通话录制权限",
  theCustomerAllowedTheRecordThisCallIsBeingRecordedFromNowOn:
    "客户已允许录制。从现在起此通话将被录制。",
  recordingVS: "录制中",
  notRecording: "未录制",
  readyToShip: "待发运",
  port: "港口",
  deliverTo: "送达",
  plane: "飞机",
  journey: "旅程",
  airwayBill: "航空运单",
  cfs: "CFS",
  addNewContainer: "添加新集装箱",
  acmeClothing: "Acme clothing",
  purchasingOrganisation: "采购组织",
  orderNumber: "订单编号",
  amosToken: "AMOS 令牌",
  token: "令牌",
  australia: "澳大利亚",
  sistrs: "SISTRS",
  pleaseEnterAValidToken: "请输入有效的令牌",
  revokeConnection: "撤销连接",
  areYouSureYouWantToRevokeTheConnection: "您确定要撤销此连接吗？",
  amos: "AMOS",
  copyKey: "复制密钥",
  inviteSISTR: "邀请 SISTR",
  editSISTR: "编辑 SISTR",
  SISTRemail: "SISTR 电子邮件",
  emailAlreadyExists: "电子邮件已存在",
  waybills: "运单",
  moreOrders: "更多订单",
  etd: "ETD",
  print: "打印",
  seeReport: "查看报告",
  reportType: "报告类型",
  uploaded: "已上传",
  uploadFile: "上传文件",
  documentsUploaded: "文档已上传",
  dragOrClickToUploadYourFile: "拖拽或点击上传文件",
  waybill: "运单",
  estimateDates: "预计日期",
  aircraftDestination: "飞机目的地",
  aircraftOrigin: "飞机始发地",
  aircraft: "飞机",
  unpackDate: "拆箱日期",
  pickDate: "提取日期",
  arrivalOfDestination: "交付日期",
  deleteShipment: "删除运输件",
  image: "图片",
  billOfLanding: "提单",
  enterBillOfLanding: "输入提单号",
  billOfLandingMustBeAtLeast7CharactersLong: "提单号至少需要 7 个字符",
  billOfLandingMustBeAtMax20CharactersLong: "提单号最多 20 个字符",
  tradingName: "商号",
  youCanGetStartedTrackingShipmentsFromHereRegardlessOfHowManyForwardersOrRoutes:
    "您可以从这里开始追踪运输件，无论有多少货代或路线。",
  eitherUploadACsvFileUsingTheTemplateOrClickNextToEnterAContainerNumber:
    "请使用模板上传 CSV 文件或点击下一步输入集装箱号。",
  uploadYourShipmentDetails: "上传您的运输件详情",
  due: "到期",
  notDefined: "未定义",
  viewFile: "查看文件",
  thisFileIsRequired: "此文件为必需",
  tryAgain: "重试",
  tryAgain2: "重试",
  ifThisIsTakingTooLong: "如果等待时间过长，",
  uploadMade: "上传完成",
  theFileMustBeLessThan2mbInSize: "文件大小不得超过 2 MB",
  invite: "邀请",
  inviteSupplier: "邀请供应商",
  inviteSuppliers: "邀请供应商",
  doYouWantToInvite: "您是否要邀请",
  toShipeezi: "加入 Shipeezi？",
  anInvitationWillBeSendTo: "邀请将发送至",
  activeContainers: "活跃集装箱",
  avgContainerPerWeek: "每周平均集装箱数",
  containersDelayed: "延误集装箱",
  containersWaitingAtGate: "在闸口等待的集装箱",
  totalContainers: "集装箱总数",
  containersTracked: "已追踪集装箱",
  averageDelay: "平均延误",
  shipmentsTracked: "已追踪运输件",
  currentVesselsWithShipmentsBeingTracked: "当前正在追踪运输件的船舶",
  ctaDate: "CTA 日期",
  teu: "TEU",
  atd: "ATD",
  actualTimeOfDeparture: "实际出发时间",
  etaDate: "ETA 日期",
  arrivalDate: "到达日期",
  via: "经由",
  customerEmail: "客户电子邮件",
  estimatedDate: "预计日期",
  estimatedTimeOfPortArrival: "预计到港时间",
  estimatedTimeOfAirportArrival: "预计到达机场时间",
  companyLogo: "公司标志",
  yourShipmentIsExpectedToArriveAt: "您的运输件预计将到达",
  poweredBy: "技术支持",
  localTime: "当地时间",
  booked: "已预订",
  collectedFromShipper: "已从发货人处提取",
  notArrivedAtPortOfLoad: "尚未到达装货港",
  waitingAtPortOfLoad: "在装货港等待",
  shippedOnBoard: "已装船",
  underway: "在途中",
  underwayToATranshipmentPort: "前往转运港途中",
  arrivalAtTranshipmentPort: "到达转运港",
  waitingAtTranshipmentPort: "在转运港等待",
  shippedOnBoardAtTranshipmentPort: "在转运港已装船",
  arrivedAtPortOrDischarge: "到达港口或卸货",
  waitingAtDestinationPort: "在目的港等待",
  leftTheDestinationPort: "已离开目的港",
  shipmentCompleted: "运输件已完成",
  maerskCode: "Maersk 代码",
  maerskBeCode: "Maersk BE 代码",
  clientCode: "客户代码",
  addressCode: "地址代码",
  divisionCode: "事业部代码",
  divisionDescription: "事业部描述",
  departmentCode: "部门代码",
  departmentDescription: "部门描述",
  sscc: "SSCC",
  ssccQuantity: "SSCC 数量",
  quantityUnit: "数量单位",
  purchasePrice: "采购价格",
  style: "款式",
  colour: "颜色",
  size: "尺寸",
  expand: "展开",
  deleteThisSsccAndYourProducts: "删除此 SSCC 及其产品",
  purchaseOrders: "采购订单",
  addNewOrder: "添加新订单",
  orderDate: "订单日期",
  shipper: "发货人",
  readyForBooking: "可预订",
  selectOrdersBelowToAddThem: "选择以下订单进行添加",
  expectedStartDate: "预计开始日期",
  expectedEndDate: "预计结束日期",
  assigned: "已分配",
  bookByDate: "预订截止日期",
  createBooking: "创建预订",
  confirmed: "已确认",
  underReview: "审核中",
  received: "已接收",
  pending: "待处理",
  loadingBookings: "正在加载预订",
  scanned: "已扫描",
  noThanks: "不，谢谢",
  cancelBooking: "取消预订",
  areYouSureYouWantToCancelTheBooking: "您确定要取消该预订吗",
  scannedItems: "已扫描物品",
  thisOrderIsCancelled: "该订单已取消",
  packingType: "包装类型",
  conditionAtOrigin: "始发地状况",
  conditionAtDestination: "目的地状况",
  conditionsAtOrigin: "始发地状况",
  conditionsAtDestination: "目的地状况",
  conditionAt: "状况：",
  upgradeVersionToDoThis: "请升级版本以执行此操作",
  viewProduct: "查看产品",
  hscode: "HSCODE",
  unitPrice: "单价",
  totalPrice: "总价",
  shipDate: "发运日期",
  fobPrice: "FOB 价格",
  createSSCC: "创建 SSCC",
  newSSCCwasCreated: "新 SSCC 已创建！",
  finish: "完成",
  closeSSCC: "关闭 SSCC",
  noInformations: "暂无信息",
  itsCurrentlyLocatedAt: "目前位于",
  atPosition: "在坐标",
  asReportedByMarineTrafficTerrestrialAutomaticIdentificationSystem:
    "据 MarineTraffic 陆基自动识别系统报告于",
  theVesselIsCurrentlyAtPort: "该船舶目前在港口",
  afterAVoyageOriginatingFromPort: "在从港口出发的航程之后",
  currentLocation: "当前位置",
  delayTime: "延误时间",
  newETA: "新 ETA",
  sendTrackingLinkToACustomer: "向客户或其他人发送追踪链接",
  areYouSureYouWantToCloseThisSSCC: "您确定要关闭此 SSCC 吗？",
  thisActionCannotBeUndoneAndIfYouWantToModifyThisSSCCYouMustDeleteItAndCreateANewOne:
    "此操作无法撤销，如需修改此 SSCC，必须删除并重新创建",
  selectProductsBelowToAddThemToSSCC: "选择以下产品添加到 SSCC",
  printLabel: "打印标签",
  allSelectedSsccMustBeClosedToBePrinted: "所有选中的 SSCC 必须关闭后才能打印",
  moreContainers: "更多集装箱",
  portOfOrigin: "装货港 (PoL)",
  consignmentInfo: "托运信息",
  originAgent: "始发地代理人",
  destinationAgent: "目的地代理人",
  estimateTimeOfDeparture: "出发时间",
  estimateTimeOfArrival: "到达时间",
  atDepartureDock: "在出发码头",
  inactivateWaybill: "停用运单",
  inactiveWaybill: "非活跃运单",
  pleaseAddAValidContainerNumber: "请输入有效的集装箱号",
  waitingForUpdate: "等待更新",
  generated: "已生成",
  containerNumberIsInvalid: "集装箱号无效",
  itemConditions: "物品状况",
  addAPhoto: "添加照片",
  conditionsAdded: "状况已添加",
  noConditions: "无状况记录",
  noPhotosAdded: "未添加照片",
  itemDescription: "物品描述",
  pleaseSelectADescriptiveSymbol: "请选择描述符号",
  cbm: "CBM",
  submitted: "已提交",
  rejected: "已拒绝",
  partiallyDelivered: "部分交付",
  bookingMustBeConfirmed: "预订必须确认",
  notificationCentre: "通知中心",
  notificationCenter: "通知中心",
  addEmailTemplate: "添加电子邮件模板",
  from: "发件人",
  subject: "主题",
  bcc: "密送",
  createNewTemplate: "创建新模板",
  templateName: "模板名称",
  newTemplate: "新建模板",
  emailDetails: "电子邮件详情",
  emailContent: "电子邮件内容",
  editEmailTemplate: "编辑电子邮件模板",
  viewEmailTemplate: "查看电子邮件模板",
  smsDetails: "短信详情",
  smsContent: "短信内容",
  pushNotificationDetails: "推送通知详情",
  pushNotificationContent: "推送通知内容",
  use178CharactersOrLessForBestDisplay: "使用 178 个字符以内以获得最佳显示效果",
  smsCharacterLimitHint: "超过 168 个字符的短信将被拆分为多条消息。",
  selectATemplate: "选择模板",
  addSMSTemplate: "添加短信模板",
  editSMSTemplate: "编辑短信模板",
  viewSMSTemplate: "查看短信模板",
  quoteCreation: "报价创建",
  quoteApproval: "报价审批",
  quoteDecline: "报价拒绝",
  ordersCreation: "订单创建",
  orderDelivered: "订单已交付",
  orderCancelled: "订单已取消",
  createNewDocument: "创建新文档",
  documentGenerated: "文档已生成",
  resendInvite: "重新发送邀请",
  downloadBookingFile: "下载预订文件",
  createAndBook: "创建并预订",
  saveAndBook: "保存并预订",
  editBooking: "编辑预订",
  viewBooking: "查看预订",
  liveAnimalsAndFish: "活体动物和鱼类",
  cerealGrains: "谷物",
  otherAgriculturalProducts: "其他农产品",
  feedAndProductsOfAnimalOrigin: "饲料及动物源性产品",
  meatAndSeafood: "肉类和海鲜",
  milledGrainProducts: "磨制谷物产品",
  otherPreparedFoodstuffs: "其他加工食品",
  alcoholicBeverages: "酒精饮料",
  tobaccoProducts: "烟草产品",
  buildingStone: "建筑石材",
  naturalSands: "天然砂",
  gravelAndCrushedStone: "砾石和碎石",
  otherNonmetallicMinerals: "其他非金属矿物",
  metallicOres: "金属矿石",
  coal: "煤炭",
  crudePetroleum: "原油",
  gasolineKeroseneAndEthanol: "汽油、煤油和乙醇",
  dieselAndOtherFuelOils: "柴油和其他燃油",
  otherFossilFuelProducts: "其他化石燃料产品",
  basicChemicals: "基础化工品",
  pharmaceuticalProducts: "药品",
  fertilizers: "化肥",
  chemicalProductsAndPreparations: "化工产品和制剂",
  plasticsAndRubber: "塑料和橡胶",
  logsAndWoodInTheRough: "原木和粗加工木材",
  woodProducts: "木材产品",
  pulpPaperAndPaperboard: "纸浆、纸张和纸板",
  paperOrPaperboardArticles: "纸张或纸板制品",
  printedProducts: "印刷品",
  textilesAndLeather: "纺织品和皮革",
  nonmetallicMineralProducts: "非金属矿物产品",
  metalInBasicShapes: "基本形状金属",
  articlesOfMetal: "金属制品",
  machinery: "机械",
  electronics: "电子产品",
  motorizedAndOtherVehicles: "机动车及其他车辆",
  otherTransportationEquipment: "其他运输设备",
  precisionInstruments: "精密仪器",
  furniture: "家具",
  miscellaneousManufacturedProducts: "杂项制成品",
  wasteAndScrap: "废料和废品",
  mixedFreight: "混合货物",
  commodity: "商品",
  fillThisFieldBeforeAddingAnotherContainer: "请在添加另一个集装箱之前填写此字段",
  youShouldHaveAtLeastOneProductInsideAnSSCCToCloseIt:
    "关闭 SSCC 前至少需要包含一个产品",
  thisSupplierIsPartOfShipeezi: "该供应商已是 Shipeezi 成员",
  supplierNotFound: "未找到供应商",
  thisSupplierNotHaveNameToSendInvitation: "该供应商没有名称，无法发送邀请",
  thisSupplierDoesNotHaveAnEmailToSendInvitation:
    "该供应商没有电子邮件，无法发送邀请",
  emails: "电子邮件",
  youCannotInviteInactiveSuppliers: "无法邀请非活跃供应商",
  financials: "财务",
  communicationCentre: "通讯中心",
  communication_centre: "通讯中心",
  notificationTemplates: "通知模板",
  communicationCentreDescription:
    "在一个集中位置管理您的通讯模板、通知和设置。",
  templateCreatedSuccessfully: "模板创建成功",
  templateUpdatedSuccessfully: "模板更新成功",
  templateDuplicatedSuccessfully: "模板复制成功",
  errorCreatingTemplate: "创建模板时出错",
  duplicateTemplate: "复制模板",
  editTemplate: "编辑模板",
  preFilled: "预填",
  emailTemplates: "电子邮件模板",
  emailTemplate: "电子邮件模板",
  manageEmailTemplatesDescription:
    "创建和管理各种通讯需求的电子邮件模板。",
  smsTemplates: "短信模板",
  smsTemplate: "短信模板",
  pushContentCannotExceed: "推送通知内容不能超过 178 个字符",
  smsContentCannotExceed: "短信内容不能超过 168 个字符",
  manageSmsTemplatesDescription: "创建和管理短信模板，用于快速通知。",
  manageNotificationsDescription: "配置通知偏好和设置。",
  communicationSettings: "通讯设置",
  configureCommunicationSettingsDescription:
    "设置通讯偏好和发送选项。",
  clickToManage: "点击管理",
  searchTemplates: "搜索模板...",
  noTemplatesFound: "未找到模板",
  content: "内容",
  availableIn: "可用于",
  areYouSureYouWantToChangeTheStatus: "您确定要更改状态吗？",
  beneficiaryDetails: "收款人详情",
  beneficiaryBank: "收款银行",
  accountNumber: "账号",
  invoiceNumber: "发票号码",
  invoiceNo: "发票号",
  ciDate: "CI 日期",
  financialsUpdatedSuccessfully: "财务信息更新成功",
  yourShipmentInformationIsLoading: "您的运输件信息正在加载",
  conditionAddedSuccessfully: "状况添加成功",
  atDestination: "在目的地",
  someSelectedSupplierHasNoName: "部分选中的供应商没有名称",
  someSelectedSupplierDoesNotHaveAnEmail: "部分选中的供应商没有电子邮件",
  allSelectedSuppliersMustHaveNameEmailAndNotYetBelongToShipeezi:
    "所有选中的供应商必须有名称、电子邮件，且尚未加入 Shipeezi",
  photoAddedSuccessfully: "照片添加成功",
  generalSettings: "通用设置",
  invalidTag: "无效标签",
  removeOrder: "移除订单",
  houseAirWaybill: "分运单",
  removeSelected: "移除所选",
  createWarehouse: "创建仓库",
  noWarehousesToShow: "暂无仓库可显示",
  statusUpdatedSuccessfully: "状态更新成功",
  supplierPortal: "供应商门户",
  youreReadyToGo: "准备就绪！",
  goToLoginPage: "前往登录页面",
  onUploadedCsvWeHaveFoundSomeErrors: "在上传的 CSV 中发现一些错误",
  youShouldAdjustThoseLinesToproceed: "请调整相关行后继续",
  youreNowPartOfOurPortal: "您现在已加入我们的门户！",
  ssccGeneration: "SSCC 生成",
  mustHave: "必须包含",
  digit: "位",
  digits: "位",
  extensionDigit: "扩展位",
  gs1CompanyCode: "GS1 公司代码",
  checkDigit: "校验位",
  columnMustBeFilled: "列必须填写",
  notFound: "未找到",
  isNotValid: "无效",
  carton: "纸箱",
  alreadyHasTheLimitOfProductsInside: "已达到内含产品数量上限",
  thereAreNoRecordsInThisFile: "此文件中没有记录",
  importance: "重要性",
  important: "重要",
  notImportant: "不重要",
  markAsUnread: "标记为未读",
  markAsRead: "标记为已读",
  markAsImportant: "标记为重要",
  unmarkAsImportant: "取消重要标记",
  importantNotifications: "重要通知",
  markAllAsRead: "全部标记为已读",
  seeAllNotifications: "查看所有通知",
  ssccOpen: "SSCC 已开启",
  contactVia: "通过以下方式联系",
  orderedQuantity: "订购数量",
  percentage: "百分比",
  areYouSureYouWantToConfirmThisBooking: "您确定要确认此预订吗",
  onceConfirmedThisWillBeSentTo: "确认后将发送至",
  youAreNotAbleToMakeAnyAdditionalChanges: "您无法进行任何其他更改",
  valueShouldBeBetween: "值应介于",
  valueShouldBe: "值应为",
  someQuantitiesFulilledAreWrongPleaseReviewAndChangeValues:
    "部分已完成数量有误。请检查并修改。",
  areYouSureYouWantToDeleteThisShipment: "您确定要删除此运输件吗",
  yesDeleteShipment: "是的，删除此运输件",
  editWaybill: "编辑运单",
  createWaybill: "创建运单",
  youCannotAddTheSameAgent: "您不能添加相同的代理人",
  saveAndSubscribe: "保存并订阅",
  theProductsMustBelongToTheSameOrder: "产品必须属于同一订单",
  youShouldSelectTheProducts: "请选择产品",
  haveProductsFromMultipleOrders: "包含来自多个订单的产品",
  portOfLoading: "装货港",
  portOfDischarge: "卸货港",
  placeOfReceipt: "收货地",
  shipperDischargeAirport: "发货人卸货机场",
  shipperReceiptAirport: "发货人收货机场",
  cargoReadyDate: "货物备妥日期",
  hasAlreadyBeenAssigned: "已被分配",
  isMissingShipByDate: "缺少发货日期",
  shipByDateIsToEarlyForBooking: "发货日期对于预订来说过早",
  shipByDateIsToLateForBooking: "发货日期对于预订来说过晚",
  office: "办公室",
  offices: "办公室",
  notifyParty: "通知方",
  youMustSelectABookingModeFirst: "请先选择预订模式",
  isDifferentFromBooking: "与预订不同",
  youMustSelectABookingLoadingPortFirst: "请先选择预订装货港",
  youMustSelectABookingDestinationPortFirst: "请先选择预订目的港",
  orderAssociated: "关联订单",
  selectOrder: "选择订单",
  youMustSelectABookingDischargePortFirst: "请先选择预订卸货港",
  youMustSelectedABookingCargoReadyDateFirst: "请先选择预订货物备妥日期",
  mustHaveFourteenDifferenceAtMaxFromCargoReadyDate:
    "与货物备妥日期的最大差异不得超过14天",
  theLimitOfProductsInsideACartonIs: "纸箱内产品数量的上限为",
  tolerancePercentage: "容差百分比",
  activatingThisWillControlTheTolerancePercentageOfProductsInsideABookingToTheDefinedValue:
    "启用此功能将把预订中产品的容差百分比控制在设定值内。",
  theInputValueWillBeConvertedIntoAPercentage:
    "输入值将被转换为百分比",
  youNeedToMatchTheToleranceOfTheRequestedQuantities:
    "您需要匹配所需数量的容差",
  atLeastOneCartonIsRequiredToCarryOutTheBooking:
    "至少需要一个纸箱才能执行预订",
  allCartonsMustContainAtLeastOneProduct: "所有纸箱必须包含至少一种产品",
  valueMustBeGreaterThanZero: "*值必须大于零",
  allSelectedProductsMustMeetTheCriteria: "所有选定的产品必须满足条件",
  thisValueMustBeAnInteger: "*此值必须为整数",
  shipByDate: "发货日期",
  bookedVolume: "预订体积",
  receivedVolume: "已收体积",
  bookedWeight: "预订重量",
  receivedWeight: "已收重量",
  ssccQuantityBooked: "SSCC 预订数量",
  ssccQuantityReceived: "SSCC 已收数量",
  theValuesWereTheSame: "值相同",
  lessThanBooked: "少于预订",
  moreThanBooked: "多于预订",
  volumeAndWeight: "体积和重量",
  insertTotalValue: "输入总值",
  insertValuesOf: "输入以下项的值",
  defineTotalValueOfSSCCs: "设定 SSCC 总值",
  defineValuesOfOneSSCC: "设定单个 SSCC 的值",
  SSCCCBM: "SSCC CBM",
  SSCCWeight: "SSCC 重量",
  valueMustBeWithin10OfSupplierValue: "* 抱歉！值必须在供应商值的 -/+ 10% 范围内。",
  notReceived: "未收到",
  receiveSSCC: "接收 SSCC",
  changeIt: "更改",
  theBookingWillBeSentBackToTheSupplier: "预订将被退回给供应商",
  areYouSureYouWantToChangeThisBookingStatusTo:
    "您确定要将此预订状态更改为",
  receiveAllSSCC: "接收全部 SSCC",
  closeIt: "关闭",
  areYouSureYouWantToMarkThisSSCCAsReceived: "您确定要将此 SSCC 标记为已接收吗",
  youAreAboutMarkAllSSCCAsReceived: "您即将把所有 SSCC 标记为已接收",
  areYouSure: "您确定吗",
  thisActionCannotbeUndone: "此操作不可撤销",
  yesReceiveAll: "是的，全部接收",
  yesReceiveSSCC: "是的，接收 SSCC",
  allCartonsHaveAlreadyBeenMarkedAsReceived: "所有纸箱均已标记为已接收",
  bookingSummary: "预订摘要",
  downloadBookingData: "下载预订数据",
  downloadReport: "下载报告",
  manageSSCC: "管理 SSCC",
  closeSSCCs: "关闭 SSCC",
  areYouSureYouWantToClosethese: "您确定要关闭这些",
  thisActionCannotBeUndoneAndIfYouWantToModifyTheseSSCCsYouMustDeleteItAndCreateNewOnes:
    "此操作无法撤销，如需修改这些 SSCC，您必须删除后重新创建",
  allSSCCsMustBeReceived: "所有 SSCC 必须已接收",
  planned: "已计划",
  allCartonsShouldBeClosedToCarryOutTheBooking:
    "所有纸箱应已关闭才能执行预订",
  unavailableNotification: "通知不可用",
  shipeeziPredicts: "Shipeezi 预测",
  carrierShipeeziPredicts: "承运商 Shipeezi 预测",
  allSSCCMustHaveProductsInsideThemToBeClosed:
    "所有 SSCC 内必须有产品才能关闭",
  photosOf: "的照片 ",
  generalComments: "一般备注",
  valueMustBeEqualToTheSupplierValue: "值必须等于供应商的值",
  beCode: "BE代码",
  pleaseEnteraValidBecode: "请输入有效的 BE Code",
  sendTaskToSistrs: "发送任务到 SISTRS",
  beCodeSupplierExample: "AUDASHING3 VDR",
  beCodeCustomerExample: " AUTHECOTT4 HQ",
  totalSSCC: "SSCC 总计",
  markBookingAs: "将预订标记为",
  selectATriggerFirst: "请先选择触发条件",
  default: "默认",
  commercialInvoice: "商业发票",
  beneficiaryName: "受益人名称",
  beneficiaryAddress: "受益人地址",
  vatNumber: "增值税号",
  eori: "EORI -",
  fiscalAgentDetails: "税务代理详情",
  salesContractNumber: "销售合同编号",
  salesContractDate: "销售合同日期",
  expNumber: "EXP 编号",
  bankName: "银行名称",
  bankAddress: "银行地址",
  swiftCode: "Swift代码",
  paymentTerms: "付款条件",
  termsOfDelivery: "交货条款",
  udNumber: "UD 编号",
  ercNumber: "ERC 编号",
  rexNumber: "REX 编号",
  commercialInvoiceDetails: "商业发票详情",
  cfsReview: "CFS 审核",
  receivedByCFS: "CFS 已接收",
  lining: "衬里",
  construction: "结构",
  category: "类别",
  fabric: "面料",
  styleCode: "款式代码",
  brand: "品牌",
  manufacturerDetails: "制造商详情",
  composition: "成分",
  downloadAllFiles: "下载所有文件",
  areYouSureYouWantToRemoveThe: "您确定要移除",
  fromThisBooking: "从此预订中",
  removePurchaseOrder: "移除采购订单",
  allSSCCsInsideThePurchaseOrderWillAlsoBeRemoved:
    "采购订单中的所有 SSCC 也将被移除",
  yesRemoveIt: "是的，移除",
  markAndNumbers: "标记和编号",
  limited: "有限",
  characters: "个字符",
  saveEdit: "保存编辑",
  cancelEdit: "取消编辑",
  purchaseOrderNumber: "采购订单编号",
  cartonName: "纸箱名称",
  quotesStatus: "报价状态",
  someInformationOfThisSkuAreMissing: "此 SKU 的部分信息缺失",
  writeHere: "在此输入",
  createNewRow: "创建新行",
  noRowsCreatedYet: "尚未创建任何行",
  noData: "暂无数据",
  estimatedQuote: "预估报价",
  yourEstimateQuoteInformationIsLoading: "您的预估报价信息正在加载...",
  youAreAboutToApproveThisEstimateAreYouSure:
    "您即将批准此预估报价。确定吗？",
  reasonForDeclining: "拒绝原因",
  reasonForReview: "审核原因",
  estimateQuoteHasBeenApproved: "预估报价已批准",
  thankYouSoMuchForApprovingTheEstimateWithUs:
    "非常感谢您批准了我们的预估报价",
  cantDeliverOrderWithBookedStatus: '无法交付状态为"已预订"的订单',
  selectedPrice: "选定价格：",
  estimateQuoteHasBeenDeclined: "预估报价已被拒绝",
  thisEstimateQuoteHasBeenSentToReview: "此预估报价已提交审核",
  weAreVerySorryThatTheQuoteWasNotAsExpectedWeHopeYouCanTryAgainAndEverythingGoesWell:
    "非常抱歉预估报价未达到您的预期。希望您能再次尝试，一切顺利。",
  shipeeziWillAlwaysBeHereWithYou: "Shipeezi 将一直与您同在",
  weHaveAlreadyNotifiedTheResponsibleCompanyThatThereAreRevisionsToBeMadeAndIfEverythingGoesCorrectlyYouWillReceiveAReturnShortly:
    "我们已通知相关公司需要进行修改，如果一切顺利，您很快就会收到回复。",
  saveAndSendToCustomer: "保存并发送给客户",
  youHaveToChooseAPriceInTheQuoteTab: "请在报价选项卡中选择价格",
  youHaveToChooseAPaymentMethodInTheQuoteTab:
    "请在报价选项卡中选择付款方式",
  noItems: "无项目",
  theFieldIsEmpty: "该字段为空",
  addNewMaterial: "添加新材料",
  destinations: "目的地",
  show: "显示",
  taskAdded: "任务已添加",
  documentCreatedSuccessfully: "文件创建成功",
  documentsUploadedSuccessfully: "文件上传成功",
  noCommunicationOptionSelected: "未选择通信方式",
  notificationSent: "通知已发送",
  searchForLocation: "搜索地点",
  noNotificationsForNow: "暂无通知",
  notificationsWillAppearHereWhenThereAreAnyUpdatesToTheTasksYouAreInvolvedIn:
    "当您参与的任务有更新时，通知将在此显示。",
  markAndNumbersShouldHaveAtLeastOneFilledLine:
    "标记和编号应至少填写一行",
  theEstimatedQuoteWasSuccessfullyShared: "预估报价已成功分享",
  noItemsInQuotedInventory: "报价库存中无项目",
  of: "的",
  reportsTo: "汇报给",
  changeStatusesTo: "将状态更改为",
  onlyBookingsWithReceivedByCFSCanChangeToReceivedStatus:
    '只有状态为"CFS 已接收"的预订才能更改为"已接收"状态',
  theLinkHasExpired: "链接已过期",
  theEstimatedQuoteLinkHasExpired: "预估报价链接已过期。",
  youCanRequestANewOneByClickingOnTheButtonBellow:
    "您可以点击下方按钮请求新链接。",
  requestNewLink: "请求新链接",
  requestedNewLinkSuccessfully: "已成功请求新链接",
  whatDoYouWantToSendToCustomer: "您想发送什么给客户？",
  shareViaVideoSurveyInvite: "通过视频勘查邀请分享",
  sendANewInvitationToTheScheduledVideoSurvey:
    "向已安排的视频调查发送新邀请",
  shareViaEstimatedQuoteLink: "通过预估报价链接分享",
  sendTheExternalLinkOfEstimatedQuote: "发送预估报价的外部链接",
  thisQuoteDoesNotHaveAValidVideoSurveyTask: "此报价没有有效的视频勘查任务",
  thisQuoteDoesNotHaveAnEstimate: "此报价没有预估",
  createNewOffice: "创建新办公室",
  editOffice: "编辑办公室",
  officeStatus: "办公室状态",
  selectAtLeastOnePort: "请至少选择一个港口",
  city: "城市",
  viewPort: "查看港口",
  siteCode: "站点代码",
  locationName: "地点名称",
  portStatus: "港口状态",
  site: "站点",
  cityCode: "城市代码",
  bookings: "预订",
  theInvitationWasSuccessfullySent: "邀请已成功发送",
  youMustBeLoggedInToSeeTheInvitation: "您必须登录才能查看邀请！",
  youHaveReachedTheEndOfNotifications: "您已查看所有通知",
  youHaventAddedAnyPriceYet: "您还没有添加任何价格。",
  automaticallyApprove: "自动批准",
  addSignatureForEveryPage: "为每页添加签名",
  addSignatureForOwnerAndLeaderForEveryPageOfReportsInsteadOfTheLastOne:
    "为报告的每一页（而非仅最后一页）添加负责人和主管的签名",
  whenTheUserApprovesHisQuoteThisWillAutomaticallyUpdateTheQuoteOnTheSystem:
    "当用户批准其报价时，系统将自动更新该报价。",
  salesAndOPS: "销售和运营",
  sales: "销售",
  ops: "OPS",
  onFieldStaff: "现场员工",
  theCartonCanOnlyContainProductsOfTheSameTypeAndColor:
    "纸箱只能包含相同类型和颜色的产品",
  yourCompanyLogoAndIconRepresentYourBrandIdentityAndValuesThisWillBeUsedInAllCommunicationsAndDocumentsSoItWouldBeGoodToUpload:
    "您的公司标志和图标代表您的品牌形象和价值观。它们将用于所有通信和文件中，建议上传。",
  downloadOurCsvTemplate: "下载我们的 CSV 模板",
  csvActions: "CSV 操作",
  leavingOnboarding: "退出引导流程",
  youAreAboutToExitTheOnboardingProcessAreYouSureYouWantToDoThis:
    "您即将退出引导流程。确定要这样做吗？",
  rememberThatYouWillOnlyBeAbleToUseTheSystemAfterCompletingThisProcess:
    "请注意，只有完成此流程后才能使用系统。",
  branchName: "分支机构名称",
  branchAddedSuccessfully: "分支机构添加成功！",
  viewBranches: "查看分支机构",
  inShipeeziYouCanManageBranchesPhysicalLocationsOfYourBusinessAMinimumOf:
    "在 Shipeezi 中，您可以管理分支机构（您的业务实体地点）。至少需要",
  oneBranch: "1 个分支机构",
  mustBeRecorded: "必须被记录。",
  resubmitToMODS: "重新提交至 MODS",
  cantSubmitCancelledBookings: "无法提交已取消的预订",
  cantDownloadCancelledBookings: "无法下载已取消的预订",
  bookingsSubmittedSuccessfully: "预订提交成功",
  areYouSureYouWantToReSubmitTheSelectedBookings:
    "您确定要重新提交所选预订吗？",
  theBookingFileWillBeSentWithAUpdateStatus: "预订文件将以更新状态发送",
  submit: "提交",
  addShipment: "添加运输件",
  noShipmentAssociatedYet: "尚未关联运输件",
  addShipmentToOrder: "将运输件添加到订单",
  removed: "已移除",
  thisProductWasRemovedFromTheOrder: "此产品已从订单中移除",
  networkVisible: "网络可见",
  partner: "合作伙伴",
  uploadImage: "上传图片",
  thisImageWillBeUsedWhenGeneratingCommercialInvoiceAndPackingListDocumentsBeingUsedAsAnEsignature:
    '此图片将在生成"商业发票"和"装箱单"文件时用作电子签名。',
  hereYouCanChooseWheterToSeeTheNetworkAndHaveTheOptionToSelectAndAgent:
    "在此您可以选择是否查看网络并选择代理人作为运输件的合作伙伴。如果选择了代理人，我们将不会向客户发送任何通信。",
  doYouHaveAgentShipeeziNetworkKey: "您有代理人的 Shipeezi 网络密钥吗？",
  agentShipeeziNetworkToken: "代理人的 Shipeezi 网络令牌",
  thisShipmentHasAPartner: "此运输件有合作伙伴",
  myAccount: "我的账户",
  orderCancelledSuccessfully: "订单取消成功",
  prime: "Prime",
  managePlan: "管理方案",
  lastInvoice: "最近发票",
  seeInvoiceHistory: "查看发票历史",
  invoiceAmount: "发票金额",
  amountOwing: "欠款金额",
  billingDate: "账单日期",
  manage: "管理",
  userType: "用户类型",
  deductibleQty: "可抵扣数量",
  extraQty: "额外数量",
  quantityUsed: "已使用数量",
  costPerExtraUnit: "每额外单位费用",
  totalValue: "总价值",
  addons: "附加服务",
  addOn: "附加服务",
  dueDate: "到期日",
  amount: "金额",
  currentAccountAmountOwing: "当前账户欠款金额",
  nextBillingDate: "下次账单日期",
  billingCountry: "账单国家",
  needToCancelYourSubscription: "需要取消您的订阅",
  cancelSubscription: "取消订阅",
  pleaseNotThatOurPricesAreGSTExclusiveGSTWillBeBilledToAustraliaCustomers:
    "请注意，我们的价格不含 GST。除非提供有效的 GST 注册澳大利亚商业编号 (ABN)，否则将向澳大利亚客户收取 GST",
  weKnowCircumstancesCanStometimesChange: "我们理解情况有时会发生变化",
  butBeforeYouGoHaveYouTriedOur: "但在您离开之前，您是否尝试过我们的",
  forTechnicalFAQ: "查看技术常见问题",
  knowledgeBase: "知识库",
  invoiceHistory: "发票历史",
  invoiceID: "发票 ID",
  seeInvoice: "查看发票",
  noKeepSubscription: "不，保留订阅",
  areYouSureYouWantToCancelYourSubscription: "您确定要取消订阅吗",
  ifYouAreInDoubtWeOfferOtherPlansAsWell:
    "如果您有疑虑，我们还提供其他方案，请浏览方案以了解我们的功能。",
  byChoosingToCancelARequestWillBeSentToTeamAndThe:
    "选择取消后，将向团队发送请求并开始退出流程。",
  weAreSorryToSeeYouGo: "很遗憾看到您离开！",
  aCancellationRequestHasBeenSentToTheTeamAndWeWillContactYouShortlyToContinueTheOffBoardProcedure:
    "取消请求已发送给团队，我们将尽快与您联系以继续退出流程。",
  youCanLogoutNow: "您现在可以退出登录",
  paid: "已付款",
  uncollectible: "无法收回",
  waitingForPayment: "等待付款",
  planSummary: "方案摘要",
  wantToChangeYourPlan: "想更换您的方案",
  contactSales: "联系销售",
  contactSupport: "联系支持",
  ifYouWantToUpgradeOrDowngradeYourPlanPlease:
    "如果您想升级或降级您的方案，请",
  youDontHaveAnyInvoicesYetWhenAnInvoiceIsGeneratedYoullSeeItHere:
    "您还没有任何发票。生成发票后会在此显示。",
  thisShipmentHasAnAgent: "此运输件有代理人",
  containerSizeType: "集装箱尺寸和类型",
  addOrderToShipment: "将订单添加到运输件",
  uploadYourFile: "上传您的文件",
  maxImageSize: "最大图片大小",
  changePicture: "更换图片",
  ExporterInformationIsDifferentFromTheVendor: "出口商信息与供应商不同",
  exporterName: "出口商名称",
  exporterContactDetails: "出口商联系方式",
  canBeJust: "可以仅为 ",
  or: "或",
  companies: "公司",
  ThisProcessIsRecommendedForCompaniesThatHave10OrMoreUsersButOnlyAdminAndGeneralRolesAreAvailableInThisStep:
    "此流程推荐给拥有10名及以上用户的公司，但此步骤仅提供管理员和普通角色。",
  introduction: "介绍",
  welcomeToShipeezi: "欢迎使用 Shipeezi！",
  unleashThePowerOfYourNewSoftware: "释放新软件的力量——仅需几步！",
  wereConfidentThatYoullFindOurPlatformToBeAnInvaluableTool:
    "我们相信您会发现我们的平台是消除碎片化并为您的运营提供端到端可视性的宝贵工具。让我们开始吧。",
  firstlyLetsAddYourCompanyDetailsToYourAccountIncludingBusinessAddress:
    "首先，让我们将您的公司详细信息添加到账户中，包括办公地址、电话号码、主要联系人和邮箱信息。",
  nextWellSetUpYourCompanyUsersAndDefineTheirPermissionsAndAccessLevels:
    "接下来，我们将设置公司用户并定义其权限和访问级别。",
  finallyWellAskYouToUploadPreliminaryInformationToAssistOurTeamWithConnectingYourDataStreams:
    "最后，我们会请您上传初步信息，以帮助我们的团队连接您的数据流。",
  deleteComment: "删除评论",
  areYouSureYouWantToDeleteThisComment: "您确定要删除此评论吗？",
  itLooksLikeTheresNoCommentsYet: "目前还没有评论",
  feelFreeToAddAnyCommentsYouFeelNecessary: "请随意添加您认为必要的评论",
  typeHereYourNote: "在此输入备注...",
  notifyPartyStatus: "通知方状态",
  editNotifyParty: "编辑通知方",
  viewNotifyParty: "查看通知方",
  createNotifyParty: "创建通知方",
  searchForAgent: "搜索代理人",
  bodyOfEmail: "邮件正文",
  bodyOfSMS: "短信正文",
  cartons: "纸箱",
  custom: "自定义",
  customTime: "自定义时间",
  shipeeziBilling: "Shipeezi 账单",
  theExtraQuantityIsTheDifferenceBetweenTheQuantityUsedAndDeductibleQty:
    '额外数量是"已使用数量"和"可抵扣数量"之间的差值',
  templateDetails: "模板详情",
  youCannotCreateATemplateWithABrokenTag: "不能创建包含无效标签的模板",
  receiveUsingCSV: "使用 CSV 接收",
  couldNotFoundSSCC: "未找到 SSCC",
  searchForAContact: "搜索联系人",
  setTemplateAsDefault: "设为默认模板",
  ssccNotFound: "未找到 SSCC",
  ssccFound: "已找到 SSCC",
  setAsDefault: "设为默认",
  yesChangeIt: "是的，更改",
  changeDefault: "更改默认",
  doYouWantToMakeTheSelectedTemplateTheDefault:
    "您要将所选模板设为默认吗？",
  theCurrentDefaultForThisTypeWillBeReplaced: "此类型的当前默认模板将被替换。",
  youCanChangeItBackLaterIfYouWant: "如需要，您可以稍后改回。",
  cartonStatus: "纸箱状态",
  weightAndCBMOfThisBookingMustBeConfirmedBeforeThisCanBeDone:
    "执行此操作前必须确认此预订的重量和 CBM，您可以在 CBM 和重量选项卡中调整值",
  allSSCCMustBeReceived: "所有 SSCC 必须已接收",
  confirmAndReceive: "确认并接收",
  allSSCCsFromCsvWereMarkedAsReceived: "CSV 中的所有 SSCC 已标记为已接收",
  boxesCouldntBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain:
    "箱子无法标记为已接收。请检查仓库扫描数据文件中的所有错误，然后重试",
  NoneSSCCsCouldBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain:
    "没有 SSCC 能被标记为已接收。请检查仓库扫描数据文件中的所有错误，然后重试",
  attention: "注意",
  containerNumberIsRequired: "集装箱号为必填项",
  youShouldAddAtLeastOneOrderToTheShipment: "请至少添加一个订单到运输件",
  thisFieldMustBeGreaterThanOrEqualTo0: "*此字段必须大于或等于 0",
  dcCode: "DC 代码",
  thisIsADeliveryLocation: "这是一个交付地点",
  stayLoggedIn: "保持登录",
  aSubscribedShipmentWasUnselectedAndCannotBeRemoved:
    "已订阅的运输件被取消选择，无法移除！",
  saveAsDraft: "保存为草稿",
  tracking: "追踪",
  thereWasAProblemTryingToImportTheFilePleaseRefreshThePage:
    "导入文件时出现问题。请刷新页面后重试。",
  theFileWasSentToImport: "文件已发送导入",
  vesselPositionUpdateDailyAt5pmUTC: "船舶位置每日 UTC 时间下午 5 点更新",
  locationIndicatedAboveIsMoreAccurateIfItDiffersFromMapDisplay:
    "如上方显示的位置与地图显示不同，以上方位置为准",
  unableToExportCSVFile: "无法导出 CSV 文件",
  analytics: "分析",
  uploadDateAndTime: "上传日期和时间",
  exporter: "出口商",
  shipmentNumber: "运输件编号",
  postCode: "邮政编码",
  itemType: "物品类型",
  consignmentNumber: "托运编号",
  pieces: "件数",
  stocksToDespatch: "待发库存",
  palletsToDespatch: "待发托盘",
  deliveryWindowOpen: "交付窗口开始",
  deliveryWindowClose: "交付窗口结束",
  shippingItems: "运输物品",
  truck: "卡车",
  addExistingAddress: "添加已有地址",
  newAddress: "新地址",
  noDeliveryAddressAddedYet: "尚未添加交付地址",
  noPickupAddressAddedYet: "尚未添加取货地址",
  addresses: "地址",
  createDespatch: "创建发货",
  editDespatch: "编辑发货",
  staged: "已暂存",
  inTransit: "转运中",
  newPickUpAddress: "新取货地址",
  newDeliveryAddress: "新交付地址",
  editPickUpAddress: "编辑取货地址",
  editDeliveryAddress: "编辑交付地址",
  labelAddress: "标签地址",
  pickUpAddress: "取货地址",
  addAddresses: "添加地址",
  palletsPerTrucks: "每车托盘数",
  newShippingItem: "新运输物品",
  editShippingItem: "编辑运输物品",
  itLooksLikeThereSNoDataYet: "暂无数据",
  youWillBeAbleToSeeAllTheInformationAboutThe:
    "当您添加后，您将能看到所有关于",
  associatedWithTheDespatchWhenYouAddThem: "与发货关联的信息",
  addShippingItems: "添加运输物品",
  editTruck: "编辑卡车",
  newTruck: "新卡车",
  quantityOnHand: "现有库存数量",
  allDespatched: "全部已发货",
  available: "可用",
  youCanStartByCreatingANew: "您可以先创建一个新的",
  passwordsDoNotMatch: "密码不匹配。",
  theresNoEstimatesAvailableToView: "没有可查看的预估报价",
  userHasAccessTo: "用户可访问...",
  poConfirmedVsPOReceived: "已确认采购订单 vs 已收采购订单",
  poPastShipByDate: "超过发货日期的采购订单",
  pastShipByDate: "超过发货日期",
  pendingPurchaseOrders: "待处理采购订单",
  printReport: "打印报告",
  addTruck: "添加卡车",
  maxValueAccepted: "可接受的最大值",
  averageMonthlyCost: "月均费用",
  averageOverTheLast12MonthsExcludingTaxes: "过去12个月的平均值（不含税）",
  templates: "模板",
  youShouldAddAtLeastOnePickUpAddress: "请至少添加一个取货地址",
  youShouldAddAtLeastOneDeliveryAddress: "请至少添加一个交付地址",
  youShouldAddAtLeastOneProduct: "请至少添加一个产品",
  ayrtonSenna: "Ayrton Senna",
  positionInManufacturingCompany: "在制造公司中的职位",
  nameOfManufacturingCompany: "制造公司名称",
  egSupplier: "例如：供应商",
  egShipeezi: "例如：Shipeezi",
  searchByCountry: "按国家搜索",
  vendorId: "供应商 ID",
  countryOfOrigin: "原产国",
  accessIntructions: "访问说明",
  generateInvoice: "生成发票",
  schedule: "日程",
  associatedWithTheInvoicesWhenYouAddThem: "与发票关联的信息",
  loadingInvoices: "正在加载发票",
  consol: "拼箱",
  etaMonth: "预计到达月份",
  actualDelivery: "实际交付",
  commInvNo: "商业发票号",
  commInvDate: "商业发票日期",
  partNumber: "零件编号",
  receivedLinePrice: "接收行价格",
  invoiceExchangeRate: "发票汇率",
  audValue: "AUD 价值",
  duty: "关税",
  lineDutyAmount: "行关税金额",
  kewill: "Kewill",
  cblNo: "CBL编号",
  mawbNo: "MAWB编号",
  originCharges: "起运地费用",
  internationalFreight: "国际运费",
  destinationCharges: "目的地费用",
  totalFreightAUD: "总运费 AUD",
  unitFob: "单位 FOB",
  freightCPU: "运费 CPU",
  freightasFOB: "运费占 FOB",
  deleteInvoice: "删除发票",
  areYouSureYouWantToDeleteTheInvoice: "您确定要删除此发票吗",
  invoiceQuantity: "发票数量",
  houseBill: "分提单",
  masterBill: "总提单",
  hblCountMode: "HBL 计数模式",
  chargeCode: "费用代码",
  overseasAmount: "海外金额",
  exchangeRateCurrency: "汇率货币",
  exchangeRate: "汇率",
  invoicedLocalAmount: "已开票本地金额",
  gstAmount: "GST 金额",
  invoiceDate: "发票日期",
  invoiceDueDate: "发票到期日",
  autoRate: "自动汇率",
  cottonOnAdultsApportionment: "Cotton On Adults 分摊",
  cottonOnAdultsLocalAmount: "Cotton On Adults 本地金额",
  ceresLifeApportionment: "Ceres Life 分摊",
  ceresLifeLocalAmount: "Ceres Life 本地金额",
  bodyApportionment: "Body 分摊",
  bodyLocalAmount: "Body 本地金额",
  factorieApportionment: "Factorie 分摊",
  factorieLocalAmount: "Factorie 本地金额",
  kidsApportionment: "Kids 分摊",
  kidsLocalAmount: "Kids 本地金额",
  rubiApportionment: "Rubi 分摊",
  rubiLocalAmount: "Rubi 本地金额",
  foundationApportionment: "Foundation 分摊",
  foundationLocalAmount: "Foundation 本地金额",
  typoApportionment: "Typo 分摊",
  typoLocalAmount: "Typo 本地金额",
  gamedayApportionment: "Gameday 分摊",
  gamedayLocalAmount: "Gameday 本地金额",
  supreApportionment: "Supre 分摊",
  supreLocalAmount: "Supre 本地金额",
  fixturesApportionment: "Fixtures 分摊",
  fixturesLocalAmount: "Fixtures 本地金额",
  consumablesApportionment: "Consumables 分摊",
  consumablesLocalAmount: "Consumables 本地金额",
  otherApportionment: "其他分摊",
  otherLocalAmount: "其他本地金额",
  dateType: "日期类型",
  searchBy: "搜索方式",
  sendReportByEmail: "通过邮件发送报告",
  originCountry: "起运国",
  part: "零件",
  id: "Id",
  createSendRecurrence: "创建定时发送",
  daily: "每日",
  weekly: "每周",
  monthly: "每月",
  frequency: "频率",
  isNotAValidEmail: "不是有效的邮箱地址",
  emailScheduled: "邮件已安排",
  emailSent: "邮件已发送",
  storageStatus: "仓储状态",
  newStorageBox: "新建储物箱",
  editStorageBox: "编辑储物箱",
  newStorageBoxType: "新建储物箱类型",
  editStorageBoxType: "编辑储物箱类型",
  typeNumber: "类型编号",
  depth: "深度",
  deleteStorageBox: "删除储物箱",
  deleteStorageBoxType: "删除储物箱类型",
  areYouSureYouWantToDeleteThisStorageBox: "您确定要删除此储物箱吗",
  areYouSureYouWantToDeleteThisStorageBoxType:
    "您确定要删除此储物箱类型吗",
  createSmsTemplate: "创建短信模板",
  notBeingUsed: "未在使用",
  inUse: "使用中",
  template: "模板",
  hideCc: "隐藏抄送",
  hideBcc: "隐藏密送",
  showCc: "显示抄送",
  showBcc: "显示密送",
  sendEstimateToCustomer: "发送预估给客户",
  writeYourOwnOrChooseFromPreSetTemplates: "自行编写或从预设模板中选择",
  storageBoxesAndUnits: "储物箱和单位",
  writeYourOwnOrChooseFromTemplates: "自行编写或从模板中选择",
  movement: "移动",
  movements: "移动记录",
  objectToMove: "待移动对象",
  storageBox: "储物箱",
  looseItem: "散件",
  typeOfObject: "对象类型",
  seeObjectActivity: "查看对象活动",
  moveTo: "移至",
  object: "对象",
  moveToLocation: "移至位置",
  move: "移动",
  someObjectDetailsWillBeDisplayedWhenYouSelectIt:
    "选择对象后，部分详情将在此显示",
  noObjectSelected: "未选择对象",
  insideAStorageBox: "在储物箱内",
  seeFullDetails: "查看完整详情",
  section: "区域",
  storageBoxDetails: "储物箱详情",
  dateIntoStorage: "入库日期",
  lastMoved: "上次移动",
  isLocatedInTheCellYouAreGoingToMoveDoYouWantToContinue:
    "位于您将要移入的单元格中，是否继续？",
  isPlacedInThisLocationRightNowWouldYouLikeToMoveItToAnUnknowLocationForNow:
    '目前放置在此位置，您要将其暂时移至"未知"位置吗？',
  the: "该",
  locationIsFull: "位置已满",
  accessTo: "访问",
  rows: "行",
  columns: "列",
  levels: "层",
  createMap: "创建地图",
  editMap: "编辑地图",
  input: "输入",
  columnsQuantity: "列数",
  characterUsed: "使用字符",
  initial: "初始",
  suffix: "后缀",
  rowsQuantity: "行数",
  levelsQuantity: "层数",
  buildMap: "构建地图",
  numbers: "数字",
  alphabetical: "字母",
  ascendant: "升序",
  descendant: "降序",
  deleteMap: "删除地图",
  viewMap: "查看地图",
  areYouSureYouWantToDeleteThisMap: "您确定要删除此地图吗",
  thisFieldMustBeGreaterThanZero: "此字段必须大于零",
  mapGenerated: "地图已生成",
  topView: "俯视图",
  applySearch: "应用搜索",
  cartonCondition: "纸箱状况",
  eventDate: "事件日期",
  deliveryStore: "交付门店",
  storeNumber: "门店编号",
  estimateArriveWH: "预计到达仓库",
  arrivalFinalPort: "到达最终港口",
  meChecklist: "M&E 检查清单",
  haveYouDoneTheMEChecklistOnThisItem: "您是否已对此物品完成 M&E？",
  meChecklistDone: "M&E 检查清单已完成",
  unsetAsDefault: "取消默认设置",
  storageAccounts: "仓储账户",
  period: "周期",
  nextBilling: "下次账单",
  createNew: "新建",
  settlement: "结算",
  createNewStorageAccount: "创建新仓储账户",
  storageAccountOrder: "仓储账户订单",
  pickedUp: "已取货",
  assignLocation: "分配位置",
  assignStorageBox: "分配储物箱",
  storageSpace: "仓储空间",
  unit: "单位",
  assignStorageBoxLocation: "分配储物箱位置",
  typeStorage: "存储类型",
  storageFrom: "存储起始",
  gracePeriodEnd: "宽限期结束",
  storageEnd: "存储结束",
  selectAPaymentMethod: "选择付款方式",
  plan: "方案",
  totalGSTIncluded: "总计（含 GST）",
  extraServices: "额外服务",
  grandTotal: "总计",
  etaUnpackDate: "预计拆包日期",
  finalPortArrival: "最终港口到达",
  all: "全部",
  estimateArrivalWH: "预计到达仓库",
  selectAtLeastOneProject: "请至少选择一个项目",
  expectedQty: "预期数量",
  quantityReceived: "接收数量",
  dateReceived: "接收日期",
  selectBranch: "选择分支机构",
  selectGroup: "选择分组",
  sections: "区域",
  createNewSection: "创建新区域",
  contains: "包含",
  storageBoxType: "储物箱类型",
  selectAtLeastOneWarehouseOrSku: "请至少选择一个仓库或 SKU",
  locationPreviewStatus: "位置预览状态",
  selectNewLocation: "选择新位置",
  noMapSelected: "未选择地图",
  aLittleMapPreviewWillAppearHereWhenYouSelectTheSectionInTheObjectThatShouldBeMoved:
    "当您选择待移动对象的区域时，此处将显示小地图预览",
  unload: "卸载",
  uploadDate: "上传日期",
  viewInWarehouseMap: "在仓库地图中查看",
  changeLocation: "更改位置",
  funcionalityUnderDevelopment: "功能开发中",
  selectWhichOrderToUnload: "选择要卸载的订单",
  pleasePayAttention: "请注意！",
  onceTheOrderIsUnloadedItCannotChangeStatusAgain:
    "一旦订单被卸载，将无法再更改状态。",
  full: "已满",
  unusable: "不可用",
  couldNotFound: "未找到",
  selectAtLeastOneContainer: "请至少选择一个集装箱",
  receivedExpected: "已接收 - 预期",
  receivedUnexpected: "已接收 - 非预期",
  notReceivedExpected: "未接收 - 预期",
  clear: "清除",
  clearFields: "清除字段",
  palletDimensions: "托盘尺寸",
  cartonDimensions: "纸箱尺寸",
  minimumValue: "最小值",
  newMap: "新地图",
  theFollowingStorageBoxesAreLoadedAndCanNotChangeStatus:
    "以下储物箱已装载，无法更改状态：",
  theFollowingMapsHaveLoadedLocationsAndCanNotChangeStatus:
    "以下地图有已装载的位置，无法更改状态：",
  theFollowingWarehousesHaveSectionsWithMapsInUseAndCanNotChangeStatus:
    "以下仓库有区域的地图正在使用中，无法更改状态：",
  selectAStartDate: "选择开始日期",
  enterAtLeast: "至少输入",
  ordersHaveDifferent: "订单有不同的",
  jobNumber: "工作编号",
  commercialInvoiceNumber: "商业发票编号",
  commercialInvoiceDate: "商业发票日期",
  lineDutyPercent: "行关税百分比",
  nonAUEntryFees: "非澳入境费用",
  totalUnitCosts: "总单位成本",
  freightAUD: "运费 AUD",
  freightFob: "运费 FOB",
  new: "新建",
  shareable: "可共享",
  routePlanner: "路线规划",
  mapSettings: "地图设置",
  clearLocation: "清除位置",
  routing: "路由",
  sharedWith: "共享给",
  belongsTo: "隶属于",
  hasNoWarehouses: "没有仓库",
  belongsToWarehouse: "隶属于仓库",
  sharedWarehouses: "共享仓库",
  isNotShareable: "不可共享",
  cartonsPerPallet: "每托盘纸箱数",
  allIncluded: "全部包含",
  exampleOfTiHi: "Ti-Hi 示例",
  manufacture: "制造",
  deleteProduct: "删除产品",
  unitsInTransit: "运输中单位数",
  originShipments: "起运地运输件",
  cartonsToDespatch: "待发纸箱",
  companyCurrentStock: "公司当前库存",
  mainSupplier: "主要供应商",
  stock: "库存",
  cartonWeight: "纸箱重量",
  createProduct: "创建产品",
  byWho: "操作人",
  objectNumber: "对象编号",
  newMovement: "新建移动",
  none: "无",
  ordersQuantity: "订单数量",
  itemsInsideThisStorageBox: "此储物箱内的物品",
  bookingNumber: "预订编号",
  noLocation: "无位置",
  typeInLocation: "输入位置",
  startWarehouse: "起始仓库",
  endWarehouse: "终点仓库",
  rta: "RTA",
  addToRoutePlanner: "添加到路线规划",
  removingFromRoutePlanner: "正在从路线规划中移除",
  removeFromRoutePlanner: "从路线规划中移除",
  removedFromRoutePlanner: "已从路线规划中移除",
  addingToRoutePlanner: "正在添加到路线规划",
  addedToRoutePlanner: "已添加到路线规划",
  couldNotAddToRoutePlanner: "无法添加到路线规划",
  couldNotRemoveFromRoutePlanner: "无法从路线规划中移除",
  updatingInRoutePlanner: "正在路线规划中更新",
  updatedInRoutePlanner: "已在路线规划中更新",
  couldNotUpdateInRoutePlanner: "已在路线规划中更新",
  addToRoutePlannerQuestionMark: "添加到路线规划？",
  addAShift: "添加班次",
  shiftTime: "班次时间",
  shiftTimes: "班次时间",
  addASecondShiftDuration: "添加第二个班次时长",
  scacCode: "SCAC代码",
  carrierName: "承运商名称",
  carrierNameAbbreviation: "承运商名称（缩写）",
  editCarrier: "编辑承运商",
  createNewCarrier: "创建新承运商",
  trackableBy: "可追踪方式",
  areYouSureYouWantToDeleteThisCarrier: "您确定要删除此承运商吗",
  deleteCarrier: "删除承运商",
  transshipment: "转运",
  dueDateBy: "截止日期（按）",
  requestedBy: "请求人",
  assignedTo: "分配给",
  newTransshipment: "新建转运",
  showTodaysTransshipments: "显示今日转运",
  generalDetails: "基本详情",
  whatToDo: "操作内容",
  team: "团队",
  saveAndPublish: "保存并发布",
  markItemsYouWantToMove: "标记要移动的物品",
  perItem: "每件",
  bingoSheet: "清点表",
  transshiping: "转运中",
  thisFieldShouldHaveAlphaNumericCharactersOnly:
    "此字段只能包含字母和数字",
  bookingReference: "预订参考号",
  showAllStorageBoxes: "显示所有储物箱",
  addStorageBox: "添加储物箱",
  createASingleUseBox: "创建一次性储物箱",
  storageBoxNumber: "储物箱编号",
  volumeAvailable: "可用容量",
  theStorageBoxHasBeenAddedSuccessfully: "储物箱已成功添加",
  itLooksLikeTheresNoDataYet: "暂无数据",
  startSearchingForAStorageBoxOrCreateASingleUseBox:
    "开始搜索储物箱或创建一次性储物箱。",
  system: "系统",
  editTransshipment: "编辑转运",
  any: "任意",
  pickUpTime: "取货时间",
  deliveryTime: "交付时间",
  addDespatchesToRoute: "将发货添加到路线",
  removeDespatchesToRoute: "从路线中移除发货",
  added: "已添加",
  searchForStorageBox: "搜索储物箱",
  noItemsToAddToTransshipment: "没有可添加到转运的物品",
  showTodayTransshipments: "显示今日转运",
  showing: "正在显示",
  theOrderHasAlreadyBeenAdded: "该订单已被添加",
  publish: "发布",
  editProject: "编辑项目",
  newProject: "新项目",
  fileName: "文件名",
  dateUploaded: "上传日期",
  ofRows: "行",
  addFile: "添加文件",
  whenYouAddThem: "当您添加后",
  youWillBeAbleToSeeAllThe: "您将能够看到所有的",
  detailsHereWhenYouUploadAtLeastOne: "上传至少一个后，详细信息将在此显示",
  createProject: "创建项目",
  uploadAFile: "上传文件",
  willBeRemoveAllOfTheItemsWillUnloadFromIt:
    "它将被移除。其中所有物品将被卸载。",
  areYouSureYouWantToContinue: "您确定要继续吗？",
  removeStorageBox: "移除储物箱",
  cellInUse: "单元格使用中",
  allWarehouses: "所有仓库",
  yourStorageBoxesAreBeingUploaded: "您的储物箱正在上传",
  automate: "自动化",
  sentToEmail: "已发送至邮箱",
  editAutomation: "编辑自动化",
  deletedSuccessfully: "删除成功",
  deleteAutomation: "删除自动化",
  doYouReallyWantToDeleteTheAutomation: "您确定要删除此自动化吗",
  createOrder: "创建订单",
  addNewproducts: "添加新产品",
  manual: "手动",
  paragraph: "段落",
  options: "选项",
  addOption: "添加选项",
  youNeedToLogOutAndLogBackInForSomeChangesToBeApplied:
    "部分更改需要您退出并重新登录后才能生效。",
  someChangesWereNotApplied: "部分更改未被应用",
  enableAsAStorageBox: "启用为储物箱",
  enablingThisAllowsTheUserToChooseTheVehicleForStorageMovementOrTransshipmentAndIndicateWhenItemsArePlacedInsideLikeAStorageBox:
    "启用此功能允许用户选择车辆用于仓储移动或转运，并标记物品何时被放入，如同储物箱。",
  projectUpdatedWithSuccess: "项目更新成功",
  deleteBrandName: "删除品牌名称",
  deleteBrandNames: "删除品牌名称",
  areYouSureYouWantToDeleteTheBrandName: "您确定要删除此品牌名称吗",
  areYouSureYouWantToDeleteThese: "您确定要删除这些吗",
  brandName: "品牌名称",
  brandNames: "品牌名称",
  brandCode: "品牌代码",
  addNewBrandName: "添加新品牌名称",
  youCanStartByAddingANewBrandName: "您可以先添加一个新的品牌名称",
  loadingBrands: "正在加载品牌",
  newBrand: "新品牌",
  logo: "Logo",
  editBrand: "编辑品牌",
  viewBrand: "查看品牌",
  deleteBrands: "删除品牌",
  previewOnSSCCLabel: "SSCC 标签预览",
  noPdfFileSpecified: "未指定 PDF 文件",
  loadType: "装载类型",
  groupageVanline: "拼装/搬家车",
  otherEnterDims: "其他（输入尺寸）",
  parties: "相关方",
  rail: "铁路",
  itemIsAHardwareBox: "物品为硬件箱",
  youCanSeeTheReportsAfterSelectingTheFollowingFilters:
    "选择以下筛选条件后即可查看报告",
  selectAProject: "选择项目",
  selectAWarehouse: "选择仓库",
  selectASKU: "选择 SKU",
  selectAContainer: "选择集装箱",
  brands: "品牌",
  repeat: "重复",
  weAreCheckingIfALinkIsAvailable: "我们正在检查链接是否可用",
  pleaseSelectAOrderType: "请选择订单类型",
  etaDestination: "预计到达目的地",
  etaDespatch: "预计发货时间",
  trackable: "可追踪",
  downloadShipmentInformations: "下载运输件信息",
  boxContents: "箱内物品",
  packedInto: "打包至",
  indicateLiftvanOrSectionTheItemCanBeFound: "指明物品所在的木框或区域",
  values: "值",
  automaticallyCreateOneHardwareBoxInEveryInventory:
    "自动在每个库存中创建一个硬件箱",
  needsAtLeastOneActiveHardwareBoxItemToBeEnabled:
    "需要至少一个有效的硬件箱物品才能启用。",
  carrierScac: "承运商 SCAC",
  fieldsAreRequired: "集装箱号、预订参考号或提单为必填项。",
  theFleetNameIsUsedAsTheSystemDefault: "车队名称用作系统默认值",
  isBox: "是否为箱",
  isBoxInterrogation: "是否为箱？",
  isThisTypeOfPackagingABox: "此包装类型是否为箱？",
  hardwareBox: "硬件箱",
  itemIsHighRiskOrHighValue: "物品为高风险/高价值",
  thisCarrierAllowsShipmentTrackingBy: "此承运商允许通过以下方式追踪运输件",
  meChecklistIsmandatoryForThisItemPleaseAnswerIt:
    "此物品的 M&E 检查清单为必填项，请完成",
  enableEstimateEditing: "启用预估编辑",
  enable: "启用",
  areYouSureYouWantToEnableEditingEstimateForThisQuote:
    "您确定要启用此报价的预估编辑吗？",
  changesMadeToThisQuoteMayAlsoAffectOrder: "对此报价的更改也可能影响订单。",
  measurementPreview: "测量预览",
  me: "M&E",
  highRiskHighValue: "高风险 / 高价值",
  proGear: "Pro-Gear",
  itemIsAME: "物品为 M&E",
  youCanSeeTheReportsAfterSelectingAtLeast: "至少选择以下条件后即可查看报告",
  warehouseCodeAlreadyExistsPleaseAssignANewCode:
    "仓库代码已存在。请分配新代码。",
  enterTheBoxNumberToSearch: "输入箱号进行搜索。",
  enterTheOrderToSearch: "输入订单进行搜索。",
  noResults: "无结果",
  etdOrigin: "起运地 ETD",
  etaPlanned: "计划 ETA",
  addNewShipment: "添加新运输件",
  basedOnABooking: "基于预订",
  box: "箱",
  case: "箱",
  pallet: "托盘",
  ftl: "FTL",
  ltl: "LTL",
  fcl: "FCL",
  lcl: "LCL",
  groupage: "拼装",
  roro: "RORO",
  bulk: "散货",
  commodityHSCode: "商品 HS 编码",
  enterTheLocationToSearch: "输入地点进行搜索。",
  productPhoto: "产品照片",
  masterbillOfLanding: "总提单",
  housebillOfLanding: "分提单",
  shipmentDetails: "运输件详情",
  placeOfOrigin: "起运地",
  shipperCode: "发货人代码",
  addAnotherContainer: "添加另一个集装箱",
  volumetricWeight: "体积重量",
  grossVolume: "毛体积",
  tareWeight: "皮重",
  netWeight: "净重",
  verifiedGrossWeight: "经核实毛重",
  selectABooking: "选择预订",
  noSubscriberAdded: "未添加订阅者",
  selectABookingBellowToStartAShipmentBasedOnIt:
    "选择下方的预订以基于其创建运输件",
  selectJustOneBookingPerShipment: "每个运输件仅选择一个预订",
  startByAddingASubscribertoShipment: "先添加一个订阅者到运输件",
  youMustSelectAShipmentLoadingPortFirst: "请先选择运输件装货港",
  youMustSelectAShipmentDestinationFirst: "请先选择运输件目的地",
  youMustSelectAShipmentOriginFirst: "请先选择运输件起运地",
  youMustSelectAShipmentDischargePortFirst: "请先选择运输件卸货港",
  youMustSelectAShipmentModeFirst: "请先选择运输件运输方式",
  youMustSelectAShipmentIncotermFirst: "请先选择运输件贸易术语",
  variance: "差异",
  youCanStartByAddingAnOrder: "您可以先添加一个订单",
  editSubscriber: "编辑订阅者",
  fromThisShipment: "从此运输件",
  regularCargo: "普通货物",
  hazardousCargo: "危险货物",
  foodGradeCargo: "食品级货物",
  rareCargo: "稀有货物",
  reeferCargoRefrigerated: "冷藏货物",
  addInAContainer: "添加到集装箱",
  chooseAContainerToAddTheSsccInto: "选择集装箱以添加 SSCC",
  choose: "选择",
  distanceTravelled: "已行驶距离",
  distanceToGo: "剩余距离",
  route: "路线",
  shipeeziPredictsETA: "Shipeezi 预测 ETA",
  plannedETA: "计划 ETA",
  theCarrierProvidesDateTimesBelowAndMayNotMatchObservationsAndPredictionsInOtherSections:
    "承运商提供以下日期时间，可能与其他部分的观测和预测不一致。",
  events: "事件",
  notEventsToShowAtTheMoment: "目前没有事件显示",
  dayDelay: "延迟天数",
  daysDelay: "延迟天数",
  invalidNumber: "无效数字",
  trackingNotFound: "未找到追踪信息",
  shipmentCreated: "运输件已创建",
  checkTheInformationYouHaveFilledInUpdateItAndSaveItWellValidateItAgainInAFewMinutes:
    "请检查您填写的信息，更新并保存。我们将在几分钟内再次验证。",
  weReStillValidatingInformationToSeeIfThisShipmentIsTrackableRefreshThisPageInAFewMinutes:
    "我们仍在验证信息以确认此运输件是否可追踪。请几分钟后刷新此页面。",
  thereIsNoTrackingAvailableForThisShipment: "此运输件暂无追踪信息。",
  yourShipmentWasSuccesfullyCreatedAndWereNowValidatingTheInformationToSeeIfItsTrackable:
    "您的运输件已成功创建，我们正在验证信息以确认是否可追踪。",
  inAFewMinutesYouCanConsultTheTrackingInfoByClickingTheViewOrEditIconButtonInTheActionsColumnOnTheGrid:
    "几分钟后，您可以通过点击列表操作列中的查看或编辑图标按钮来查询追踪信息。",
  whatDoYouWantToSend: "您要发送什么？",
  sendTrackingViaSMSOrEmail: "通过短信或邮件发送追踪信息",
  sendShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse:
    "通过短信或邮件将运输件追踪信息发送给客户或他人",
  writeAnEmailOrUseATemplate: "编写邮件或使用模板",
  writeASMSOrUseATemplate: "编写短信或使用模板",
  writeAPushNotificationOrUseATemplate: "编写推送通知或使用模板",
  sendJSONFile: "发送 JSON 文件",
  sendOnlyTheJSONFileToCustomer: "仅向客户发送 JSON 文件",
  trackingNotAvailable: "追踪不可用",
  doYouAlsoWantToCancelTheLinkedOrder: "您还想取消关联的订单吗",
  areYouSureYouWantToDeleteThisProduct: "您确定要删除此产品吗",
  createSingleUseBox: "创建一次性储物箱",
  newSingleUseBox: "新建一次性储物箱",
  createAnotherSingleUseBox: "再创建一个一次性储物箱",
  searchByContactNameMobilePhoneOrEmailAddress:
    "按联系人姓名、手机号码或邮箱地址搜索",
  searchOrAddAContact: "搜索或添加联系人",
  howMany: "多少个？",
  autoNumberThem: "自动编号",
  typePrefix: "输入前缀",
  singleUse: "一次性",
  noWarehouses: "无仓库",
  byWhom: "由谁",
  enterTheObjectToSearch: "输入对象进行搜索。",
  orderOrCustomer: "订单或客户",
  salutation: "称谓",
  allowance: "容许量",
  secondReference: "第二参考号",
  editLiftvans: "编辑木框",
  addLiftvans: "添加木框",
  areYouSureYouWantToCancelTheTransshipment: "您确定要取消此转运吗",
  yesCancelTransshipment: "是的，取消转运",
  cancelTransshipment: "取消转运",
  sendTheShipmentTrackingViaSMSToTheCustomerOrAnotherPerson:
    "通过短信将运输件追踪信息发送给客户或其他人",
  sendTrackingViaSMS: "通过短信发送追踪信息",
  createdOn: "创建于",
  sendTheShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse:
    "通过短信或邮件将运输件追踪信息发送给客户或其他人",
  sendTrackingViaSMSorEmail: "通过短信或邮件发送追踪信息",
  weightAndMeasurements: "重量和尺寸",
  storageBoxAdded: "储物箱已添加",
  storageBoxRemoved: "储物箱已移除",
  generateCsv: "生成 CSV",
  revokeInvite: "撤销邀请",
  yesRevoke: "是的，撤销",
  revokeInvitation: "撤销邀请",
  doYouWantToRevokeTheInvitationSentTheUserWillNoLonge:
    "您要撤销已发送的邀请吗？该用户将无法再接受此邀请",
  youCanAlwaysInviteThemAgain: "您可以随时重新邀请。",
  cancelInvite: "取消邀请",
  thisInviteWasRevoked: "此邀请已被撤销",
  oopsItLooksLikeThisInvitationHasBeenRevoked:
    "抱歉，此邀请已被撤销，不再有效。",
  ifYouThinkThisIsAnErrorPleaseContactTheCompanyResponsibleToBetter:
    "如果您认为这是一个错误，请联系相关公司以了解详情。",
  unlinkInventory: "取消关联库存",
  yesUnlink: "是的，取消关联",
  doYouWantToUnlinkTheInventory: "您要取消关联该库存吗",
  inventoryLinked: "库存已关联",
  inventoryUnlinked: "库存已取消关联",
  inventoryLinkedSuccessfully: "库存关联成功",
  inventoryUnlinkedSuccessfully: "库存取消关联成功",
  relinkInventory: "重新关联库存",
  yesRelink: "是的，重新关联",
  doYouWantToRelink: "您要重新关联吗",
  thisActionWillReplaceTheValuesYouveSetWithTheValuesFromYourActualInventory:
    "此操作将用您的实际库存值替换您设置的值。",
  whenYouUnlinkTheInventoryYouCanEditTheTotalValuesThisMeansThatAnyFutureChangesYouMakeToTheInventoryWillNotBeReflectedInTheseMeasurements:
    "取消关联库存后，您可以编辑总值。这意味着您将来对库存所做的任何更改都不会反映在这些测量值中。",
  inventoriesSummary: "库存汇总",
  itemIsProGear: "物品为 Pro-Gear",
  apps: "应用",
  thisStorageBoxTypeIsCurrentlyInUseAndItsStatusCantBeChanged:
    "此储物箱类型正在使用中，无法更改状态",
  allowItemPhotosToBeUploadedFromTheDevicesImageGallery:
    "允许从设备相册上传物品照片",
  thisSettingsEnablesMobileAppUsersToUploadImagesFromTheirDevicesGallery:
    "此设置允许移动应用用户从设备相册上传图片",
  thisMayCauseADataSecurityRiskAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices:
    "这可能会导致数据安全风险，因为它可能导致客户物品照片被存储在个人设备上",
  allowUseOfDeviceGallery: "允许使用设备相册",
  galleryUsePermission: "相册使用权限",
  enablesUsersToUploadItemImagesFromTheirDevicesGallery:
    "允许用户从设备相册上传物品图片",
  note: "备注",
  thisMayCauseAPersonalInformationSecurityRisksAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices:
    "这可能导致个人信息安全风险，因为它可能导致客户物品照片被存储在个人设备上",
  typeHere: "在此输入...",
  hideCC: "隐藏抄送",
  hideBCC: "隐藏密送",
  cc: "抄送",
  linkedTo: "关联至",
  linkedMaterials: "关联材料",
  selectAMaterial: "选择材料",
  addAnExistingGroup: "添加已有分组",
  newBlankGroup: "新建空白分组",
  selectOneOrMoreGroups: "选择一个或多个分组",
  addGroup: "添加分组",
  showCC: "显示抄送",
  showBCC: "显示密送",
  asTheShipmentIdentificationIsUniqueYouCannotChangeItAfterCreation:
    "运输件标识具有唯一性，创建后不可更改",
  generatePDFReport: "生成 PDF 报告",
  reportLanguage: "报告语言",
  taskReportType: "任务报告类型",
  addedToContainer: "已添加至集装箱",
  ssccs: "SSCCs",
  typeAComment: "输入评论",
  addAComment: "添加评论",
  commentsHistory: "评论历史",
  addedOn: "添加于",
  youCanStartByCreatingASscc: "您可以先创建一个 SSCC",
  hereIsYourShipmentInfo: "以下是您的运输件信息",
  yourShipmentHasArrivedAt: "您的运输件已到达",
  commentSpecialInstruction: "备注/特殊说明",
  hsCode: "HS 编码",
  typeInAConsignee: "输入收货人",
  typeInACustomer: "输入客户",
  typeInOtherParty: "输入其他方",
  otherAdditionalParty: "其他/附加方",
  byFillingInOneOrMoreOfTheseFieldsYourShipmentWillBeTracked:
    "填写一个或多个以下字段后，您的运输件将被追踪。",
  moreContainerType: "更多集装箱类型",
  sendCustomerPortalLink: "发送客户门户链接",
  typeInToSearch: "输入进行搜索",
  flight: "航班",
  generatedBySystem: "系统生成",
  mandatory: "必填",
  newDocument: "新文件",
  clearFile: "清除文件",
  areYouSureYouWantToDelete: "您确定要删除",
  deleteDocument: "删除文件",
  notAvailableYet: "暂不可用",
  documentsForThisShipment: "此运输件的文件",
  shipmentMustBeConfirmed: "运输件必须已确认",
  clearingFile: "正在清除文件",
  generatingFile: "正在生成文件",
  openingFile: "正在打开文件",
  shareCustomerPortalLink: "分享客户门户链接",
  sendTheCustomerPortalLinkWithAccessToTheOrderOnline:
    "发送可在线访问订单的客户门户链接",
  loading: "加载中",
  escalation: "升级处理",
  escalationContactRaised: "已发起升级处理/联系",
  removeEscalationRequest: "移除升级处理请求",
  noKeepIt: "不，保留",
  ohNoSomethingWentWrongPleaseTryAgain: "糟糕！出现了问题。请重试。",
  escalationRequestHasBeenRemoved: "升级处理请求已移除",
  removingThisEscalationChangeRequestWillClearAnyPendingRequests:
    "移除此升级处理/变更请求将清除所有待处理请求",
  areYouSureYouWishToProceed: "您确定要继续吗",
  yourEscalationRequestHasBeenSentSuccessfully:
    "您的升级处理请求已成功发送",
  inputComment: "输入评论",
  sendTo: "发送至",
  selectedPerson: "已选人员",
  selectWhoToNotify: "选择通知对象",
  theFollowingEmail: "以下邮件",
  notify: "通知",
  contactUs: "联系我们",
  packingItems: "打包物品",
  closingTheBoxes: "正在封箱",
  listeningToBubbleWrapConfessions: "正在聆听气泡膜的心声",
  parkingTheShip: "正在停靠船只",
  talkingToTheFish: "正在和鱼儿聊天",
  cartonContents: "纸箱内容物",
  ata: "ATA",
  thereIsNoTrackingInformationAvailableForThisShipment:
    "此运输件暂无追踪信息",
  thisTabWillShowSomeTrackingInformationIfAvailableAfterYouCreateTheShipment:
    "创建运输件后，此选项卡将显示追踪信息（如有）",
  theresNoTrackingInformationYet: "暂无追踪信息",
  livePosition: "实时位置",
  containerCase: "集装箱 / 货箱",
  containerCaseSize: "集装箱 / 货箱尺寸",
  sealMarkings: "海运号 / 标记",
  selectALoadType: "选择装载类型",
  selectAContainerCaseSize: "选择集装箱或货箱尺寸",
  typeAContainerCaseSize: "输入集装箱或货箱尺寸",
  dContainer: "D-Container",
  eContainer: "E-Container",
  ldnContainer: "LDN Container",
  liftvan: "木框",
  liftvans: "木框",
  eur1Iso1Pallet: "EUR1/ISO1 托盘",
  eur2Iso2Pallet: "EUR2/ISO2 托盘",
  itLooksLikeThereNoDataYet: "暂无数据",
  startByAddingAnOrderToShipment: "先将订单添加到运输件",
  thisValueShouldBeAPositiveNumber: "此值应为正数",
  selectTheLoadTypeFirst: "请先选择装载类型",
  hsCommodityCode: "HS / 商品编码",
  searchForAnAgent: "搜索代理人",
  enterAValueGraterThanNetWeight: "请输入大于净重的值",
  enterAValueLowerThanGrossWeight: "请输入小于毛重的值",
  youShouldAddAtLeastOneContainerToTheShipment:
    "请至少添加一个集装箱到运输件",
  thisRepresentsTheInitialEstimatedTimeOfArrivalProvidedByTheCarrier:
    "这表示承运商提供的初始预计到达时间",
  thisIsYourShipmentInformation: "这是您的运输件信息",
  today: "今天",
  configure: "配置",
  last15Days: "最近15天",
  lastMonth: "上月",
  monthToDate: "本月至今",
  lastYear: "去年",
  customDate: "自定义日期",
  customPeriod: "自定义周期",
  configureOverview: "配置概览",
  adjustWidgetsAndViewAsYouWish: "按需调整小部件和视图",
  purchaseOrdersWidgets: "采购订单小部件",
  poStatuses: "采购订单状态",
  lastReceivedOrders: "最近收到的订单",
  poConfirmedVSPoReceived: "已确认采购订单 vs 已收采购订单",
  productsOrigin: "产品原产地",
  mostRequestedProducts: "最热门产品",
  productsRunningOutOfStock: "即将缺货的产品",
  containersByArrivalDate: "按到达日期的集装箱",
  shipmentsPerTime: "各时段运输件数",
  shipmentStatuses: "运输件状态",
  resetToDefault: "恢复默认",
  ofTotal: "占总计",
  inboundAtPortAtDC: "入境中、在港口和在配送中心",
  containersStatuses: "集装箱状态",
  amountOfSSCC: "SSCC 数量",
  apply: "应用",
  searchForAConsultant: "搜索顾问",
  enableQuoteEditing: "启用报价编辑",
  areYouSureYouWantToEnableEditingForThisQuote:
    "您确定要启用此报价的编辑吗？",
  trackYourShipmentByFillingInEitherOrBothFields:
    " 输入提单 (BOL)、预订 ID 或两者来追踪您的运输件。",
  pleaseFillInAtLeastOnField: "请至少填写一个字段。",
  dimensionalWeight: "体积重量",
  airportOfOrigin: "卸货港 (PoD)",
  airportOfDestination: "目的机场",
  arrivalAOfDestination: "交货日期",
  accounts: "账户",
  ofUsers: "个用户",
  newAccount: "新账户",
  companyAddress: "公司地址",
  accountLogo: "账户标志",
  notEnoughData: "数据不足",
  thereIsInsufficientDataToGenerateGraphicsForTheSelectedPeriod:
    "所选周期数据不足，无法生成图表。",
  atDC: "在配送中心",
  incoterms: "Incoterms",
  uldContainers: "ULD 集装箱",
  uldPallets: "ULD 托盘",
  thisActionWillAlsoRemoveAnyFilesYouHaveUploadedInIt:
    "此操作还将删除您在其中上传的所有文件。",
  actualInventory: "实际库存",
  checkAllSteps: "检查所有步骤",
  milestones: "里程碑",
  checkYourMoveFileOnline: "在线查看您的搬迁文件",
  logedInAs: "登录身份",
  english: "英文",
  yourOrder: "您的订单",
  theTokenProvidedIsIncorrect: "提供的令牌不正确",
  nextStep: "下一步",
  survey: "勘查",
  typeYourCommentsHere: "在此输入您的评论",
  agentContactDetails: "代理人联系方式",
  distanceToNextPort: "距下一港口距离",
  kg: "Kg",
  eventsUnavailable: "事件不可用",
  routeUnavailable: "路线不可用",
  trackingInformationUnavailable: "追踪信息暂时不可用。",
  nauticalMiles: "海里",
  closeAllSSCCs: "关闭所有 SSCC",
  areYouSureYouWantToCloseAllSSCCs: "您确定要关闭所有 SSCC 吗",
  isItByDefaultAMilestone: "它默认是里程碑吗？",
  newTask: "新任务",
  addTask: "添加任务",
  tasksAndMilestones: "任务和里程碑",
  milestonesFunctionallity: "里程碑功能",
  aMilestoneIsAKeyDateThatShowsOnTheCustomerPortalMilestonesAreDisplayedAsAMoveFlowInAscendingOrderTasksAreSetByDefaultToBeConsideredAMilestoneOrNot:
    "里程碑是在客户门户上显示的关键日期。里程碑按升序显示为搬运流程。任务默认设置为是否被视为里程碑。",
  youCanEditTheseDefaultsInSystemSettings: "您可以在系统设置中编辑这些默认值。",
  youCanAlsoChooseToChangeThemAsNeededForThisFileOnly:
    "您也可以根据需要仅为此文件更改这些设置。",
  setAsMilestone: "设为里程碑",
  removeAsMilestone: "取消里程碑",
  youCanChooseFromTheListBelowWhichItemsYouWantToUpload:
    "您可以从下方列表中选择要上传的项目",
  downloadCSVTemplate: "下载 CSV 模板",
  theFilesWereUploadedAndUpdatedSuccesfully: "文件已成功上传和更新",
  anErrorOccurredLoadingUploadCentreTryAgain: "加载上传中心时发生错误，请重试",
  weHaveFoundSomeErros: "我们发现了一些错误",
  branchCode: "分支机构编码",
  warehouseCode: "仓库编码",
  branchCodeNotFound: "未找到分支机构编码",
  warehouseCodeNotFound: "未找到仓库编码",
  thisBranchIsNotRelatedToInformedWarehouse: "此分支机构与所填仓库无关",
  serviceCodeAlreadyExistsPleaseAssignANewCode:
    "服务编码已存在，请分配新的编码。",
  materialCodeAlreadyExistsPleaseAssignANewCode:
    "物料编码已存在，请分配新的编码。",
  codeAlreadyExistsPleaseAssignANewCode: "编码已存在，请分配新的编码。",
  codeIsDuplicated: "编码重复",
  codeNotFound: "未找到编码",
  anErrorOccurredOnTryAgain: "重试时发生错误",
  looseItems: "散件",
  thisFieldMustHaveAtLeastOneItem: "此字段至少需要一个项目",
  theOrderAlreadyIsInATransshipment: "该订单已在转运中",
  publishTask: "发布任务",
  unpublishTask: "取消发布任务",
  noCommentsAdded: "暂无评论",
  actualAtDepartureDock: "到达 PoD",
  actualArrivalOfDestination: "交付日期",
  noRecord: "无记录",
  hwab: "HWAB",
  selectAPeriod: "选择时间段",
  storageBoxSingleUseSelected: "已选择一次性仓储箱",
  youCanAddOnlyOneOrderToAStorageBoxSingleUse:
    "一次性仓储箱只能添加一个订单",
  createsANomenclatureBasedOnTheTransshipmentNumberAndTheQuantityOfLiftvans:
    "根据转运编号和木箱数量创建命名规则。",
  result: "结果",
  results: "结果",
  youCanOnlyUseOneStorageBoxSingleUsePerOrder:
    "每个订单只能使用一个一次性仓储箱",
  youCanOnlyUseStorageBoxSingleUseForJustOneOrder:
    "一次性仓储箱只能用于一个订单。",
  completed: "已完成",
  initialRequest: "初始请求",
  noStepsInformed: "未提供步骤信息",
  noTrackingAvailable: "暂无跟踪信息",
  dateNotInformed: "未提供日期",
  invoiceTotal: "发票总额",
  receivedDate: "接收日期",
  error: "错误",
  waitingUpdate: "等待更新",
  shipeeziDefault: "Shipeezi 默认",
  theFileToUploadMustBeInCSVFormat: "上传文件必须为 .csv 格式",
  pleaseFillInTheRequiredFieldsBeforeSaving: "请在保存前填写必填字段。",
  changeAssignee: "更改负责人",
  selectAPerson: "选择人员",
  theAssignedPersonHasBeenChangedSuccessfully: "负责人已成功更改",
  shipmentsPerDate: "按日期统计运输件",
  for: "用于",
  chapter: "章",
  heading: "目",
  subHeading: "子目",
  statisticalClassification: "统计分类",
  applicableTo: "适用于",
  inactivatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeInactivatedAsWell:
    "停用某个区域、章或目时，所有相关的 HS/商品编码也将被停用。",
  doYouWantToInactivateAllOfThemAsWell: "是否同时停用所有相关项？",
  activatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeActivatedAsWell:
    "启用某个区域、章或目时，所有相关的 HS/商品编码也将被启用。",
  doYouWantToActivateAllOfThemAsWell: "是否同时启用所有相关项？",
  inactivateCode: "停用编码",
  activateCode: "启用编码",
  typeInTheFirst6Digits: "输入前 6 位数字",
  typeInTheLast2To4Digits: "输入后 2 至 4 位数字",
  typeInTheCommodityCodeDescription: "输入商品编码描述",
  typeInCountryOrRegion: "输入国家或地区",
  commodityCode: "商品编码",
  doYouReallyWantToDeleteThisCommodityCode: "确定要删除此商品编码吗",
  deleteCommodityCode: "删除商品编码",
  clone: "克隆",
  adjustTheDataAsDesiredToCreateTheNewCode: "根据需要调整数据以创建新编码。",
  insertAValidCode: "*请输入有效编码",
  youMustFillInTheFieldsInRed: "请填写红色标记的字段",
  importCSV: "导入 CSV",
  importCSVFile: "导入 CSV 文件",
  weHaveFoundSomeErrors: "我们发现了一些错误",
  regions: "地区",
  defineWheterTheStorageBoxTypeCanApperInAllWarehouses:
    "设置该仓储箱类型是否可在所有仓库中显示",
  defineIfTheStorageBoxTypeCanBeUsedInTransitInsideTheWarehouseOrBoth:
    "设置该仓储箱类型可用于运输中、仓库内还是两者皆可",
  pleaseSelectAtLeastOne: "请至少选择一项",
  originAirport: "始发机场",
  finalDestinationAirport: "最终目的机场",
  plannedETD: "计划 ETD",
  departureFrom: "从…出发",
  departedFrom: "已从…出发",
  theAirplanePositionIsUpdatedFrom15To15Minutes:
    "飞机位置每 15 分钟更新一次。",
  inviteCustomer: "邀请客户",
  inviteCustomers: "邀请客户",
  supplyChain: "供应链",
  allSelectedCustomersMustHaveNameEmailAndNotYetBelongToShipeezi:
    "所有选中的客户必须有姓名、邮箱，且尚未加入 Shipeezi",
  theBranch: "该分支机构",
  warehouseNotFound: "未找到仓库",
  isNotRelatedToInformedWarehouse: "与所填仓库无关",
  writeACommentInSKU: "在 SKU 中添加评论",
  loadMore: "加载更多",
  commentHistory: "评论历史",
  readMore: "阅读更多",
  return: "返回",
  toAdd: "添加",
  shiftReturn: "Shift + Return",
  toBreakLine: "换行",
  now: "现在",
  inMoment: "稍后",
  justNow: "刚刚",
  in: "在",
  years: "年",
  yearAgo: "年前",
  yearsAgo: "年前",
  months: "个月",
  monthAgo: "个月前",
  monthsAgo: "个月前",
  weeks: "周",
  weekAgo: "周前",
  weeksAgo: "周前",
  tomorrow: "明天",
  yesterday: "昨天",
  daysAgo: "天前",
  hour: "小时",
  hours: "小时",
  hourAgo: "小时前",
  hoursAgo: "小时前",
  minute: "分钟",
  minutes: "分钟",
  minuteAgo: "分钟前",
  minutesAgo: "分钟前",
  pleaseTypeLessThanCharacters: "请输入少于 {{maxLength}} 个字符",
  emailConfiguration: "邮件配置",
  selectAll: "全选",
  "common.clearAll": "清除全部",
  youCantRemoveColumsTheMinimumIs: "无法移除列，最少为",
  allTime: "全部时间",
  lastWeek: "上周",
  allTypes: "所有类型",
  editions: "编辑记录",
  loads: "装载",
  unloads: "卸载",
  member: "成员",
  spouse: "配偶",
  whoDoesThisItemBelongTo: "此物品属于谁？",
  searchOrAddAnItem: "搜索或添加物品",
  writeYourMessageHere: "在此输入您的消息",
  message: "消息",
  youAreNotifying: "您正在通知",
  perDestination: "按目的地",
  asQuoted: "按报价",
  noItemsHaveBeenRegisteredYet: "尚未登记任何物品",
  onceItemsAreAddedToInventoryYouWillBeAbleToSeeTheirDetails:
    "物品添加到库存后，您将可以查看其详细信息",
  goodMorning: "早上好",
  goodAfternoon: "下午好",
  goodNight: "晚上好",
  youDontHaveAnyMovesWithUsYet: "您还没有任何搬运记录。",
  youHaveNotYetRequestedAQuoteFromUs: "您尚未向我们提交报价请求。",
  itSeemsLikeEverythingIsFineAroudHere: "一切看起来都很顺利",
  weAreHereToHelpYourMoveToBeAsSmoothlyAsPossible:
    "我们致力于让您的搬运过程尽可能顺畅",
  weAreHereToHelpYourQuoteToBeAsSmoothlyAsPossible:
    "我们致力于让您的报价流程尽可能顺畅",
  yourMoves: "您的搬运",
  yourQuotes: "您的报价",
  scheduled: "已排期",
  needsYourAttention: "需要您关注",
  yourScheduleIsSqueakyCleanNoUpcomingAppointmentsToWorryAbout:
    "您的日程空空如也！没有即将到来的预约需要担心。",
  ifWeNeedYouForAnythingHereItIsThePlaceToTakeAction:
    "如果我们需要您处理任何事项，这里就是您采取行动的地方。",
  actualMilestone: "实际里程碑",
  trackingAvailable: "可追踪",
  howAboutHavingACoffe: "要不来杯咖啡？",
  everythingIsUpToDate: "一切都是最新的",
  youWillSeeAllTheCommunicationBetweenYourselfAndUsHere:
    "您将在此处看到您与我们之间的所有通讯记录。",
  transshipped: "已转运",
  weDidNotFindAnyMovesRelatedTo: "未找到相关的搬运记录",
  noResultsFound: "未找到结果",
  nothingScheduledForNow: "暂无排期",
  timeline: "时间线",
  home: "首页",
  checkAllMilestones: "查看所有里程碑",
  yourMoveProgress: "您的搬运进度",
  showMore: "显示更多",
  transport: "运输",
  originContacts: "始发地联系人",
  destinationContacts: "目的地联系人",
  checkMyInventories: "查看我的库存",
  messageSentThankYouForContactingUsWellGetBackToYouSoon:
    "消息已发送！感谢您联系我们，我们会尽快回复您。",
  contactHistory: "联系历史",
  youContacted: "您联系了",
  yourMoveDocumentStatus: "您的搬运文件状态",
  pleaseFillInEitherTheMobileNumberOrPhoneNumberField:
    "请填写手机号或电话号码",
  pleaseFillAtLeastOne: "请至少填写一项",
  allItemsPacked: "所有物品已打包",
  allYourItemsHaveBeenPackedAndEverythingIsFine:
    "您的所有物品已打包完毕，一切正常。",
  couldNotFoundWithUsernamePassword:
    "未找到匹配的账户凭证。出于安全原因，在 <strong>{{numberOfAttempts}} 次失败</strong>登录尝试后，您需要等待 <strong>{{lockoutDuration}}</strong> 才能再次尝试。<HiddenText> 您需要<Link>重置密码</Link>吗？</HiddenText>",
  members: "成员",
  teams: "团队",
  newTeam: "新建团队",
  equipments: "设备",
  leaderUser: "负责人（用户）",
  inviteMember: "邀请成员",
  newMember: "新建成员",
  chooseTheTypeOfMember: "选择成员类型",
  theMemberCanHaveAccessToSystemOrNot: "该成员可以拥有或不拥有系统访问权限",
  personalDetails: "个人详情",
  generalInformationAboutTheMember: "成员的基本信息",
  howThePersonAccessesAndInteractsWithTheSystem:
    "该人员如何访问和使用系统",
  additional: "附加信息",
  hasAccessToShipeeziSystemWithALoginAndPassword:
    "拥有 Shipeezi 系统访问权限，有登录名和密码",
  thisMemberBelongsToASubcontractor: "该成员属于分包商",
  subcontractor: "分包商",
  nickname: "昵称",
  startEmploymentDate: "入职日期",
  endEmploymentDate: "离职日期",
  citizenship: "国籍",
  license: "执照",
  jobTitle: "职位",
  editPhoto: "编辑照片",
  specificDetailsAboutTheStaffPerson: "员工的详细信息",
  staffInformation: "员工信息",
  typerOfUser: "用户类型",
  notApproved: "未通过",
  review: "审核",
  expiry: "到期",
  certification: "证书",
  certifications: "证书",
  newCertification: "新建证书",
  uploadANewFile: "上传新文件",
  confirmThisCertificationIsValidated: "确认此证书已验证",
  expire: "到期",
  preferNotToSay: "不愿透露",
  nonBinary: "非二元",
  searchForCitizenship: "搜索国籍",
  serchForCountry: "搜索国家",
  thisUserIsAlsoALeader: "该用户同时也是负责人",
  pleaseCompleteAllRequiredFields: "请填写所有必填字段",
  createMember: "创建成员",
  associatedWithThisMemberWhenYouAddThem: "在添加成员时与其关联",
  associatedWithThisEquipmentWhenTheyAreAdded: "在添加设备时与其关联",
  newAbsence: "新建缺勤",
  absences: "缺勤",
  absence: "缺勤",
  allDayAbsence: "全天缺勤",
  availability: "可用性",
  convertStaffIntoUser: "将员工转换为用户",
  convertUserIntoStaff: "将用户转换为员工",
  configureAsSubcontractor: "配置为分包商",
  doYouWantToConvertThisUserIntoStaff: "是否要将此用户转换为员工？",
  doYouWantToConvertThisStaffIntoUser: "是否要将此员工转换为用户？",
  youWillNeedToFillInTheMissigInformation: "您需要填写缺失的信息",
  thisMemberIsA: "该成员是",
  andIsDefinedAsA: "并被定义为",
  subconttractorFor: "的分包商",
  own: "自有",
  convertInto: "转换为",
  subcontractorFor: "的分包商",
  timesheet: "工时表",
  timesheets: "工时表",
  typeOfMember: "成员类型",
  ifTheTeamAlreadyHasALeaderTheMemberWillBeAddedAsStaff:
    "如果团队已有负责人，该成员将被添加为员工",
  emergencyEmail: "紧急联系邮箱",
  newTime: "新建时间",
  editTeam: "编辑团队",
  addMember: "添加成员",
  addTeam: "添加团队",
  nameL: "姓名",
  equipmentPhoto: "设备照片",
  maxSize2mb: "最大 2MB",
  formatsJpgGifPng: "格式：JPG、GIF、PNG",
  equipmentIcon: "设备图标",
  rental: "租赁",
  leased: "租用",
  noMembersAssociatedToThisEquipment: "此设备暂无关联成员",
  youCanStartByAddingAMember: "您可以先添加一名成员",
  newUnavailabilityTime: "新建不可用时间",
  allDayUnavailable: "全天不可用",
  rolesecurity: "角色（安全）",
  loaction: "位置",
  addMembers: "添加成员",
  youwillbeabletoseealltheinformationabouttheavailabilityofthismemberwhenyouaddthem:
    " 添加该成员后，您将可以查看其所有可用性信息",
  addUnavailability: "  添加不可用时间",
  addTeams: "添加团队",
  enableThisFleetAsAStrorageBox: "将此车队启用为仓储箱",
  dates: "日期",
  selectAnOptionToSeeTheForm: "选择一个选项以查看表单",
  typeInToSearchAMebmer: "输入以搜索成员",
  pantech: "厢式货车",
  nickName: "昵称",
  EuroNorm: "EUROnorm",
  driverLicense: "驾驶执照",
  manufacturer: "制造商",
  branch1: "分支机构 1",
  warehouse1: "仓库 1",
  enableThisFleetAsAStorageBox: "将此车队启用为仓储箱",
  writeADescription: "填写描述",
  chooseAvehicleTypeOfEquipmentLikeAForkliftOrATruck:
    "选择车辆类型的设备，如叉车或卡车",
  chooseAVehicleTypeOfEquipmentLikeAForkliftOrATruck:
    "选择车辆类型的设备，如叉车或卡车",
  createMoreGeneralizedEquipmentWithAFewDetails:
    "创建更通用的设备，仅需少量信息",
  whoOwnsThisEquipment: "此设备的所有者是谁？",
  businessphone: "商务电话",
  vatcode: "VAT 编码",
  iban: "IBAN",
  bic: "BIC",
  usesameasgeneraladdress: "使用与一般地址相同的地址",
  addaequipment: "添加设备",
  quickcreationequipment: "快速创建设备",
  addequipment: "添加设备",
  addAMember: "添加成员",
  addATeam: "添加团队",
  createnew: "新建",
  businessdetails: "企业信息",
  businessinformationaboutthesubcontractor: "分包商的企业信息",
  generalinformationabouttheowner: "所有者的基本信息",
  bankingdetails: "银行信息",
  nomembersassociatedtothisequipment: "此设备暂无关联成员",
  youcanstartbyaddingamember: "您可以先添加一名成员",
  createnewmember: "创建新成员",
  addanexistentmember: "添加现有成员",
  quickcreation: "快速创建",
  equipment: "设备",
  quicklycreateanewequipmentwithessentialdetailsaddmoreinformationanytimeinsettings:
    "快速创建新设备，仅需基本信息。您可以随时在设置中补充更多信息。",
  createmoregeneralizedequipmentwithafewdetails:
    "创建更通用的设备，仅需少量信息",
  personaldetails: "个人详情",
  platenumber: "车牌号",
  subcontractors: "分包商",
  newSubcontractor: "新建分包商",
  qtyMembers: "成员数量",
  qtyEquipments: "设备数量",
  businessDetails: "企业信息",
  businessInformationAboutTheSubcontractor: "分包商的企业信息",
  businessPhone: "商务电话",
  generalInformationAboutTheOwner: "所有者的基本信息",
  addNumberHere: "在此输入号码",
  bankingDetails: "银行信息",
  vatCode: "VAT 编码",
  useSameAsGeneralAddress: "使用与一般地址相同的地址",
  contactEmail: "联系邮箱",
  noMembersAssociatedToThisSubcontractor: "此分包商暂无关联成员",
  createNewMember: "创建新成员",
  addAnExistentMember: "添加现有成员",
  noMembersToShow: "暂无成员",
  noTeamsToShow: "暂无团队",
  typeInToSearchAMember: "输入以搜索成员",
  addWorkTimeToMember: "为成员添加工时",
  howDoYouWantToAddAnewTime: "您想如何添加新时间",
  createMockTask: "创建模拟任务",
  createAMimicTaskToRecordHoursForThisMember:
    "创建模拟任务以记录该成员的工时。",
  selectExistentTask: "选择现有任务",
  selectAnExistingTaskInTHeOrderToLogWorkTime:
    "在订单中选择现有任务以记录工时",
  addTime: "添加时间",
  backFromBreak: "休息结束",
  itLooksLikeNoOrderWasSelectYet: "看起来尚未选择订单",
  startSearchingForAnOrderToBeAbleToCreateANewTask:
    "开始搜索订单以创建新任务",
  searchOrderBy: "按以下条件搜索订单",
  cancelAvailability: "取消可用性",
  doYouReallyWantToCancelThisAbsence: "确定要取消此缺勤吗，对象：",
  yesCancel: "是，取消",
  thisActionCannotBeUndone: "此操作不可撤销",
  viewTime: "查看时间",
  editTime: "编辑时间",
  noLeaderAvailable: "无可用负责人",
  noStaffAvailable: "无可用员工",
  noTasks: "暂无任务",
  m3: "m³",
  unavailableUntil: "不可用至",
  lv: "LV",
  noEquipmentToShow: "暂无设备",
  addEquipment: "添加设备",
  addAnExistentEquipment: "添加现有设备",
  addEquipments: "添加设备",
  addAEquipment: "添加设备",
  newEquipment: "新建设备",
  chooseTheTypeOfEquipment: "选择设备类型",
  purchaseDate: "购买日期",
  soldDate: "出售日期",
  euronorm: "EUROnorm",
  lastInspectionDate: "上次检验日期",
  nextInspectionDate: "下次检验日期",
  pleaseSelectAnLaterDate: "请选择更晚的日期",
  pleaseSelectAnEarlierDate: "请选择更早的日期",
  workedTime: "工作时长",
  breaks: "休息",
  waitingApproval: "等待审批",
  noSubcontractorAvailable: "无可用分包商",
  noLeaderAdded: "未添加负责人",
  noStaffAdded: "未添加员工",
  noEquipmentAdded: "未添加设备",
  noStorageBoxAdded: "未添加仓储箱",
  noOrders: "未添加订单",
  openOrder: "打开订单",
  accessDetails: "访问详情",
  membersAndTeams: "成员与团队",
  membersAndEquipments: "成员与设备",
  extraMembersAndTeams: "额外成员与团队",
  addTeamToBoard: "将团队添加到看板",
  timeMustBeAfter: "时间必须晚于",
  addALeader: "添加负责人",
  addStaffs: "添加员工",
  addStorageBoxes: "添加仓储箱",
  timeClock: "打卡时钟",
  removeTaskFromTeam: "从团队中移除任务",
  youCannotPublishATaskWithoutALeader: "没有负责人无法发布任务",
  thisChangeWillBeProcessedShortly: "此更改将很快处理",
  noLanguageAvailable: "无可用语言",
  noJobTitleAvailable: "无可用职位",
  equipmentDetails: "设备详情",
  removeThisTeamFromTheBoard: "从看板中移除此团队",
  areYouSureyouWantToCancelTheTask: "确定要取消此任务吗",
  forOrder: "用于订单",
  createCrew: "创建班组",
  noTeamsAddedYet: "尚未添加团队",
  allCaughtUpWhatAboutACoffee: "全部处理完毕！来杯咖啡吧？",
  weAreDoingOneLastSearchWhatAboutACoffee: "正在进行最后一次搜索…来杯咖啡吧？",
  viewOptions: "查看选项",
  showItemsUnavailable: "显示不可用项目",
  showEmptyOrdersTasks: "显示空订单任务",
  showEmptyTeams: "显示空团队",
  collapseOrdersTasks: "折叠订单任务",
  collapseTeams: "折叠团队",
  expandOrdersTasks: "展开订单任务",
  expandTeams: "展开团队",
  organization: "组织",
  organiseByTask: "按任务组织",
  organiseByOrder: "按订单组织",
  organiseByTeam: "按团队组织",
  youCannotPublishThisTask: "无法发布此任务",
  typeHereAndPressEnter: "在此输入并按回车",
  noMemberFound: "未找到成员",
  noTeamFound: "未找到团队",
  noOrderFound: "未找到订单",
  noInformationToShow: "暂无信息",
  noEquipmentFound: "未找到设备",
  noStorageBoxFound: "未找到仓储箱",
  pressToSearch: "按下搜索",
  noOrderAvailable: "无可用订单",
  youHaveToUnpublishFirst: "请先取消发布",
  thisTaskAlreadyStartedByTheLeader: "负责人已开始此任务",
  thisTaskAlreadyFinished: "此任务已完成",
  thisTaskAlreadyCancelled: "此任务已取消",
  youHaveToAddATaskBeforeCreateASingleUse: "需要先添加任务才能创建一次性使用",
  youCannotAddASingleUseForDifferentOrders: "无法为不同订单添加一次性使用",
  createAStorageBoxSingleUse: "创建一次性仓储箱",
  thisTaskCannotBeCancelled: "此任务无法取消",
  thereIsNoNeed: "无需操作",
  vipMode: "VIP 模式",
  bluebarkMove: "Bluebark 搬运",
  satefyMove: "安全搬运",
  dispatch: "调度",
  youHaveUnpublishedTasks: "您有未发布的任务！",
  thisTeamHasTasksAlreadyPublishedForThisLeader:
    "该团队已有为此负责人发布的任务",
  anOperationalMemberUsedJustForRegisterPurposes:
    "仅用于登记的运营成员",
  boardDisplay: "看板显示",
  createATemporaryTeamoForTodaysTasks: "为今天的任务创建临时团队",
  registredAddress: "注册地址",
  noResultMatchYourSearch: "没有与您的搜索匹配的结果",
  searchAndSelectOrder: "搜索并选择订单",
  itLooksLikeNoOrderWasSelectedYet: " 看起来尚未选择订单",
  startSearchingForAnOrderYoBeAbleToCreateANewTask:
    "开始搜索订单以创建新任务",
  newTaskFor: "新建任务，用于",
  timeFor: "时间用于",
  notifyTheClientAboutTheStartOfTheTask30MinutesInAdvance:
    "提前 30 分钟通知客户任务即将开始",
  breakFromBreak: "休息结束",
  albertFloresMarvinMcKinneyJeromeBell: " Albert Flores, Marvin McKinney, Jerome Bell",
  extraMembers: "额外成员与团队",
  devonLane: "Devon Lane",
  readLess: "收起",
  writeACommentIn: "添加评论于",
  shift: "shift",
  teamRemovalIsBlockedDueToThePresenceOfTasks:
    "由于存在任务，团队无法移除。",
  vipTreatment: "VIP 待遇",
  personalAddress: "个人地址",
  pleaseSelectAStartDate: "请选择开始日期",
  morning: "上午",
  afternoon: "下午",
  evening: "傍晚",
  night: "夜晚",
  registeredAddress: "注册地址",
  noTaskYest: "暂无任务",
  writeAComment: "填写评论",
  allowBookingSearch: "允许预订搜索",
  securityLoginAttempts:
    "出于安全原因，在 <strong>{{numberOfAttempts}} 次失败</strong>登录尝试后，您需要等待 <strong>{{lockoutDuration}}</strong> 才能再次尝试。",
  weakPassword: "弱密码",
  avaragePassword: "一般密码",
  goodPassword: "良好密码",
  strongPassword: "强密码",
  passwordMustHave: "您的密码必须包含：",
  UpperAndLowercaseLetters: "大写和小写字母",
  aSpecialCharacter: "一个特殊字符（#$&@）",
  atLeastOneNumber: "至少一个数字",
  minLength: "12 个或更多字符",
  pleaseEnterANewPassword: "请输入新密码",
  pleaseConfirmPassword: "请确认密码",
  autoTerminateSessionExpire:
    "出于安全原因，您的连接将在活动 8 小时后过期。请保存您的工作并退出登录。如果您想继续保持登录状态，<strong>15 分钟</strong>后我们将要求您重新输入凭证。",
  yourSessionIsAboutToExpire: "您的会话即将过期",
  terminatedSession: "此会话已终止。",
  reEnterCreds: "请<strong>重新输入</strong>您的凭证。",
  weWillSendALinkToResetYourPasswordToTheEmailAddressAssociatedWithYourAccount:
    "我们将向与您账户关联的邮箱地址发送密码重置链接。",
  sortReportBy: "报告排序方式",
  sortedByInventory: "按库存排序",
  sortedAndGroupedByStorageBox: "按仓储箱排序和分组",
  loadOrder: "装载订单",
  areYouSureYouWantToLoadThisOrder: "确定要装载此订单吗？",
  changeOrderStatusModalDescription: "新的订单状态将为 '{{status}}'。",
  noKeepItAsItIs: "否，保持原样",
  noKeepItAsStatus: "否，保持为 {{status}}",
  yesLoad: "是，装载",
  yesDeliver: "是，交付",
  noPhotosHaveBeenAddedYet: "尚未添加照片",
  transportationType: "运输类型",
  assistance: "协助",
  doorToDoor: "门到门",
  doorToPort: "门到港",
  doorToWarehouse: "门到仓",
  fotWarehouse: "FOT 仓库",
  portToDoor: "港到门",
  portToPort: "港到港",
  portToWarehouse: "港到仓",
  warehouseToDoor: "仓到门",
  warehouseToPort: "仓到港",
  warehouseToWarehouse: "仓到仓",
  accountType: "账户类型",
  accountContact: "账户联系人",
  bookingAgent: "预订代理人",
  personalPropertyProgram: "个人财产项目",
  searchForAnOption: "搜索选项",
  memberWillChangeFromSubcontractorToOwnAfterSaving:
    '保存后成员将从"分包商"变更为"自有"',
  memberWillChangeFromOwnToSubcontractorAfterSaving:
    '保存后成员将从"自有"变更为"分包商"',
  memberWillChangeFromUserToStaffAfterSaving:
    '保存后成员将从"用户"变更为"员工"',
  memberWillChangeFromStaffToUserAfterSaving:
    '保存后成员将从"员工"变更为"用户"',
  noTaskYet: "暂无任务",
  workHours: "工作时长",
  breakHours: "休息时长",
  mostCommonTask: "最常见任务",
  theCompanyDoesNotHaveARegisteredAddress: "该公司没有注册地址",
  noPhotoAdded: "未添加照片",
  exampleAyrton: "示例：Ayrton",
  exampleSenna: "示例：Senna",
  mailmailcom: "mail@mail.com",
  newUnavailability: "新建不可用时间",
  editTask: "编辑任务",
  notAllocated: "未分配",
  vipTasksWithAssign: "已分配的 VIP 任务",
  tasksWithNoAssign: "未分配的任务",
  normalTasksWithAssign: "已分配的普通任务",
  noCrewAssigned: "未分配班组",
  certificationType: "证书类型",
  defineWheterTheStorageBoxTypeRequiresPhotosSealNumberOrBoth:
    "设置该仓储箱类型是否需要照片、封条号或两者",
  checklist: "检查清单",
  sealsNumber: "封条数量",
  ifNoRuleIsAddedToAnOrderTypeTheRequiredSealNumberWillBeEqualTo1:
    "如果未为订单类型添加规则，所需封条数量默认为 1",
  checklistRules: "检查清单规则",
  itLooksLikeThereIsNoRulesAdded: "看起来尚未添加规则",
  youCanStartByAddingANewRuleByClickingTheButtonBellow:
    "您可以点击下方按钮添加新规则",
  addARule: "添加规则",
  sealNumbersNeeded: "所需封条数量",
  numberOfSealsRequired: "所需封条数量",
  whenOrderTypeIs: "当订单类型为",
  addAnotherRule: "添加另一条规则",
  sealsValueMustBeGreaterThan0: "封条数量必须大于 0",
  pleaseFillInTheCustomerInformationFirst: "请先填写客户信息。",
  isAllocated: "已分配",
  clearSelection: "清除选择",
  typeIn: "输入",
  newPlaceholderTask: "新建占位任务",
  taskName: "任务名称",
  typeHereAComment: "在此输入评论",
  deleteTask: "删除任务",
  yesDelete: "是，删除",
  areYouSureyouWantToDeleteTheTask: "确定要删除此任务吗",
  placeholder: "占位符",
  taskDescription: "任务描述",
  describeTaskHere: "在此描述任务",
  sealNumbers: "封条号",
  sealNumber: "封条号",
  photosOfSpecialItemsInside: "内部特殊物品照片",
  photosOfCaulked: "填缝照片",
  photosOfPackedAndSealed: "打包和封箱照片",
  itLooksLikeThereIsNoPhotosYet: "看起来还没有照片",
  youCanStartByAddingANewPhotoOnTheButtonBelow:
    "您可以点击下方按钮添加新照片",
  addAnotherPhoto: "添加另一张照片",
  checklistDone: "检查清单已完成",
  noTaskAdded: "未添加任务",
  createAnInternalTaskOrARegisterForADraftTask:
    "创建内部任务或登记草稿任务",
  selectAReport: "选择报告",
  crew_schedule_report: "班组排期报告",
  warehouse_schedule_report: "仓库排期报告",
  atLeastOneBranchMustBeSelected: "至少需要选择一个分支机构",
  reportTypeIsRequired: "需要选择报告类型",
  noReportGenerated: "未生成报告",
  reportGeneratedSuccessfully: "报告生成成功",
  reportsGeneratedSuccessfully: "报告生成成功",
  youMustSelectAtLeast1BranchToPrint: "至少需要选择 1 个分支机构才能打印",
  leaderName: "负责人姓名",
  memberName: "成员姓名",
  equipmentName: "设备名称",
  multiDay: "多日",
  theTaskIsFinishedSoItCannotBeRemoved: "任务已完成，无法移除。",
  showSupplierNameOnTheSSCCLabel: "在 SSCC 标签上显示供应商名称",
  dateFor: "日期用于",
  isThisAMultiDayTask: "这是一个多日任务吗？",
  endDateCantBeBeforeStartDate: "结束日期不能早于开始日期",
  quickSearch: "快速搜索",
  newSubscriber: "新建订阅者",
  searchForAnUserByTyping: "输入以搜索用户",
  enterContactType: "输入联系人类型",
  unselectAll: "取消全选",
  thereAreNoOrderBelongingToTheSelectedBranchesFor:
    "所选分支机构在以下时间段内没有订单",
  thereAreNoOrderBelongingToTheSelectedBranchesForToday:
    "所选分支机构今天没有订单",
  multi_day: "多日",
  fullDay: "全天",
  between: "介于",
  unavailableOn: "不可用于",
  h: "时",
  m: "分",
  withPhotos: "含照片",
  withoutPhotos: "不含照片",
  manageEmailSubscriptions: "管理邮件订阅",
  reportName: "报告名称",
  subscribers: "订阅者",
  editActivities: "编辑活动",
  emailActivities: "邮件活动",
  activities: "活动",
  timestamp: "时间戳",
  changes: "更改记录",
  modifiedBy: "修改人",
  selectedFilters: "已选筛选条件",
  deactivate: "停用",
  areYouSureYouWantToDeactivateThisReportEmailSubscription:
    "确定要停用此报告邮件订阅吗？",
  youWillNoLongerReceiveEmailsForTheSelectedReport:
    "您将不再收到所选报告的邮件。",
  deactivateEmailScheduleForThisReport: "是否停用此报告的邮件计划？",
  yesDeactivate: "是，停用",
  cancelGoBack: "取消并返回",
  noEmailSubscriptionsRegistered: "暂无注册的邮件订阅",
  addAdminUser: "添加管理员用户",
  oneTime: "一次性",
  emailFrequency: "邮件频率",
  noOfTasks: "任务数量",
  orderCreated: "订单已创建",
  totalOrders: "订单总数",
  ordersCompleted: "已完成订单",
  totalTasks: "任务总数",
  tasksCompleted: "已完成任务",
  exportingCSV: "正在导出 CSV",
  taskBooked: "任务已预订",
  hideTasks: "隐藏任务",
  showTasks: "显示任务",
  lifetime: "全周期",
  reportLifetimeData: "全周期报告数据",
  originBranch: "始发分支机构",
  destinationBranch: "目的分支机构",
  teamBranches: "团队分支机构",
  receiveOnlyOnce: "仅接收一次",
  receiveEveryWeek: "每周接收",
  receiveOnceAMonth: "每月接收一次",
  sendOn: "发送于",
  sendEvery: "发送频率…",
  onceYouClickOn: "当您点击",
  youWillReceiveThisReportWithAllTheSelectedFiltersAndSetFrequency:
    "后，您将按照设定的频率收到包含所有已选筛选条件（如上所列）的报告。",
  emailDeliveryMayBeDelayedDueFactorsBeyondOurControl:
    "邮件发送可能因不可控因素而延迟。",
  pleaseWhitelistToAvoidEmailsGoingToSpam:
    "请将 shipeezi.com 加入白名单，以避免邮件进入垃圾邮件。",
  subscriberMustBeRegisteredOnShipeezi: "订阅者必须在 Shipeezi 上注册",
  enterADayOfTheMonthBetween1and28: "请输入 1 到 28 之间的月份日期",
  selectReportType: "选择报告类型",
  allReports: "所有报告",
  selectTaskReportType: "选择任务报告类型",
  generateAndDownload: "生成并下载",
  workOrder: "工单",
  applicableOnlyOnInventoryConditionReport: "仅适用于库存状况报告",
  applicableOnlyOnLoadAndTransshipmentReport: "仅适用于装载和转运报告",
  applicableOnInventoryConditionReportMechanicalAndEletricalChecklistHightValuePropertyDemange:
    "适用于库存状况报告、机电检查清单、高风险/高价值库存、财产损坏报告、装载和转运报告、检查清单报告（如已选择）",
  listOfReports: "报告列表",
  allAvailableReportsForThisOrderWillBeGeneratedInOneBatchWhichMayTakeLongerThanUsual:
    "该订单的所有可用报告将一次性生成，可能比通常需要更长时间。",
  pleaseNoteThatGrayedOutReportsAreCurrentlyUnavailbaleForThisOrder:
    "请注意，灰色显示的报告当前不可用于此订单。",
  youCanChooseTheSpecificReportsYouNeedAndEachSelectedReportWillBeGeneratedAsAnIndividualFileWhichMayTakeLongerThanUsual:
    "您可以选择所需的具体报告，每份选中的报告将生成为独立文件，可能需要更长时间。",
  security: "安全",
  enableTwoFactorAuthenticationToLogin: "启用双因素认证登录",
  enableAnExternalMethodToAuthenticateLogin: "启用外部认证方式登录。",
  limitUnsuccessfulLogonAttempts: "限制登录失败次数",
  anThe4thFailedAttemptTheAccountWillBeLockedFor30Seconds:
    "第 4 次失败尝试后，账户将被锁定 30 秒；",
  onThe5thFailedAttemptTheAccountWillBeLockedFor60Seconds:
    "第 5 次失败尝试后，账户将被锁定 60 秒；",
  anyFailedAttemptsAfterThe5thTheAccountWillBeLockedFor120Seconds:
    "第 5 次之后的任何失败尝试，账户将被锁定 120 秒。",
  onThe6thFailedAttemptTheAccountWillBeLockedFor120Seconds:
    "第 6 次失败尝试后，账户将被锁定 120 秒；",
  anyFailedAttemptsAfterThe6thTheAccountWillBeLockedFor120Seconds:
    "第 6 次之后的任何失败尝试，账户将被锁定 120 秒。",
  autoTerminateSessionsAfter8HoursFromLogin: "登录 8 小时后自动终止会话",
  thePlatformCalculates8HoursFromTheMostRecentLoginAndTerminatesTheSessionRequiringTheUserToLogInAgain:
    "平台从最近一次登录起计算 8 小时后终止会话，用户需要重新登录。",
  aWarningAppears15MinutesBeforeTheSessionTeminates:
    "会话终止前 15 分钟会显示警告。",
  minimumPasswordComplexityPolicy: "最低密码复杂度策略",
  passwordsMustFulfilMinimumRequirementsForAComplexPasswordWhenCreatingOrResettingAPassword:
    "创建或重置密码时，密码必须满足复杂密码的最低要求。",
  prohibitPasswordReuse: "禁止重复使用密码",
  prohibitUsersFromReusingAPreviousPasswordWhenCreatingOrResettingAPassword:
    "禁止用户在创建或重置密码时重复使用之前的密码。",
  automatedPasswordResetPolicy: "自动密码重置策略",
  passwordsMustBeChangedEvery90Days: "密码必须每 90 天更换一次。",
  operationsApp: "运营 App",
  inventoryNumberingIsTheStartingInventoryNumberEditable:
    "库存编号：起始库存编号是否可编辑？",
  enforceAppLockScreen: "强制应用锁屏",
  usingTheAppForMilitaryPurpose: "是否将应用用于军事用途？",
  ifAUserIsInactiveForASetPeriodTheAppLocksAutomaticallyForSecurityUsersChooseAPinAtFirstLoginAndCanResetItUsingTheirUsernameAndPasswordThisPreventsUnauthorizedAccessToSensitiveData:
    "如果用户在设定时间内处于不活动状态，应用将自动锁定以确保安全。用户在首次登录时选择 PIN 码，并可使用用户名和密码重置。这可以防止对敏感数据的未经授权的访问。",
  enterInactivityTime: "输入不活动时间",
  fieldRelatedSettings: "字段相关设置",
  loadIntoStorageBoxIsMandatoryInUpliftTask: "在提升任务中必须装入仓储箱",
  systemConfigurationIsNotAvailablePleaseContactTheAdministratorForAssistance:
    "系统配置不可用。请联系管理员获取帮助。",
  updatedSuccessfully: "更新成功",
  ifVolumeConfirmationIsMandatoryThenStorageBoxMandatoryOptionMustBeSetToFalse:
    "如果体积确认为必填项，则仓储箱必填选项必须设为否。",
  volumeConfirmation: "体积确认",
  autofillBasedOnTheTask: "根据任务自动填充",
  allowMultipleSelection: "允许多选",
  inventoryFields: "库存字段",
  expanseManagement: "费用管理",
  others: "其他",
  cost: "成本",
  onceDeletedThisEntryWillBePermanentlyRemoved:
    "删除后，此条目将被永久移除。",
  loadingTaskInformation: "正在加载任务信息…",
  taskNotFound: "未找到任务",
  couldNotLoadRequestedTaskDetails: "无法加载所请求的任务详情。",
  recalculateExpenses: "重新计算费用",
  isTimeSlotRequiredForMultiDayTask: "多日任务是否需要时间段？",
  fixedTimeSlot: "固定时间段",
  variableTimeSlot: "可变时间段",
  addAnotherDate: "添加另一个日期",
  itShouldBeAtLeastTwoDates: "至少需要两个日期。",
  endTimeMustBeGreaterThanStartTime: '"结束"时间必须晚于"开始"时间。',
  generatingYourReportMightTakeLongerThanUsual:
    "生成报告可能比通常需要更长时间。",
  weWillNotifyYouAsSoonAsItsReadyForDownload:
    "报告准备好下载后我们会通知您。在此期间您可以安全关闭此窗口。",
  categorizeItemsInOperationsApp: "在运营 App 中对物品进行分类",
  checkedFieldsWillBeMarkedAsAMandatory: "勾选的字段将被标记为必填项。",
  selectCategories: "选择类别",
  mandatoryFields: "必填字段",
  mandatoryFieldsByCategory: "按类别的必填字段",
  noAccess: "无访问权限",
  fullAccess: "完全访问权限",
  partialAccess: "部分访问权限",
  newAccessRuleAdded: "已添加新访问规则 '{{accessRuleName}}'",
  newAccessRuleAddedAndSetAsInactive:
    "已添加新访问规则 '{{accessRuleName}}' 并设为未启用",
  accessRuleUpdatedSuccessfully: "访问规则 '{{accessRuleName}}' 更新成功",
  accessRuleDeletedSuccessfully: "访问规则 '{{accessRuleName}}' 删除成功",
  thisIsASystemDefaultAccessRuleAndCannotBeModifiedYouAreWelcomeToCreateANewAccessRuleOrDuplicateAsNeeded:
    "这是系统默认访问规则，无法修改。欢迎您根据需要创建新规则或复制现有规则。",
  thisAccessRuleIsUtilizedBy: "此访问规则正在被 {{group}} 使用",
  returnToPermissions: "返回权限设置",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeactivated:
    "此规则当前正在被群组使用，无法停用。",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeleted:
    "此规则当前正在被群组使用，无法删除。",
  pleaseUseOnlyLettersNumbersAndSpacesSpecialCharactersAreNotAllowed:
    "请仅使用字母、数字和空格，不允许使用特殊字符。",
  enterNameForThisAccessRule: "输入此访问规则的名称",
  describeThisAccessRuleInFewWords: "用简短文字描述此访问规则",
  failedToAssignPermissionsToAccessRulePleaseTryAgain:
    "为访问规则分配权限失败，请重试。",
  yourPermissionsHaveBeenUpdatedPleaseLogInAgainToApplyTheNewChanges:
    "管理员已更新您所在群组的访问权限。要应用更改，您需要退出登录并重新登录。",
  signBackIn: "重新登录",
  groupAccessRuleUpdated: "群组访问规则已更新",
  theAccessRuleNameAlreadyExistsPleaseChooseADifferentName:
    "访问规则名称 '{{accessRuleName}}' 已存在，请选择其他名称。",
  enterNickname: "输入昵称",
  nicknameIsForYourOwnReference: "昵称仅供您个人参考",
  dateOfDeparture: "出发日期",
  arrivalAtAod: "到达 AoD",
  enterOrder: "输入订单",
  enterEmail: "输入邮箱",
  enterMobileNumber: "输入手机号",
  realTimeTrackingUnavailable: "实时跟踪不可用",
  liveTrackingIsUnavailableOnYourCurrentPlanUnlockThisFeatureByUpgradingYourPlanOrContactingOurSupportTeamForAssistance:
    "实时跟踪在您当前的方案中不可用。升级\n您的方案或联系我们的支持团队以解锁此功能。",
  typeOfContact: "联系人类型",
  notifyVia: "通知方式",
  refineByOrder: "按订单筛选",
  bolBooking: "BoL/预订",
  pol: "PoL",
  utilization: "利用率",
  destinationAirport: "目的机场",
  display: "显示",
  items2: "项",
  exportCSV: "导出 CSV",
  numberOfRowsPerPage: "每页行数",
  errorField: "错误",
  showHideColumn: "显示/隐藏列",
  typeAndClickEnterToAdd: "输入并按回车键添加",
  communicationSentSuccessfully: "通讯发送成功！",
  deSelectAll: "取消全选",
  selectOrders: "选择订单",
  addSelectedOption: "添加选中的订单",
  volumeAdded: "已添加体积",
  noLinkNotYet: "尚无关联订单！",
  notifyUsers: "通知用户",
  notificationSentSuccessfully: "通知发送成功！",
  continueBooking: "继续预订",
  saveADraft: "保存为草稿",
  grossWeightKg: "毛重 (Kg)",
  saveThisSearch: "保存此搜索",
  serial: "序列号",
  groupManagementCreatedSuccessfully: "群组 '{{groupName}}' 创建成功",
  groupManagementUpdatedSuccessfully: "群组 '{{groupName}}' 更新成功",
  errorUpdateGroupManagement:
    "更新群组 '{{groupName}}' 时发生错误。请联系 Shipeezi 支持团队获取帮助",
  groupInfoViewOnly:
    "这是系统默认群组，无法修改，但您可以添加或移除其中的成员",
  groupNameAlreadyExists:
    "群组名称 '{{groupName}}' 已存在，请选择其他名称。",
  departure: "出发",
  arrival: "到达",
  itLooksLikeYoureAboutToLeaveTheBookingProcessIfYouExitNowYourBookingWillNotBeCompletedAndAllTheInformationYouveEnteredSoFarWillBeLost:
    "您似乎要离开预订流程。如果现在退出，预订将不会完成，您已输入的所有信息将丢失。",
  importantOnceYouLeaveTheresNoGuaranteeThatTheSameAvailabilityAndRatesWillStillApplyIfYouStartTheBookingAgain:
    "重要提示：一旦离开，如果重新开始预订，无法保证相同的可用性和费率仍然适用。",
  areYouSureYouWantToCancel: "确定要取消吗？",
  connectionTimeout: "连接超时：请重试",
  timeoutDetail:
    "所需时间超出预期。这可能是临时问题，请刷新页面或稍后重试。",
  retry: "重试",
  nothingToDisplayHere: "此处暂无内容显示！",
  toGetStartedFillOutTheSearchFormWithYourFreightDetailsAndHitTheSearchButtonToSeeTheBestAvailableOptions:
    '要开始使用，请在搜索表单中填写货运详情，然后点击"搜索"按钮查看最佳可用选项。',
  averagePassword: "一般密码",
  tariff: "关税",
  roadFreightPickUp: "公路货运\n（取货）",
  thcO: "THC-O",
  exportService: "出口服务",
  thcD: "THC-D",
  importService: "进口服务",
  roadFreightDelivery: "公路货运（送货）",
  carbonOffset: "碳抵消",
  transportMode: "运输方式",
  rateValidity: "费率有效期",
  totalCargoWeight: "货物总重量",
  inspectionServices: "检验服务",
  customClearance: "清关",
  etaAtWarehouse: "预计到达仓库时间",
  edd: "EDD",
  etaUnpack: "预计拆箱时间",
  supplierPortalBannerMessagePaymentPending:
    "根据 <strong>{{incoterm}} 贸易术语</strong>，费用须由买方支付。预订将在付款后确认。",
  supplyChainBannerMessagePaymentPending:
    "根据 <strong>{{incoterm}} 贸易术语</strong>，需要支付费用以确认预订。",
  originTerminalHandlingCharge: "始发港码头操作费",
  destinationTerminalHandlingCharge: "目的港码头操作费",
  portOfLoadingPoL: "装货港 (PoL)",
  portOfDischargePoD: "卸货港 (PoD)",
  movementType: "移动类型",
  freightCharges: "运费",
  payWithCard: "银行卡支付",
  notRequired: "非必填",
  paymentWillBeAvailableToTheBuyerSoon: "买方即将可以进行付款。",
  theBuyerHasPaidSuccessfully: "买方已成功付款。",
  thisBookingHasExpiredAndBeenCancelled: "此预订已过期并被取消。",
  onceConfirmedThisWillBeSentToTheCarrierYouAreNotAbleToMakeAnyAdditionalChanges:
    "确认后将发送给承运商，届时您将无法进行任何更改。",
  payBooking: "支付预订",
  paidOn: "支付于",
  noAllocated: "未分配",
  thisFieldDoesntAllowSpecialCharacters: "此字段不允许使用特殊字符",
  anErrorOccurredWhileProcessingYourRequestPleaseTryAgainOrContactSupport:
    "处理您的请求时发生错误。请重试或联系支持团队。",
  anErrorOccurredWhileProcessingYourRejectionPleaseTryAgainOrContactSupport:
    "处理您的拒绝请求时发生错误。请重试或联系支持团队。",
  errorProcessingRejection: "处理拒绝时出错",
  errorProcessingRequest: "处理请求时出错",
  areYouAnExistingShipeeziUser: "您是 Shipeezi 的现有用户吗？",
  yesGoToLoginPage: "是，前往登录页",
  noRegisterAsAnAgent: "否，注册为代理人",
  selectCompany: "选择公司",
  enterName: "输入名称",
  connect: "连接",
  anErrorOccurredWhileTryingToConnectTheCompaniesPleaseTryAgainLater:
    "连接公司时发生错误，请稍后重试。",
  invalidOrExpiredLink: "无效或已过期的链接",
  thisInvitationLinkIsInvalidOrHasAlreadyExpiredPleaseContactUsToReceiveANewInvitation:
    "此邀请链接无效或已过期。请联系我们获取新的邀请。",
  paymentPending: "待付款",
  processing: "处理中",
  searchFreight: "搜索货运",
  freightBooking: "货运预订",
  YourShipeeziID: "您的 Shipeezi ID",
  noOfOrders: "订单数量",
  carriersFound: "找到的承运商",
  LowToHigh: "从低到高",
  HighToLow: "从高到低",
  directRoutes: "直达路线",
  alternateRoutes: "替代路线",
  alternate: "替代",
  direct: "直达",
  Shipmentno: "运输件编号",
  passwordResetSuccesfully: "密码重置成功",
  frieghtid: "货运 ID",
  passwordRestLinkExpired: "密码重置链接已过期",
  valid: "有效",
  customerIsNotAllowedToReceiveNotification: "该客户不允许接收通知",
  carbonFootprint: "碳足迹",
  PlaceOfDestination: "目的地",
  advanceShippingNoticeIsRequired: "需要预先发货通知",
  weightCantBe0: "重量不能为 0",
  shipTermsIsRequired: "需要填写运输条款",
  selectOfficeFromTheDropdown: "从下拉列表中选择办事处",
  marksAndNumber: "唛头和编号",
  requiredDocument: "必需文件",
  supportingDocuments: "证明文件",
  optionalShipmentData: "可选运输数据",
  requiredVolumeConfirmation: "体积确认为必填项",
  shipmentsSettings: "运输件",
  seaTrackingEnabled: "海运跟踪已启用",
  airTrackingEnabled: "空运跟踪已启用",
  accessRuleCreatedSuccessfully: "已添加新访问规则 '{{accessRuleName}}'",
  accessRuleDuplicatedSuccessfully: "已添加新访问规则 '{{accessRuleName}}' 并设为未启用",
  accessRuleInfoViewOnly:
    "这是系统默认访问规则，无法修改。欢迎您根据需要创建新规则或复制现有规则。",
  viewGroupAccessRuleTitle: "此访问规则正在被 {{groupCount}} 个群组使用",
  accessRuleNameHaveSpecialCharacter:
    "请仅使用字母、数字和空格，不允许使用特殊字符。",
  updatedPreference: "数据表偏好设置已更新！",
  subscriberThatLinkedToOrdersIsNotAllowedToBeDelete:
    "关联到订单的订阅者无法删除！",
  minimumPageSizeGreaterThanTen: "最小页面大小为 10",
  subscriberSuccessfullyAdded: "订阅者添加成功",
  defaultTeam: "默认团队",
  customTeam: "自定义团队",
  created: "已创建",
  noMatchingRecordsFound: "未找到匹配记录",
  tryAdjustingYourFilters: "请尝试调整筛选条件。",
  noRecordFound: "未找到记录",
  haveTask: "有任务",
  dontHaveTask: "无任务",
  forContainerOnRow: "用于行中的集装箱",
  column: "列",
  storeName: "门店名称",
  loadedStatus: "装载状态",
  markAsDefault: "标记为默认",
  enterTemplateName: "输入模板名称",
  enterSubject: "输入主题",
  enterFromName: "输入发件人名称",
  enterStatus: "输入状态",
  enterAvailableIn: "输入可用范围",
  enterAutomation: "输入自动化",
  enterLastUpdate: "输入最后更新",
  addBusinessIcon: "添加企业图标",
  addBusinessLogo: "添加企业标志",
  addIcon: "添加图标",
  fromName: "发件人名称",
  formatsJPG_GIF_PNG: "格式：JPG、GIF、PNG",
  maxSize2MB: "最大：2MB",
  attachments: "附件",
  pushNotification: "推送通知",
  salesApp: "销售 App",
  linkedAutomation: "关联自动化",
  noAutomationsLinked: "暂无关联自动化",
  signup: {
    left: {
      title: "一个平台，每一次搬运",
      subtitle:
        "开始您的免费试用，体验Shipeezi如何将工作流程的每个环节统一起来——从销售到运营再到仓储。",
      card1Title: "规模化的简约",
      card1Desc:
        "Shipeezi将您的所有流程整合在一个平台上，帮助您的团队在全球范围内更智能、更高效地工作。",
      card2Title: "更多控制，更低成本",
      card2Desc:
        "一切互联互通，您将节省时间、减少错误、降低成本——同时为客户提供无缝体验。",
      trusted: "受到全球行业领袖的信赖",
    },
    right: {
  createAccount: "创建您的账户",
      subtitle:
        "您距离全面掌控和了解您的货运状况仅一步之遥！",
  haveAccount: "已有账户？",
  signIn: "登录",
      thankYou: "感谢您申请Shipeezi账户",
      pendingApproval: "我们的团队将在激活您的账户之前与您联系",

      // Step 2
      step2Title: "告诉我们您的业务情况",
      step2Subtitle: "我们将根据贵公司的需求定制Shipeezi",
  companyName: "公司名称",
  companyType: "公司类型",
      selectYourPlatform: "选择您的平台",

      // Step 3
      step3Title: "您希望通过Shipeezi改善哪些方面？",
      step3Subtitle: "选择您想简化和扩展的业务领域",
  sales: "销售",
  operations: "运营",
  warehousing: "仓储",

      // botões genéricos
  next: "下一步",
  back: "返回",

      // (para etapas futuras, mas já deixo pronto)
  requestAccount: "申请账户",
  termsOfUse: "使用条款",
  privacyPolicy: "隐私政策",
  and: "和",
      byContinuingYouReAgreeingToShipeeziS: "继续即表示您同意Shipeezi的",
      getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime:
        "接收 Shipeezi 关于产品更新、行业新闻和活动的电子邮件。如果您改变主意，可以随时退订。",
  captchaExpired: "验证码已过期",

      step4Title: "帮助我们了解您的销售流程",
      step4Subtitle: "您的回答将帮助我们为您的团队配置Shipeezi",

      // Questions
      videoSurveysQuestion: "您是否为客户提供视频勘查服务？",
      salesRepsQuestion: "贵公司有多少名销售代表？",
  yes: "是",
  no: "否",
      range_1_10: "1-10",
      range_11_20: "11-20",
      range_above_30: "30以上",

      // Titles/subtitles por área (Step 4)
      salesStepTitle: "帮助我们了解您的销售流程",
      salesStepSubtitle: "您的回答将帮助我们为您的团队配置Shipeezi",

      operationsStepTitle: "告诉我们您的运营情况",
      operationsStepSubtitle: "我们将根据贵公司目前的运营方式设置Shipeezi",

      warehousingStepTitle: "告诉我们您的仓储情况",
      warehousingStepSubtitle:
        "我们将在Shipeezi中优化您的仓储和库存设置",

      // Warehousing
      storageQuestion: "您是否为客户提供仓储服务？",
      warehousesCountQuestion: "您管理多少个仓库？",

      // Operations
      shipmentType: "运输类型",
      local: "本地",
      international: "国际",
      interstate: "州际",
      military: "军事",
      annualShipmentVolume: "年运输量",
      v_1_4: "1-4",
      v_5_600: "5-600",
      v_601_10000: "601 - 10,000",
      v_10001_20000: "10,001 - 20,000",
      v_20001_plus: "20,001 +",

      step5Title: "太棒了！我们快完成了！",
      step5Subtitle: "我们很想知道您是如何发现Shipeezi的！",

      thankYouV2Title: "感谢您注册！",
      thankYouV2Description:
        "我们的团队将很快与您联系以激活您的账户。届时您将可以体验Shipeezi——一个平台，每一次搬运。",
      returnToWebsite: "返回我们的网站",

      // Discovery options
      discover: {
        website: "我们的网站",
  email: "电子邮件",
        google: "Google",
        newsletter: "电子通讯",
        aiTools: "AI工具",
        referral: "推荐",
        whereLabel: "在哪里？",
        whoReferredLabel: "是谁推荐您的？",
        other: "其他",
      },
      wh_1_10: "1-10",
      wh_11_30: "11-30",
      wh_above_30: "30 以上",
      trustedBy: "深受全球行业领导者信赖",
      paymentTerms: "付款条款",
      privacyAndCompliance: "隐私与合规政策",
      saasAgreement: "SAAS 协议与 SLA",
      termsOfSale: "销售条款",
      termsPrefix: "继续即表示您同意 Shipeezi 的",
      ownWords: {
        questionLabel: "您目前面临哪些挑战或障碍？",
        placeholder: "输入内容...",
        characters: "字符",
        helperShort: "您的消息至少需要 50 个字符。",
        helperLong: "请将消息控制在 500 个字符以内。",
      },
    },
  },
  common: {
    close: "关闭",
    save: "保存",
    saving: "保存中",
  },
  onboarding: {
  pageTitle: "入职引导",
    left: {
      title: "欢迎使用Shipeezi！\n一个平台，每一次搬运",
      subtitle:
        "您只需几个简单步骤即可完成账户设置。Shipeezi将帮助您简化流程、连接团队，让您全面掌控每一次搬运。让我们开始吧。",
    },
    steps: {
  introduction: "介绍",
      companyDetails: "公司详情",
      myBilling: "我的账单",
      members: "成员",
      uploadCentre: "上传中心",
  complete: "完成",
    },
    uploadCentre: {
      title: "上传中心",
      description:
        "在这里您可以上传自己的文件（如库存、员工或服务清单）或使用Shipeezi的默认列表。您随时可以更新。",
      uploadOwnList: "上传我的自定义列表",
      uploadOwnListDescription: "从一开始就导入您自己的数据来定制Shipeezi。",
      useDefaultList: "使用Shipeezi默认列表（ISO17451-1:2016）",
      useDefaultListDescription:
        "使用我们基于全球ISO17451-1:2016标准的预配置列表快速开始。您可以随时更新或扩展。",
  downloadTemplate: "在此处下载我们的 CSV 模板",
  complete: "完成",
    },
    complete: {
      title: "欢迎使用Shipeezi——可视化、掌控力和简约汇聚于此。",
      subtitle: "",
  button: "开始使用",
      leftTitle: "设置完成！",
      leftSubtitle: "您已准备好在一个平台上管理每一次搬运。",
    },
    buttons: {
  goBackToLogin: "返回登录",
      skip: "暂时跳过",
  downloadCsvTemplate: "在此处下载我们的 CSV 模板",
  next: "下一步",
  back: "返回",
    },
    introduction: {
      companyDetails:
        "添加您的公司信息、业务地址、主要联系人和电子邮件详情，以便我们正确设置您的账户。",
      members:
        "邀请您的团队成员并分配适当的权限，让他们在需要的地方获得访问权限。",
      uploadCentre:
        "上传您的初始信息和数据，以便Shipeezi能为您无缝连接一切。",
    },
    members: {
      title: "成员",
      description: "邀请与您一起使用 Shipeezi 的人员。分配其角色和分支机构，以便从一开始就拥有正确的访问权限。您可以随时更新或添加更多成员。",
      registeredMembers: "已注册成员",
      firstName: "名",
      lastName: "姓",
      email: "电子邮件",
      memberCode: "成员代码",
      branch: "分支机构",
      mobile: "手机",
      accessGroup: "访问组",
      memberType: "成员类型",
      additionalMembers: "其他成员",
      uploadMembers: "上传成员",
      addMembers: "添加成员",
      name: "名称",
      group: "组",
      type: "类型",
      noAdditionalMembers: "无其他成员",
      downloadTemplate: "下载模板",
      uploadCSV: "上传 CSV",
      addMember: "添加成员",
      userCode: "用户代码",
    },
    billing: {
      useSameAdmin: '使用与"管理员用户"相同的详细信息',
      contactName: "账单联系人姓名",
  email: "电子邮件",
  phone: "电话号码",
  address: "地址",
      paymentMethod: "付款方式",
      noPaymentMethod: "未注册付款方式",
      addPaymentMethod: "添加付款方式",
  creditCard: "信用卡",
      nameOnCard: "持卡人姓名",
    },
  },
  notShared: "未共享",
  partiallyShared: "部分共享",
  fullyShared: "完全共享",
  scac: "SCAC",
  inventorySummary: "库存概要",
  networkDetails: "详情",
  networkRoles: "角色",
  networkWeightAndMeasurements: "重量与尺寸",
  networkPickup: "取货",
  networkDelivery: "交付",
  networkGeneralComments: "一般备注",
  networkActualInventory: "实际库存",
  networkQuotedInventory: "报价库存",
  networkPhotosAndVideos: "照片与视频",
  networkDocuments: "文档",
  networkSettingsBannerMessage:
    "从下方区域选择您希望在网络代理人接受任务时显示的数据字段。",
  failedToSaveNetworkSettings: "保存网络设置失败，请重试。",
  assignToAnAgent: "分配给代理人？",
  selectAnAgent: "选择代理人",
  additionalInstructions: "附加说明",
  enterAdditionalInstructions: "输入附加说明",
  agentName: "代理人名称",
  started: "已开始",
  taskAddedSuccessfully: "任务添加成功！",
  thisInstructionWillBeVisibleInTheEmailAndTaskView:
    "此说明将在邮件和任务视图中可见。",
  moreJobTypes: "更多作业类型",
  moreTaskTypes: "更多任务类型",
  moreTriggers: "更多触发器",
  selectTaskTypes: "选择任务类型",
  selectOrderTypes: "选择订单类型",
  selectTriggers: "选择触发器",
  typeCode: "类型编码",
  newChecklist: "新建检查清单",
  enterQuestionHere: "在此输入问题",
  responseType: "回复类型",
  addLogic: "添加逻辑",
  shortDescription: "简短描述",
  enterDescriptionHere: "在此输入描述",
  singleChoiceQuestion: "单选题",
  multipleChoiceQuestion: "多选题",
  inputText: "文本输入",
  inputNumber: "数字输入",
  selectDate: "选择日期",
  addSignature: "添加签名",
  checklistItem: "检查清单项",
  enterOptions: "输入选项",
  option: "选项",
  addQuestion: "添加问题",
  defaultState: "默认状态",
  taskTypes: "任务类型",
  jobTypes: "作业类型",
  ifAnswer: "如果回答",
  is: "是",
  isNot: "不是",
  then: "则",
  enterText: "输入文本",
  enterNumber: "输入数字",
  selectOption: "选择选项",
  isLesserThan: "小于",
  isGreaterThan: "大于",
  selected: "已选择",
  notSelected: "未选择",
  if: "如果",
  requireEvidence: "要求证据",
  askQuestion: "提问",
  chooseTheEvidenceThatllBeRequiredWhenThisAnswerIsSelected:
    "选择当此答案被选中时所需的证据。",
  youShouldAddAtLeastOneOption: "请至少添加一个选项。",
  youShouldAddAtLeastTwoOptions: "请至少添加两个选项。",
  allOptionsShouldHaveAName: "所有选项都应有名称。",
  methodOfPreparation: "准备方法",
  itemCharacteristics: "物品特征",
  highRiskHighValueChecklist: "高风险/高价值检查清单",
  proGearChecklist: "专业装备检查清单",
  isHighRisk: "高风险",
  notHighRisk: "非高风险",
  isProGear: "专业装备",
  notProGear: "非专业装备",
  meChecklistNotDone: "机电检查清单未完成",
  unsavedItem: "未保存的项目，请保存以正确应用所有筛选条件",
  youHaveUnsavedChanges: "您有未保存的更改。",
  doYouWantToSaveBeforeLeaving: "离开前是否要保存",
  timezoneIssue: "时区问题",
  allQuestionsMustHaveATitleAndAllLogicsFieldsMustBeFilled:
    "所有问题必须有标题，且所有逻辑字段必须填写。",
  areYouSureYouWantToDeleteThisLogic: "确定要删除此逻辑吗",
  deleteLogic: "删除逻辑",
  atLeastOneOptionIsRequired: "至少需要一个选项",
  atLeastTwoOptionsAreRequired: "至少需要两个选项",
  templateNameAlreadyExists: "模板名称已存在！",
  userUploaded: "用户上传",
  systemGenerated: "系统上传",
  uploadFiles: "上传文件",
  orDragAndDropHere: "或将文件拖放到此处",
  maxFileSizeLimit: "文件大小上限为 25 MB。接受的格式：",
  quickOrder: "快速订单",
  createQuickOrder: "创建快速订单",
  automaticSequenceUnavailableEnterReferenceManually: "自动序列不可用，请手动输入参考编号。",
  enableQuickOrder: "启用快速订单",
  showOrderReportInManagement: "在 Management 中显示订单报告",
  reportsAvailableForSharingViaOpsApp: "可通过 Ops App 分享的报告",
  noReportsAvailableForSharingViaOpsApp: "没有可通过 Ops App 分享的报告",
  orderReport: "订单报告",
  orderAlreadyExists: "订单已存在",
  searchOrAddCustomer: "搜索或添加客户",
  aCustomerWithSameIdAlreadyExists: "相同 ID 的客户已添加",
  addANoteAsEvidence: "添加备注作为证据",
  addAPhotoAsEvidence: "添加照片作为证据",
  displayInDispatchModule: "在调度模块中显示",
  leavingTheWarehouse: "离开仓库",
  leads: "潜在客户",
  estimates: "估价",
  proposal: "提案",
  invoicing: "开票",
  creditNotes: "贷项通知单",
  expenses: "费用",
  claims: "理赔",
  storageBoxUnit: "仓储箱与单元",
  storageAccount: "仓储账户",
  finance: "财务",
  packageType: "包装类型",
  methodType: "方法类型",
  itemInstruction: "物品说明",
  communicationCentre: "通讯中心",
  leadSoure: "潜在客户来源",
  help: "帮助",
  askDumont: "询问 Dumont",
  dumontHelpDocumentation: "帮助与文档",
  dumontSendFeedback: "发送反馈",
  dumontContactSupport: "联系支持",
  dumontLearnHowToUseDumont: "了解如何有效使用 Dumont",
  dumontHelpUsImproveDumont: "帮助我们改进 Dumont",
  dumontGetHelpFromTeam: "获取团队帮助",
  dumontQuickActions: "快速操作",
  dumontContactOurSupport: "联系我们的支持团队",
  dumontGetHelpWithIssues: "获取任何问题的帮助",
  dumontSendUsYourFeedback: "向我们发送您的反馈",
  dumontShareThoughtsAndSuggestions: "分享您的想法和建议",
  dumontCommonQuestions: "常见问题",
  dumontHowToCreateCustomAgent: "如何创建自定义代理？",
  dumontHowToCreateCustomAgentAnswer: "您可以从Dumont中的代理选项卡创建自定义代理。",
  dumontWhatCanDumontHelp: "Dumont 可以帮我做什么？",
  dumontWhatCanDumontHelpAnswer:
    "Dumont 是您专注于物流和搬运的 AI 助手。我可以帮助您进行调度规划、订单管理、路线优化，以及回答有关您运营的问题。",
  dumontHowToAccessChatHistory: "如何访问我的聊天记录？",
  dumontHowToAccessChatHistoryAnswer:
    "点击侧边栏中的历史记录图标，查看您与 Dumont 的所有过往对话。您可以搜索历史记录并恢复任何之前的对话。",
  dumontCanCustomizeAgentCapabilities: "可以自定义代理功能吗？",
  dumontResources: "资源",
  dumontKnowledgeBase: "知识库",
  dumontCompleteGuidesAndTutorials: "完整指南和教程",
  dumontSelectAnOption: "选择一个选项",
  dumontFeedbackHelpsImprove: "您的反馈帮助我们改进 Dumont",
  dumontIssueType: "问题类型",
  dumontSubject: "主题",
  dumontBriefDescriptionOfIssue: "简要描述您的问题",
  dumontMessage: "消息",
  dumontPleaseDescribeIssueDetail: "请详细描述您的问题…",
  dumontIncludeErrorMessages: "请包含任何错误信息或重现问题的步骤",
  dumontGotIt: "知道了",
  dumontCancel: "取消",
  dumontSendFeedbackButton: "发送反馈",
  dumontSendMessage: "发送消息",
  dumontSupportRequestSentSuccessfully: "您的支持请求已成功发送。我们的团队将在 24 小时内回复。",
  dumontFeedbackSentSuccessfully: "您的反馈已成功发送。感谢您的宝贵意见！",
  dumontSearchPlaceholder: "搜索聊天、代理、历史记录…",
  dumontNavigation: "导航",
  dumontNewChat: "新建聊天",
  dumontChats: "聊天",
  dumontNoChatsFound: "未找到聊天",
  dumontNoRecentChats: "暂无近期聊天",
  dumontAgents: "代理",
  dumontNoAgentsFound: "未找到代理",
  dumontReturnToShipeezi: "返回 Shipeezi",
  dumontHelp: "帮助",
  dumontWelcomeMessage:
    "您好，{{userName}}，我是 Dumont，您专注于物流和搬运的 AI 助手。我专为简化复杂的工作流程而构建，持续学习以为您的业务提供更快、更智能、更精准的支持。",
  dumontWelcomeMessageBusiness:
    "您好，{{userName}}，我是 Dumont 商务助手！💼 我专注于销售和报价。我可以帮助您创建精准的货运报价、管理客户关系，并更快地完成交易。今天我能为您做什么？",
  dumontWelcomeMessageOperations:
    "您好，{{userName}}，我是 Dumont 运营助手！📊 我是您的运营专家。我可以帮助您跟踪货运、监控交付、管理作业，并确保物流运营顺畅。您需要什么帮助？",
  dumontWelcomeMessageWarehousing:
    "您好，{{userName}}，我是 Dumont 仓储助手！🏭 我专注于库存和仓库运营。我可以帮助您管理库存水平、跟踪库存、协调仓储，并优化仓库效率。我能为您做什么？",
  dumontDispatchQuickActions: "调度快速操作",
  dumontHistory: "历史记录",
  dumontConversationHistory: "对话历史",
  dumontNoConversationsFound: "未找到对话",
  dumontNoConversationHistory: "暂无对话历史",
  dumontTryDifferentSearchTerm: "尝试其他搜索词",
  dumontStartNewConversation: "开始新对话后将在此处显示",
  dumontFileTooLarge: "文件太大。最大大小为 10MB。",
  dumontUnsupportedFileType: "不支持的文件类型。请选择 TXT、PDF 或 DOC/DOCX 文件。",
  dumontDocumentProcessing:
    "PDF/DOC 处理功能即将推出，请暂时使用 TXT 文件。",
  dumontFileProcessingError: "处理文件时出错，请重试。",
  dumontAskDumont: "询问 Dumont…",
  dumontAskDumontAnything: "向 Dumont 提问",
  dumontUpload: "上传",
  dumontUsesAI: "Dumont 使用人工智能。请审核回复内容。",
  dumontCopyConversation: "复制对话",
  dumontExportChat: "导出聊天",
  dumontClearConversation: "清除对话",
  dumontLoadingAgents: "正在加载代理…",
  dumontAgentsTitle: "Dumont 代理",
  dumontCreateAgent: "创建代理",
  dumontSearchAgents: "搜索代理…",
  dumontNoAgentsAvailable: "暂无可用代理",
  dumontAgentsAvailableSoon: "代理即将上线",
  featureLocked: "功能已锁定",
  accountNotHaveAccess: "您的账户目前无权访问此功能。",
  reachSupportTeam: "联系我们的支持团队",
  forDetails: " 了解详情。",
  titleFeatureRequestSupport: "请求访问此功能",
  sendRequestSupport: "向支持团队发送请求",
  itLooksLikeYouDontHaveAcessThisFeatureYet:
    "您似乎尚未获得此功能的访问权限。如果您想使用，请向我们的支持团队发送请求。",
  feature: "功能",
  pleaseDescribeYouIntendUseFeature: "请描述您打算如何使用此功能",
  yourMessageShouldLeast50Characters: "您的消息至少需要 50 个字符。",
  minCharacters: "您的消息至少需要 {{count}} 个字符。",
  maxCharacters: "您的消息不得超过 {{count}} 个字符",
  yourRequestHasBeenSentOurSupportTeam: "您的请求已发送至我们的支持团队",
  TermsConditions: "条款与条件",
  Iso14451: "ISO14451-1:2016",
  Iso17451: "ISO17451 - 1:2016",
  dumontConversationHistory: "对话历史",
  dumontNoConversationHistory: "暂无对话历史",
  dumontStartNewConversation: "开始新对话后将在此处显示",
  dumontAgentsTitle: "Dumont 代理",
  dumontCreateAgent: "创建代理",
  dumontSearchAgents: "搜索代理…",
  dumontComingSoon: "即将推出…",
  dumontBusinessAssistant: "商务助手",
  dumontBusinessAssistantDesc: "专注于销售和报价",
  dumontOperationsAssistant: "运营助手",
  dumontOperationsAssistantDesc: "您的全能运营专家",
  dumontWarehousingAssistant: "仓储助手",
  dumontWarehousingAssistantDesc: "库存和仓库运营专家",
  dumontAskDumont: "询问 Dumont…",
  dumontUsesAI: "Dumont 使用人工智能。请审核回复内容。",
  dumontLearnHowToUseDumont: "了解如何有效使用 Dumont",
  dumontContactOurSupport: "联系我们的支持团队",
  dumontGetHelpWithIssues: "获取任何问题的帮助",
  dumontHowToCreateCustomAgentAnswer:
    '要创建自定义代理，请导航到代理部分并点击"创建新代理"按钮。然后您可以根据需要配置代理的功能和设置。',
  dumontWhatCanDumontHelp: "Dumont 可以帮我做什么？",
  dumontWhatCanDumontHelpAnswer:
    "Dumont 是您专注于物流和搬运的 AI 助手。我可以帮助您进行调度规划、订单管理、路线优化，以及回答有关您运营的问题。",
  dumontHowToAccessChatHistoryAnswer:
    "点击侧边栏中的历史记录图标，查看您与 Dumont 的所有过往对话。您可以搜索历史记录并恢复任何之前的对话。",
  dumontCanCustomizeAgentCapabilitiesAnswer:
    "可以！每个代理都可以根据您的具体工作流程进行自定义。您可以调整其功能、设置特定参数，并配置其可访问的数据源。",
  dumontFeedbackType: "反馈类型",
  dumontYourFeedback: "您的反馈",
  dumontTellUsWhatYouThink: "告诉我们您的想法…",
  dumontSendFeedbackButton: "发送反馈",
  dumontIssueType: "问题类型",
  dumontBriefDescriptionOfIssue: "简要描述您的问题",
  dumontPleaseDescribeIssueDetail: "请详细描述您的问题…",
  dumontIncludeErrorMessages: "请包含任何错误信息或重现问题的步骤",
  dumontSendMessage: "发送消息",
  dumontSupportRequestSentSuccessfully:
    "您的支持请求已成功发送。我们的团队将在 24 小时内回复。",
  dumontFeedbackSentSuccessfully:
    "您的反馈已成功发送。感谢您的宝贵意见！",
  dumontPleaseSelectTextFile: "请选择文本文件 (.txt)",
  dumontDocumentAttached: "文档已附加",
  dumontRemoveDocument: "移除文档",
  dumontDefaultResponse:
    "感谢您的联系！我正在分析您的请求，将为您提供最佳解决方案。",
  dumontSales: "销售",
  dumontOperations: "运营",
  dumontLogistics: "物流",
  thisLinkIsNotValidPleaseCheckIfYouHaveAccessedTheCorrectLink:
    "此链接无效。请检查您是否访问了正确的链接。",
  youCanSafelyCloseThisWindowNowIfYouNeedAnyFurtherAssistanceFeelFreeToReachOutHaveAGreatDay:
    "您现在可以安全关闭此窗口。如需进一步帮助，请随时联系我们。祝您愉快！",
  anErrorOccurredWhileProcessingYourRequestPleaseTryAgainOrContactSupport:
    "处理您的请求时发生错误。请重试或联系支持团队。",
  anErrorOccurredWhileProcessingYourRejectionPleaseTryAgainOrContactSupport:
    "处理您的拒绝请求时发生错误。请重试或联系支持团队。",
  anErrorOccurredWhileTryingToConnectTheCompaniesPleaseTryAgainLater:
    "连接公司时发生错误，请稍后重试。",
  thisInvitationLinkIsInvalidOrHasAlreadyExpiredPleaseContactUsToReceiveANewInvitation:
    "此邀请链接无效或已过期。请联系我们获取新的邀请。",
  networkSettingsBannerMessage:
    "从下方区域选择您希望在网络代理人接受任务时显示的数据字段。",
  thisInstructionWillBeVisibleInTheEmailAndTaskView:
    "此说明将在邮件和任务视图中可见。",
  chooseTheEvidenceThatllBeRequiredWhenThisAnswerIsSelected:
    "选择当此答案被选中时所需的证据。",
  allQuestionsMustHaveATitleAndAllLogicsFieldsMustBeFilled:
    "所有问题必须有标题，且所有逻辑字段必须填写。",
  // Dumont Dispatch Prompts
  dumontDispatchShowTodayOrders: "显示今天的调度订单",
  dumontDispatchShowTodayOrdersDesc: "获取今天计划调度的所有订单摘要",
  dumontDispatchFindCustomer: "按客户名称查找订单",
  dumontDispatchFindCustomerDesc: "使用客户信息搜索特定订单",
  dumontDispatchTrackStatus: "跟踪订单状态",
  dumontDispatchTrackStatusDesc: "查看系统中订单的当前状态",
  dumontDispatchOptimizeRoutes: "优化送货路线",
  dumontDispatchOptimizeRoutesDesc: "获取最高效送货路线的建议",
  dumontDispatchQuickActions: "调度快速操作",
  dumontWelcomeMessage:
    "您好，{{userName}}，我是 Dumont，您专注于物流和搬运的 AI 助手。我专为简化复杂的工作流程而构建，持续学习以为您的业务提供更快、更智能、更精准的支持。",
  dumontWelcomeMessageBusiness:
    "您好，{{userName}}，我是 Dumont 商务助手！💼 我专注于销售和报价。我可以帮助您创建精准的货运报价、管理客户关系，并更快地完成交易。今天我能为您做什么？",
  dumontWelcomeMessageOperations:
    "您好，{{userName}}，我是 Dumont 运营助手！📊 我是您的运营专家。我可以帮助您跟踪货运、监控交付、管理作业，并确保物流运营顺畅。您需要什么帮助？",
  dumontWelcomeMessageWarehousing:
    "您好，{{userName}}，我是 Dumont 仓储助手！🏭 我专注于库存和仓库运营。我可以帮助您管理库存水平、跟踪库存、协调仓储，并优化仓库效率。我能为您做什么？",
  // Dumont Fullscreen Sidebar
  dumontSearchPlaceholder: "搜索聊天、代理、历史记录…",
  dumontNewChat: "新建聊天",
  dumontWhatCanIHelpYouWith: "我能帮您做什么？",
  dumontOptimizeLogisticsOperations: "优化我的物流运营",
  dumontOptimizeLogisticsOperationsDesc:
    "获取个性化建议以提高效率并降低成本",
  dumontTrackShipmentStatus: "跟踪运输状态",
  dumontTrackShipmentStatusDesc: "获取运输件和交付估算的实时更新",
  dumontCalculateShippingCosts: "计算运输费用",
  dumontCalculateShippingCostsDesc:
    "估算不同运输方式和目的地的费用",
  dumontFindWarehouseLocations: "查找仓库位置",
  dumontFindWarehouseLocationsDesc:
    "为您的配送网络找到最优仓库位置",
  dumontManageInventoryLevels: "管理库存水平",
  dumontManageInventoryLevelsDesc: "获取库存优化和库存管理的洞察",
  dumontScheduleDeliveries: "安排送货",
  dumontScheduleDeliveriesDesc: "规划并优化送货路线以实现最大效率",
  dumontHowCanIHelpYou: "我能为您做什么？",
  invalidFileType: "无效的文件类型",
  uploadFailed: "上传失败",
  tooManyFiles: "文件过多",
  filesExceedSizeLimit: "文件超过大小限制",
  allFilesUploadedSuccessfully: "所有文件上传成功",
  moreBranches: "更多分支机构",
  maximum10FilesPerUpload: "每次最多上传 10 个文件。",
  generate: "生成",
  onCSVWeHaveFoundSomeErrors:
    "在 <strong>{{csvFileName}}</strong> CSV 中，我们发现了一些错误。请调整这些行以继续：",
  weReSecurelyLoadingYourDataIntoShipeeziSCertifiedFramework:
    "我们正在将您的数据安全地加载到 Shipeezi 的认证框架中。",
  weFoundSomeIssuesInYourCSV:
    '我们在您的 "{{csvFileName}}" 中发现了一些问题。请在继续之前修复这些行：',
  needHelp: "需要帮助？",
  forTheCorrectFormat: "了解正确的格式。",
  noScreenshotsCaptured: "未捕获截图",
  noParticipantsAvailable: "无可用参与者",
  companySlug: "公司标识",
  aUniqueIDUsedToIdentifyThisOrganization: "用于识别此组织的唯一 ID",
  thisSubdomainIsNotAvailablePleaseChooseADifferentOne:
    "此子域名不可用，请选择其他子域名。",
  maximum10FilesPerUpload: "每次最多上传 10 个文件。",
  fileIsTooBig: "文件太大。最大文件大小为 25 MB",
  multiFactorAuthentication: "多因素认证",
  mfaMultiFactorAuthentication: "多因素认证",
  configureMfaSettingsPerGroup: "为每个群组配置 MFA 设置",
  mfaSettings: "MFA 设置",
  enableMfa: "启用 MFA",
  mfaEnabled: "MFA 已启用",
  mfaDisabled: "MFA 已禁用",
  authenticationMethod: "认证方式",
  selectMethod: "选择方式",
  environments: "环境",
  enabledEnvironments: "已启用的环境",
  web: "Web",
  operationsApp: "运营 App",
  salesApp: "销售 App",
  savingMfaSettings: "正在保存 MFA 设置…",
  mfaSettingsUpdated: "MFA 设置更新成功",
  errorUpdatingMfaSettings: "更新 MFA 设置时出错",
  noGroupsFound: "未找到群组",
  mfaVerificationTitle: "输入验证码",
  mfaVerificationDescription: "验证码已发送至：",
  mfaVerificationCode: "验证码",
  verify: "验证",
  resendCode: "重新发送验证码",
  resendViaEmail: "通过邮件重新发送",
  resendViaSms: "通过 SMS 重新发送",
  mfaCodeResent: "验证码重新发送成功",
  errorResendingCode: "重新发送验证码时出错，请重试。",
  invalidCode: "无效的验证码，请重试。",
  codeExpired: "验证码已过期",
  expiresIn: "到期时间",
  email: "电子邮件",
  sms: "SMS",
  smsRequiresPhoneNumber: "SMS 需要手机号码",
  activeLoginSessions: "活跃的登录会话",
  operating_system: "操作系统",
  application: "应用程序",
  shipeezi_platform: "Shipeezi 平台",
  ip_address: "IP 地址",
  last_active_date: "最后活跃",
  maximum10FilesPerUpload: "每次最多上传 10 个文件。",
  youHaveToSelectAtLeastOnePlatform: "至少需要选择一个平台",
  prohibitSimultaneousLogin: "禁止同时登录",
  prohibitSimultaneousLoginDescription:
    "防止用户同时在多个设备或平台上登录",
  applyToPlatforms: "应用于平台",
  selectEquipmentType: "选择设备类型",
  infoMessageEquipmentTypeFilterTitle: "此筛选条件为可选。",
  infoMessageEquipmentTypeFilterNoSelection: "未选择 → 报告包含所有设备类型。",
  infoMessageEquipmentTypeFilterSpecificType:
    "已选择特定类型 → 报告仅包含该类型的任务。",
  infoMessageEquipmentTypeFilterNoTasks:
    "所选类型无任务 → 报告无结果显示。",
  navigation: "导航",
  defaultTemplate: "默认模板",
  originFile: "源文件",
  templateContent: "模板内容",
  onboardingTrigger: "入职引导",
  signupTrigger: "注册",
  offboarding: "离职",
  sendViaVideoSurveyLink: "通过视频调查链接发送",
  sendANewInvitationToTheScheduleVideoSurvey: "向已安排的视频调查发送新邀请",
  thereIsNoActiveVideoSurvey: "暂无活跃的视频调查。",
  videoSurveyLinkSentToCustomer: "视频调查链接已发送给客户",
  videoSurveyLinkSendFailed: "视频调查链接发送失败",
  plainText: "纯文本",
  header: "页眉",
  copyrightText: "版权文本",
  shipeeziBranding: "Shipeezi 品牌设置",
  scheduleSend: "定时发送",
  sendDate: "发送日期",
  sendTime: "发送时间",
  selectAnUser: "选择用户",
  currentShipByDate: "当前发货日期",
  originalShipByDate: "原始发货日期",
  branding: "品牌设置",
  legal: "法律",
  localization: "本地化",
  unitSystem: "单位制",
  servicesAndTariffs: "服务和关税",
  dumontYou: "您",
  dumontSending: "发送中…",
  dumontTypeAMessage: "输入消息…",
  dumontThankYou: "谢谢！",
  dumontConnectionError: "联系 Dumont 时出现问题，请稍后重试。",
  dumontUnableToConnect: "无法连接 Dumont。",
  dumontNoMessagesToCopy: "没有可复制的消息",
  dumontConversationCopied: "对话已复制到剪贴板",
  dumontFailedToCopyConversation: "复制对话失败",
  dumontNoMessagesToExport: "没有可导出的消息",
  dumontChatExportedSuccessfully: "聊天导出成功",
  dumontFailedToExportChat: "导出聊天失败",
  dumontNoMessagesToClear: "没有可清除的消息",
  dumontConversationCleared: "对话已清除",
  dumontOpenInNewWindow: "在新窗口中打开 Dumont AI",
  dumontCloseShortcut: "点击或按 ⌘K 关闭 Dumont AI",
  wouldYouLikeToSendAnInviteToAgentName: "您是否要向 {{agentName}} 发送邀请以加入您的 Shipeezi 网络？",
  selectAtLeastOneItem: "请至少选择一项",
  shipmentNotFound: "未找到货运信息",
  expensesRecalculatedSuccessfully: "费用重新计算成功",
  reconnecting: "正在重新连接",
  pleaseSelectAFile: "请选择一个文件！",
  commentsSavedSuccessfully: "评论保存成功",
  couldNotSaveComments: "无法保存评论",
  anErrorOccurred: "发生错误",
  unknownError: "未知错误",
  newNotification: "新通知",
  externalAgentAssignmentInfo:
    "您已被分配给一位外部代理，该代理将收到一封电子邮件邀请以接受或拒绝该分配。如果没有回复，系统将在三天内发送提醒邮件。如果代理在此期间内未回复，任务将被自动取消。",
  page: "页面",
  originCriterion: "原产地标准",
  originCriterionMustBeWOrP: "原产地标准必须为 'W' 或 'P'",
  uploadPDF: "上传 PDF",
  addManualItems: "添加手动项目",
  editManualItems: "编辑手动项目",
  editInventory: "编辑库存",
  describeEachBingoItem: "请在下方为每个项目输入描述。添加大量项目时请使用分页功能。",
  createInventory: "创建库存",
  editInventoryManualTitle: "编辑库存（手动项目）",
  customerSurvey: "客户调查（出站）",
  statementOfAsp: "附属服务执行声明",
  downloadCsv: "下载 CSV",
  associateShipmentToOrder: "将货运关联到订单",
  shipmentSavedAsDraft: "货运已保存为草稿",
  shipmentCreationFailedAtIndex: "无法创建第 {{current}} 个（共 {{total}} 个）货运。之前的货运可能已保存。请检查订单或手动添加剩余货运。",
  scacCodePlaceholder: "搜索或输入 SCAC 代码",
  grade: "等级",
  gradePlaceholder: "例如 A、B、C",
  scacInformation: "SCAC 信息",
  scacDescription: "SCAC 描述",
  claimsPhone: "理赔电话",
  claimsEmail: "理赔邮箱",
  itemIsTv: "物品是电视",
  screenSize: "屏幕尺寸",
  screenType: "屏幕类型",
  remoteControl: "遥控器",
  powerCord: "电源线",
  tvBaseStand: "电视底座/支架",
  baseStandHardware: "底座/支架硬件",
  tv: "电视",
  vehicle: "车辆",
  serialNumberVin: "序列号 / VIN",
  odometerMiles: "里程表读数",
  km: "公里",
  accessoriesIncluded: "包含配件",
  gasTankEmpty: "油箱已空",
  fuelSystemPurged: "燃油系统已清洗",
  batteryDisconnected: "电池已断开",
  preApprovals: "预审批",
  noPreApprovals: "无预审批",
  approvalItem: "审批项目",
  goShareId: "Go Share ID",
  count: "数量",
  storageInTransitOriginSit: "运输中存储（始发 SIT）",
  sitInDate: "SIT 入库日期",
  sitOutDate: "SIT 出库日期",
  sitOutDateMustBeAfterSitInDate: "SIT 出库日期必须晚于 SIT 入库日期。",
  sitNumber: "SIT 编号",
  baseCode: "基地代码",
  baseDescription: "基地描述",
  areaCode: "区域代码",
  areaDescription: "区域描述",
  zipCode: "邮政编码",
  itemIsVehicle: "物品是车辆",
  vehicleType: "车辆类型",
  motorcycle: "摩托车",
  car: "汽车",
  boat: "船",
  startingNumber: "起始编号",
  decreaseStartingNumber: "减少起始编号",
  increaseStartingNumber: "增加起始编号",
  editDescriptionForItem: "编辑物品描述",
  itemDescriptionDefaultPlaceholder: "适用于此库存中的所有物品",
  defaultManualInventoryItemDescription: "见库存",
  customerSignature: "客户签名",
  removalistName: "搬运工姓名",
  removalistSignature: "搬运工签名",
  removeFile: "移除文件",
  removeInventoryPdf: "移除库存 PDF",
  removeInventoryPdfConfirmation: "库存 PDF 将从此订单中移除。已添加的物品不会被删除。继续？",
  viewInventory: "查看库存",
  noDocumentsHaveBeenAddedYet: "尚未添加任何文档",
  askEnzo: "询问 Enzo",
  enzoHelpDocumentation: "帮助和文档",
  enzoSendFeedback: "发送反馈",
  enzoContactSupport: "联系支持",
  enzoLearnHowToUseEnzo: "了解如何有效使用 Enzo",
  enzoHelpUsImproveEnzo: "帮助我们改进 Enzo",
  enzoGetHelpFromTeam: "获取我们团队的帮助",
  enzoQuickActions: "快捷操作",
  enzoContactOurSupport: "联系我们的支持",
  enzoGetHelpWithIssues: "获取任何问题的帮助",
  enzoSendUsYourFeedback: "向我们发送您的反馈",
  enzoShareThoughtsAndSuggestions: "分享您的想法和建议",
  enzoCommonQuestions: "常见问题",
  enzoHowToCreateCustomAgent: "如何创建自定义代理？",
  enzoHowToCreateCustomAgentAnswer: "要创建自定义代理，请导航到代理部分并点击「创建新代理」按钮。然后您可以根据需要配置代理的功能和设置。",
  enzoWhatCanEnzoHelp: "Enzo 可以帮我什么？",
  enzoWhatCanEnzoHelpAnswer: "Enzo 是您的物流和搬迁专业 AI 助手。我可以帮助您进行调度规划、订单管理、路线优化以及回答有关您运营的问题。",
  enzoHowToAccessChatHistory: "如何查看我的聊天记录？",
  enzoHowToAccessChatHistoryAnswer: "点击侧边栏中的历史记录图标，查看您与 Enzo 的所有过去对话。您可以搜索历史记录并恢复任何之前的对话。",
  enzoCanCustomizeAgentCapabilities: "我可以自定义代理功能吗？",
  enzoResources: "资源",
  enzoKnowledgeBase: "知识库",
  enzoCompleteGuidesAndTutorials: "完整的指南和教程",
  enzoSelectAnOption: "请选择一个选项",
  enzoFeedbackHelpsImprove: "您的反馈帮助我们改进 Enzo",
  enzoIssueType: "问题类型",
  enzoSubject: "主题",
  enzoBriefDescriptionOfIssue: "简要描述您的问题",
  enzoMessage: "消息",
  enzoPleaseDescribeIssueDetail: "请详细描述您的问题...",
  enzoIncludeErrorMessages: "包括任何错误消息或重现问题的步骤",
  enzoGotIt: "知道了",
  enzoCancel: "取消",
  enzoSendFeedbackButton: "发送反馈",
  enzoSendMessage: "发送消息",
  enzoSupportRequestSentSuccessfully: "您的支持请求已成功发送。我们的团队将在 24 小时内回复。",
  enzoFeedbackSentSuccessfully: "您的反馈已成功发送。感谢您的意见！",
  enzoSearchPlaceholder: "搜索对话、代理、历史记录...",
  enzoNavigation: "导航",
  enzoNewChat: "新对话",
  enzoChats: "对话",
  enzoNoChatsFound: "未找到对话",
  enzoNoRecentChats: "没有最近的对话",
  enzoAgents: "代理",
  enzoNoAgentsFound: "未找到代理",
  enzoReturnToShipeezi: "返回 Shipeezi",
  enzoHelp: "帮助",
  enzoWelcomeMessage: "你好，{{userName}}，我是 Enzo，您的物流和搬迁专业 AI 助手。旨在简化复杂的工作流程，我不断学习以为您的业务提供更快、更智能、更准确的支持。",
  enzoWelcomeMessageBusiness: "你好，{{userName}}，我是 Enzo 商务助手！💼 我专注于销售和报价。我可以帮助您创建准确的运费报价、管理客户关系并更快地完成交易。今天我能帮您什么？",
  enzoWelcomeMessageOperations: "你好，{{userName}}，我是 Enzo 运营助手！📊 我是您的运营专家。我可以帮助您追踪货运、监控交付、管理作业并确保物流运营顺畅。您需要什么帮助？",
  enzoWelcomeMessageWarehousing: "你好，{{userName}}，我是 Enzo 仓储助手！🏭 我专注于库存和仓库运营。我可以帮助您管理库存水平、追踪库存、协调存储并优化仓库效率。我能帮您什么？",
  enzoDispatchQuickActions: "调度快捷操作",
  enzoHistory: "历史记录",
  enzoConversationHistory: "对话历史",
  enzoNoConversationsFound: "未找到对话",
  enzoNoConversationHistory: "没有对话历史",
  enzoTryDifferentSearchTerm: "尝试不同的搜索词",
  enzoStartNewConversation: "开始新对话即可在此处查看",
  enzoFileTooLarge: "文件太大。最大大小为 10MB。",
  enzoUnsupportedFileType: "不支持的文件类型。请选择 TXT、PDF 或 DOC/DOCX 文件。",
  enzoDocumentProcessing: "PDF/DOC 处理即将推出。请暂时使用 TXT 文件。",
  enzoFileProcessingError: "处理文件时出错。请重试。",
  enzoAskEnzo: "问 Enzo...",
  enzoAskEnzoAnything: "向 Enzo 提任何问题",
  enzoUpload: "上传",
  enzoUsesAI: "Enzo 使用人工智能。请审查回复。",
  enzoCopyConversation: "复制对话",
  enzoExportChat: "导出对话",
  enzoClearConversation: "清除对话",
  enzoLoadingAgents: "正在加载代理...",
  enzoAgentsTitle: "Enzo 代理",
  enzoCreateAgent: "创建代理",
  enzoSearchAgents: "搜索代理...",
  enzoNoAgentsAvailable: "没有可用的代理",
  enzoAgentsAvailableSoon: "代理即将推出",
  enzoComingSoon: "即将推出...",
  enzoBusinessAssistant: "商务助手",
  enzoBusinessAssistantDesc: "专注于销售和报价",
  enzoOperationsAssistant: "运营助手",
  enzoOperationsAssistantDesc: "您的运营专家",
  enzoWarehousingAssistant: "仓储助手",
  enzoWarehousingAssistantDesc: "库存和仓库运营专家",
  enzoCanCustomizeAgentCapabilitiesAnswer: "是的！每个代理都可以定制以适应您的特定工作流程。您可以调整其功能、设置特定参数并配置其可以访问的数据源。",
  enzoFeedbackType: "反馈类型",
  enzoYourFeedback: "您的反馈",
  enzoTellUsWhatYouThink: "告诉我们您的想法...",
  enzoPleaseSelectTextFile: "请选择文本文件 (.txt)",
  enzoDocumentAttached: "文档已附加",
  enzoRemoveDocument: "移除文档",
  enzoDefaultResponse: "感谢您的联系！我正在分析您的请求，将为您提供最佳解决方案。",
  enzoSales: "销售",
  enzoOperations: "运营",
  enzoLogistics: "物流",
  enzoDispatchShowTodayOrders: "显示今天的调度订单",
  enzoDispatchShowTodayOrdersDesc: "获取所有计划今天调度的订单摘要",
  enzoDispatchFindCustomer: "按客户名称查找订单",
  enzoDispatchFindCustomerDesc: "使用客户信息搜索特定订单",
  enzoDispatchTrackStatus: "追踪订单状态",
  enzoDispatchTrackStatusDesc: "检查系统中订单的当前状态",
  enzoDispatchOptimizeRoutes: "优化配送路线",
  enzoDispatchOptimizeRoutesDesc: "获取最高效的配送路线建议",
  enzoWhatCanIHelpYouWith: "我能帮您什么？",
  enzoOptimizeLogisticsOperations: "优化我的物流运营",
  enzoOptimizeLogisticsOperationsDesc: "获取个性化建议以提高效率和降低成本",
  enzoTrackShipmentStatus: "追踪货运状态",
  enzoTrackShipmentStatusDesc: "获取您的货运和交付估计的实时更新",
  enzoCalculateShippingCosts: "计算运费",
  enzoCalculateShippingCostsDesc: "估算不同运输方式和目的地的费用",
  enzoFindWarehouseLocations: "查找仓库位置",
  enzoFindWarehouseLocationsDesc: "为您的分销网络发现最佳仓库位置",
  enzoManageInventoryLevels: "管理库存水平",
  enzoManageInventoryLevelsDesc: "获取库存优化和库存管理的洞察",
  enzoScheduleDeliveries: "安排配送",
  enzoScheduleDeliveriesDesc: "规划和优化配送路线以实现最大效率",
  enzoHowCanIHelpYou: "我能帮您什么？",
  fileSizeIsTooLarge: "文件大于 2MB",
  propertyDamageReport: "财产损坏报告",
  optional: "可选",
  photoRequiredAtUpliftCompletion: "提货完成时需要拍照",
  customerPhoneNumber: "客户电话号码",
  alternativePhone: "备用电话",
  alternativeEmail: "备用邮箱",
  mailingAddress: "邮寄地址",
  customerFields: "客户字段",
  requireCustomerInformationFields: "要求客户信息字段",
  customerFieldsWillBeRequired: "客户字段将为必填",
  selectMadatory: "选择必填项",
  military: "军事",
  templateType: "模板类型",
  assignedTemplate: "分配的模板",
  packingList: "装箱单",
  billOfLading: "提单",
  inventoryReport: "库存报告",
  shippingManifest: "运输清单",
  deliveryReceipt: "交货收据",
  customsDeclaration: "海关申报",
  saveTemplates: "保存模板",
  shipeeziDefault2: "Shipeezi 默认",
  clientCustomTemplate: "客户自定义模板",
  customTemplate: "自定义模板",
  reportTemplates: "报告模板",
  defineWhichTemplateEachReportUses: "定义每个报告使用哪个模板。模板按公司保存，仅对军事账户可见。确定每个报告是使用 Shipeezi 默认模板还是客户提供的自定义模板。",
  accessToThisSectionIsRestrictedByPermissionLevel: "此部分的访问受权限级别限制。更改按公司保存，对商业账户隐藏。",
  customerPortalAddress: "客户门户地址",
  definesLinkYourCustomerWillUse: "定义您的客户将使用的链接来追踪订单和查看货运详情",
  dateFormat: "日期格式",
  timeFormat: "时间格式",
  accountPreferences: "账户偏好设置",
  addPreApprovalItem: "添加预审批项目",
  removePreApprovalItem: "移除项目",
  pleaseFillAllPreApprovalFields: "请为每行填写预审批描述。",
  unitOfMeasure: "计量单位",
  boxes: "箱",
  pairs: "双",
  sets: "套",
  pallets: "托盘",
  customerLogo: "客户标志",
  removeShipmentFromOrder: "从订单中移除货运",
  thisShipmentHasNoOtherOrdersAssociated: "此货运没有关联的其他订单。您想如何处理？",
  revertToDraft: "恢复为草稿",
  leaveAsDraft: "保留为草稿",
  cancelShipment: "取消货运",
  MB: "MB",
  "Search...": "搜索...",
  activate: "激活",
  inactivate: "停用",
  cancelButton: "取消",
  cereLifeLocalAmount: "CereLife 本地金额",
  commercial: "商业",
  confirmDelete: "删除",
  confirmation: "确认",
  containerId: "集装箱 ID",
  createANewPort: "创建新港口",
  customerLastName: "客户姓氏",
  customerPhone: "客户电话",
  dateCannotBeInThePast: "日期不能是过去的日期",
  decimalPlaces: "小数位数",
  deleteData: "删除数据",
  deletePlaceholderTask: "删除占位任务",
  editPort: "编辑港口",
  emailIsInvalid: "电子邮件无效",
  errorFetchingTriggers: "获取触发器时出错",
  errorLoadingTemplates: "加载模板时出错",
  errorReadingFile: "读取文件时出错",
  errorUpdatingTemplate: "更新模板时出错",
  errorUploadingFile: "上传文件时出错",
  errorValidatingTemplateName: "验证模板名称时出错",
  inAMoment: "稍后",
  invalidDateTime: "日期和时间无效",
  invalidTimeFormat: "时间格式无效",
  inviteAgent: "邀请代理",
  invoicedAmount: "已开票金额",
  iso174511Description: "使用 Shipeezi 经 ISO17451-1:2016 认证的默认库存清单。您可以随时更新或扩展。",
  itShouldBeAtLeastOneBranch: "至少应有一个分支机构",
  itShouldHaveLeastOneBranch: "您必须至少有一个分支机构",
  "label.item.packaging": "物品包装",
  last: "最近",
  loadingLocations: "正在加载位置...",
  militaryReportsDescription: "为军事账户配置报告模板。",
  noInformationToBeShwon: "没有可显示的信息",
  noLinkedAutomationsFound: "未找到关联的自动化",
  noReports: "无报告",
  only: "仅",
  operationFailed: "操作失败",
  origins: "来源",
  picture: "图片",
  pictures: "图片",
  pushCharacterLimitExceeded: "推送通知字符数超出限制",
  scheduledTimeCannotBeInThePast: "计划时间不能是过去的时间",
  seconds: "秒",
  selectAContainerNumber: "选择集装箱编号",
  selectAtLeastOneTarget: "请至少选择一个目标",
  selectOptions: "选择选项",
  sending: "发送中",
  shipeeziDefaultTemplate: "Shipeezi 默认模板",
  shipmentInformation: "货运信息",
  smsCharacterLimitExceeded: "短信字符数超出限制",
  someFilesFailedToUpload: "部分文件上传失败",
  taskUnpublishedCannotBeEdited: "未发布的任务无法编辑",
  theLimitOfLinesIs: "行数限制为",
  thisCustomerDoesNotHaveAnEmailToSendInvitation: "该客户没有可发送邀请的电子邮件",
  thisFieldIsNumber: "此字段必须为数字",
  uploadCategories: "上传类别",
  uploadCategoriesDescription: "上传您的类别列表以开始。",
  uploadCentreDescription: "您可以在此上传自己的文件（如库存、员工或服务列表），或使用 Shipeezi 默认列表。您可以随时更新。",
  useShipeeziSDefaultListDescription: "使用基于全球 ISO17451-1:2016 标准的预配置列表快速开始。您可以随时更新或扩展。",
  url: "URL",
  v: "V",
  youCannotInviteInactiveCustomers: "无法邀请未激活的客户",
  youDontHavePermissionToAccessShipmentData: "您无权访问货运数据",
  youHaveToAddAtLeastOneOrder: "您必须至少添加一个订单",
  youMustEnterAAgentId: "您必须输入代理 ID",
  youMustHaveAtLeastOneContact: "您必须至少有一个联系人",
  youMustHaveAtLeastOnePrimaryContact: "您必须至少有一个主要联系人",
  yourPasswordMustBeAtLeast6CharactersLong: "密码长度至少为 6 个字符",
  memberCode: "成员代码",
  uploadOwnListDescription: "导入您自己的数据，从一开始就定制 Shipeezi。",
  downloadCsvTemplate: "下载 CSV 模板",
};
